import './assets/index.3ba50d36.css';
import { PodcastArtwork as ta } from "@simplecast/styles";
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, us = { exports: {} };
/*! Player.js - v0.1.0 - 2017-10-24
* http://github.com/embedly/player.js
* Copyright (c) 2017 Embedly; Licensed BSD */
(function(t) {
  (function(e, r) {
    var s = {};
    s.DEBUG = !1, s.VERSION = "0.0.11", s.CONTEXT = "player.js", s.POST_MESSAGE = !!e.postMessage, s.origin = function(o) {
      return o.substr(0, 2) === "//" && (o = e.location.protocol + o), o.split("/").slice(0, 3).join("/");
    }, s.addEvent = function(o, n, c) {
      !o || (o.addEventListener ? o.addEventListener(n, c, !1) : o.attachEvent ? o.attachEvent("on" + n, c) : o["on" + n] = c);
    }, s.log = function() {
      s.log.history = s.log.history || [], s.log.history.push(arguments), e.console && s.DEBUG && e.console.log(Array.prototype.slice.call(arguments));
    }, s.isString = function(o) {
      return Object.prototype.toString.call(o) === "[object String]";
    }, s.isObject = function(o) {
      return Object.prototype.toString.call(o) === "[object Object]";
    }, s.isArray = function(o) {
      return Object.prototype.toString.call(o) === "[object Array]";
    }, s.isNone = function(o) {
      return o == null;
    }, s.has = function(o, n) {
      return Object.prototype.hasOwnProperty.call(o, n);
    }, s.indexOf = function(o, n) {
      if (o == null)
        return -1;
      var c = 0, u = o.length;
      if (Array.prototype.IndexOf && o.indexOf === Array.prototype.IndexOf)
        return o.indexOf(n);
      for (; c < u; c++)
        if (o[c] === n)
          return c;
      return -1;
    }, s.assert = function(o, n) {
      if (!o)
        throw n || "Player.js Assert Failed";
    }, s.Keeper = function() {
      this.init();
    }, s.Keeper.prototype.init = function() {
      this.data = {};
    }, s.Keeper.prototype.getUUID = function() {
      return "listener-xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(o) {
        var n = Math.random() * 16 | 0, c = o === "x" ? n : n & 3 | 8;
        return c.toString(16);
      });
    }, s.Keeper.prototype.has = function(o, n) {
      if (!this.data.hasOwnProperty(o))
        return !1;
      if (s.isNone(n))
        return !0;
      for (var c = this.data[o], u = 0; u < c.length; u++)
        if (c[u].id === n)
          return !0;
      return !1;
    }, s.Keeper.prototype.add = function(o, n, c, u, A) {
      var d = {
        id: o,
        event: n,
        cb: c,
        ctx: u,
        one: A
      };
      this.has(n) ? this.data[n].push(d) : this.data[n] = [d];
    }, s.Keeper.prototype.execute = function(o, n, c, u) {
      if (!this.has(o, n))
        return !1;
      for (var A = [], d = [], h = 0; h < this.data[o].length; h++) {
        var C = this.data[o][h];
        s.isNone(n) || !s.isNone(n) && C.id === n ? (d.push({
          cb: C.cb,
          ctx: C.ctx ? C.ctx : u,
          data: c
        }), C.one === !1 && A.push(C)) : A.push(C);
      }
      A.length === 0 ? delete this.data[o] : this.data[o] = A;
      for (var S = 0; S < d.length; S++) {
        var x = d[S];
        x.cb.call(x.ctx, x.data);
      }
    }, s.Keeper.prototype.on = function(o, n, c, u) {
      this.add(o, n, c, u, !1);
    }, s.Keeper.prototype.one = function(o, n, c, u) {
      this.add(o, n, c, u, !0);
    }, s.Keeper.prototype.off = function(o, n) {
      var c = [];
      if (!this.data.hasOwnProperty(o))
        return c;
      for (var u = [], A = 0; A < this.data[o].length; A++) {
        var d = this.data[o][A];
        !s.isNone(n) && d.cb !== n ? u.push(d) : s.isNone(d.id) || c.push(d.id);
      }
      return u.length === 0 ? delete this.data[o] : this.data[o] = u, c;
    }, s.Player = function(o, n) {
      if (!(this instanceof s.Player))
        return new s.Player(o, n);
      this.init(o, n);
    }, s.EVENTS = {
      READY: "ready",
      PLAY: "play",
      PAUSE: "pause",
      ENDED: "ended",
      TIMEUPDATE: "timeupdate",
      PROGRESS: "progress",
      ERROR: "error"
    }, s.EVENTS.all = function() {
      var o = [];
      for (var n in s.EVENTS)
        s.has(s.EVENTS, n) && s.isString(s.EVENTS[n]) && o.push(s.EVENTS[n]);
      return o;
    }, s.METHODS = {
      PLAY: "play",
      PAUSE: "pause",
      GETPAUSED: "getPaused",
      MUTE: "mute",
      UNMUTE: "unmute",
      GETMUTED: "getMuted",
      SETVOLUME: "setVolume",
      GETVOLUME: "getVolume",
      GETDURATION: "getDuration",
      SETCURRENTTIME: "setCurrentTime",
      GETCURRENTTIME: "getCurrentTime",
      SETLOOP: "setLoop",
      GETLOOP: "getLoop",
      REMOVEEVENTLISTENER: "removeEventListener",
      ADDEVENTLISTENER: "addEventListener"
    }, s.METHODS.all = function() {
      var o = [];
      for (var n in s.METHODS)
        s.has(s.METHODS, n) && s.isString(s.METHODS[n]) && o.push(s.METHODS[n]);
      return o;
    }, s.READIED = [], s.Player.prototype.init = function(o, n) {
      var c = this;
      s.isString(o) && (o = r.getElementById(o)), this.elem = o, s.assert(
        o.nodeName === "IFRAME",
        'playerjs.Player constructor requires an Iframe, got "' + o.nodeName + '"'
      ), s.assert(
        o.src,
        "playerjs.Player constructor requires a Iframe with a 'src' attribute."
      ), this.origin = s.origin(o.src), this.keeper = new s.Keeper(), this.isReady = !1, this.queue = [], this.events = s.EVENTS.all(), this.methods = s.METHODS.all(), s.POST_MESSAGE ? s.addEvent(e, "message", function(u) {
        c.receive(u);
      }) : s.log("Post Message is not Available."), s.indexOf(s.READIED, o.src) > -1 ? c.loaded = !0 : this.elem.onload = function() {
        c.loaded = !0;
      };
    }, s.Player.prototype.send = function(o, n, c) {
      if (o.context = s.CONTEXT, o.version = s.VERSION, n) {
        var u = this.keeper.getUUID();
        o.listener = u, this.keeper.one(u, o.method, n, c);
      }
      return !this.isReady && o.value !== "ready" ? (s.log("Player.queue", o), this.queue.push(o), !1) : (s.log("Player.send", o, this.origin), this.loaded === !0 && this.elem.contentWindow.postMessage(JSON.stringify(o), this.origin), !0);
    }, s.Player.prototype.receive = function(o) {
      if (s.log("Player.receive", o), o.origin !== this.origin)
        return !1;
      var n;
      try {
        n = JSON.parse(o.data);
      } catch {
        return !1;
      }
      if (n.context !== s.CONTEXT)
        return !1;
      n.event === "ready" && n.value && n.value.src === this.elem.src && this.ready(n), this.keeper.has(n.event, n.listener) && this.keeper.execute(n.event, n.listener, n.value, this);
    }, s.Player.prototype.ready = function(o) {
      if (this.isReady === !0)
        return !1;
      o.value.events && (this.events = o.value.events), o.value.methods && (this.methods = o.value.methods), this.isReady = !0, this.loaded = !0;
      for (var n = 0; n < this.queue.length; n++) {
        var c = this.queue[n];
        s.log("Player.dequeue", c), o.event === "ready" && this.keeper.execute(c.event, c.listener, !0, this), this.send(c);
      }
      this.queue = [];
    }, s.Player.prototype.on = function(o, n, c) {
      var u = this.keeper.getUUID();
      return o === "ready" ? this.keeper.one(u, o, n, c) : this.keeper.on(u, o, n, c), this.send({
        method: "addEventListener",
        value: o,
        listener: u
      }), !0;
    }, s.Player.prototype.off = function(o, n) {
      var c = this.keeper.off(o, n);
      if (s.log("Player.off", c), c.length > 0)
        for (var u in c)
          return this.send({
            method: "removeEventListener",
            value: o,
            listener: c[u]
          }), !0;
      return !1;
    }, s.Player.prototype.supports = function(o, n) {
      s.assert(
        s.indexOf(["method", "event"], o) > -1,
        'evtOrMethod needs to be either "event" or "method" got ' + o
      ), n = s.isArray(n) ? n : [n];
      for (var c = o === "event" ? this.events : this.methods, u = 0; u < n.length; u++)
        if (s.indexOf(c, n[u]) === -1)
          return !1;
      return !0;
    };
    function i(o) {
      return function() {
        var n = {
          method: o
        }, c = Array.prototype.slice.call(arguments);
        /^get/.test(o) ? (s.assert(c.length > 0, "Get methods require a callback."), c.unshift(n)) : (/^set/.test(o) && (s.assert(c.length !== 0, "Set methods require a value."), n.value = c[0]), c = [n]), this.send.apply(this, c);
      };
    }
    for (var a = 0, l = s.METHODS.all().length; a < l; a++) {
      var f = s.METHODS.all()[a];
      s.Player.prototype.hasOwnProperty(f) || (s.Player.prototype[f] = i(f));
    }
    s.addEvent(e, "message", function(o) {
      var n;
      try {
        n = JSON.parse(o.data);
      } catch {
        return !1;
      }
      if (n.context !== s.CONTEXT)
        return !1;
      n.event === "ready" && n.value && n.value.src && s.READIED.push(n.value.src);
    }), s.Receiver = function(o, n) {
      this.init(o, n);
    }, s.Receiver.prototype.init = function(o, n) {
      var c = this;
      this.isReady = !1, this.origin = s.origin(r.referrer), this.methods = {}, this.supported = {
        events: o || s.EVENTS.all(),
        methods: n || s.METHODS.all()
      }, this.eventListeners = {}, this.reject = !(e.self !== e.top && s.POST_MESSAGE), this.reject || s.addEvent(e, "message", function(u) {
        c.receive(u);
      });
    }, s.Receiver.prototype.receive = function(o) {
      if (o.origin !== this.origin)
        return !1;
      var n = {};
      if (s.isObject(o.data))
        n = o.data;
      else
        try {
          n = e.JSON.parse(o.data);
        } catch (A) {
          s.log("JSON Parse Error", A);
        }
      if (s.log("Receiver.receive", o, n), !n.method || n.context !== s.CONTEXT)
        return !1;
      if (s.indexOf(s.METHODS.all(), n.method) === -1)
        return this.emit("error", {
          code: 2,
          msg: 'Invalid Method "' + n.method + '"'
        }), !1;
      var c = s.isNone(n.listener) ? null : n.listener;
      if (n.method === "addEventListener")
        this.eventListeners.hasOwnProperty(n.value) ? s.indexOf(this.eventListeners[n.value], c) === -1 && this.eventListeners[n.value].push(c) : this.eventListeners[n.value] = [c], n.value === "ready" && this.isReady && this.ready();
      else if (n.method === "removeEventListener") {
        if (this.eventListeners.hasOwnProperty(n.value)) {
          var u = s.indexOf(this.eventListeners[n.value], c);
          u > -1 && this.eventListeners[n.value].splice(u, 1), this.eventListeners[n.value].length === 0 && delete this.eventListeners[n.value];
        }
      } else
        this.get(n.method, n.value, c);
    }, s.Receiver.prototype.get = function(o, n, c) {
      var u = this;
      if (!this.methods.hasOwnProperty(o))
        return this.emit("error", {
          code: 3,
          msg: 'Method Not Supported"' + o + '"'
        }), !1;
      var A = this.methods[o];
      if (o.substr(0, 3) === "get") {
        var d = function(h) {
          u.send(o, h, c);
        };
        A.call(this, d);
      } else
        A.call(this, n);
    }, s.Receiver.prototype.on = function(o, n) {
      this.methods[o] = n;
    }, s.Receiver.prototype.send = function(o, n, c) {
      if (s.log("Receiver.send", o, n, c), this.reject)
        return s.log("Receiver.send.reject", o, n, c), !1;
      var u = {
        context: s.CONTEXT,
        version: s.VERSION,
        event: o
      };
      s.isNone(n) || (u.value = n), s.isNone(c) || (u.listener = c);
      var A = JSON.stringify(u);
      e.parent.postMessage(A, this.origin === "" ? "*" : this.origin);
    }, s.Receiver.prototype.emit = function(o, n) {
      if (!this.eventListeners.hasOwnProperty(o))
        return !1;
      s.log("Instance.emit", o, n, this.eventListeners[o]);
      for (var c = 0; c < this.eventListeners[o].length; c++) {
        var u = this.eventListeners[o][c];
        this.send(o, n, u);
      }
      return !0;
    }, s.Receiver.prototype.ready = function() {
      s.log("Receiver.ready"), this.isReady = !0;
      var o = {
        src: e.location.toString(),
        events: this.supported.events,
        methods: this.supported.methods
      };
      this.emit("ready", o) || this.send("ready", o);
    }, s.HTML5Adapter = function(o) {
      if (!(this instanceof s.HTML5Adapter))
        return new s.HTML5Adapter(o);
      this.init(o);
    }, s.HTML5Adapter.prototype.init = function(o) {
      s.assert(o, "playerjs.HTML5Adapter requires a video element");
      var n = this.receiver = new s.Receiver();
      o.addEventListener("playing", function() {
        n.emit("play");
      }), o.addEventListener("pause", function() {
        n.emit("pause");
      }), o.addEventListener("ended", function() {
        n.emit("ended");
      }), o.addEventListener("timeupdate", function() {
        n.emit("timeupdate", {
          seconds: o.currentTime,
          duration: o.duration
        });
      }), o.addEventListener("progress", function() {
        n.emit("buffered", {
          percent: o.buffered.length
        });
      }), n.on("play", function() {
        o.play();
      }), n.on("pause", function() {
        o.pause();
      }), n.on("getPaused", function(c) {
        c(o.paused);
      }), n.on("getCurrentTime", function(c) {
        c(o.currentTime);
      }), n.on("setCurrentTime", function(c) {
        o.currentTime = c;
      }), n.on("getDuration", function(c) {
        c(o.duration);
      }), n.on("getVolume", function(c) {
        c(o.volume * 100);
      }), n.on("setVolume", function(c) {
        o.volume = c / 100;
      }), n.on("mute", function() {
        o.muted = !0;
      }), n.on("unmute", function() {
        o.muted = !1;
      }), n.on("getMuted", function(c) {
        c(o.muted);
      }), n.on("getLoop", function(c) {
        c(o.loop);
      }), n.on("setLoop", function(c) {
        o.loop = c;
      });
    }, s.HTML5Adapter.prototype.ready = function() {
      this.receiver.ready();
    }, s.JWPlayerAdapter = function(o) {
      if (!(this instanceof s.JWPlayerAdapter))
        return new s.JWPlayerAdapter(o);
      this.init(o);
    }, s.JWPlayerAdapter.prototype.init = function(o) {
      s.assert(o, "playerjs.JWPlayerAdapter requires a player object");
      var n = this.receiver = new s.Receiver();
      this.looped = !1, o.on("pause", function() {
        n.emit("pause");
      }), o.on("play", function() {
        n.emit("play");
      }), o.on("time", function(u) {
        var A = u.position, d = u.duration;
        if (!A || !d)
          return !1;
        var h = {
          seconds: A,
          duration: d
        };
        n.emit("timeupdate", h);
      });
      var c = this;
      o.on("complete", function() {
        c.looped === !0 ? o.seek(0) : n.emit("ended");
      }), o.on("error", function() {
        n.emit("error");
      }), n.on("play", function() {
        o.play(!0);
      }), n.on("pause", function() {
        o.pause(!0);
      }), n.on("getPaused", function(u) {
        u(o.getState().toLowerCase() !== "PLAYING".toLowerCase());
      }), n.on("getCurrentTime", function(u) {
        u(o.getPosition());
      }), n.on("setCurrentTime", function(u) {
        o.seek(u);
      }), n.on("getDuration", function(u) {
        u(o.getDuration());
      }), n.on("getVolume", function(u) {
        u(o.getVolume());
      }), n.on("setVolume", function(u) {
        o.setVolume(u);
      }), n.on("mute", function() {
        o.setMute(!0);
      }), n.on("unmute", function() {
        o.setMute(!1);
      }), n.on("getMuted", function(u) {
        u(o.getMute() === !0);
      }), n.on("getLoop", function(u) {
        u(this.looped);
      }, this), n.on("setLoop", function(u) {
        this.looped = u;
      }, this);
    }, s.JWPlayerAdapter.prototype.ready = function() {
      this.receiver.ready();
    }, s.MockAdapter = function() {
      if (!(this instanceof s.MockAdapter))
        return new s.MockAdapter();
      this.init();
    }, s.MockAdapter.prototype.init = function() {
      var o = {
        duration: 20,
        currentTime: 0,
        interval: null,
        timeupdate: function() {
        },
        volume: 100,
        mute: !1,
        playing: !1,
        loop: !1,
        play: function() {
          o.interval = setInterval(function() {
            o.currentTime += 0.25, o.timeupdate({
              seconds: o.currentTime,
              duration: o.duration
            });
          }, 250), o.playing = !0;
        },
        pause: function() {
          clearInterval(o.interval), o.playing = !1;
        }
      }, n = this.receiver = new s.Receiver();
      n.on("play", function() {
        var c = this;
        o.play(), this.emit("play"), o.timeupdate = function(u) {
          c.emit("timeupdate", u);
        };
      }), n.on("pause", function() {
        o.pause(), this.emit("pause");
      }), n.on("getPaused", function(c) {
        c(!o.playing);
      }), n.on("getCurrentTime", function(c) {
        c(o.currentTime);
      }), n.on("setCurrentTime", function(c) {
        o.currentTime = c;
      }), n.on("getDuration", function(c) {
        c(o.duration);
      }), n.on("getVolume", function(c) {
        c(o.volume);
      }), n.on("setVolume", function(c) {
        o.volume = c;
      }), n.on("mute", function() {
        o.mute = !0;
      }), n.on("unmute", function() {
        o.mute = !1;
      }), n.on("getMuted", function(c) {
        c(o.mute);
      }), n.on("getLoop", function(c) {
        c(o.loop);
      }), n.on("setLoop", function(c) {
        o.loop = c;
      });
    }, s.MockAdapter.prototype.ready = function() {
      this.receiver.ready();
    }, s.VideoJSAdapter = function(o) {
      if (!(this instanceof s.VideoJSAdapter))
        return new s.VideoJSAdapter(o);
      this.init(o);
    }, s.VideoJSAdapter.prototype.init = function(o) {
      s.assert(o, "playerjs.VideoJSReceiver requires a player object");
      var n = this.receiver = new s.Receiver();
      o.on("pause", function() {
        n.emit("pause");
      }), o.on("play", function() {
        n.emit("play");
      }), o.on("timeupdate", function(c) {
        var u = o.currentTime(), A = o.duration();
        if (!u || !A)
          return !1;
        var d = {
          seconds: u,
          duration: A
        };
        n.emit("timeupdate", d);
      }), o.on("ended", function() {
        n.emit("ended");
      }), o.on("error", function() {
        n.emit("error");
      }), n.on("play", function() {
        o.play();
      }), n.on("pause", function() {
        o.pause();
      }), n.on("getPaused", function(c) {
        c(o.paused());
      }), n.on("getCurrentTime", function(c) {
        c(o.currentTime());
      }), n.on("setCurrentTime", function(c) {
        o.currentTime(c);
      }), n.on("getDuration", function(c) {
        c(o.duration());
      }), n.on("getVolume", function(c) {
        c(o.volume() * 100);
      }), n.on("setVolume", function(c) {
        o.volume(c / 100);
      }), n.on("mute", function() {
        o.volume(0);
      }), n.on("unmute", function() {
        o.volume(1);
      }), n.on("getMuted", function(c) {
        c(o.volume() === 0);
      }), n.on("getLoop", function(c) {
        c(o.loop());
      }), n.on("setLoop", function(c) {
        o.loop(c);
      });
    }, s.VideoJSAdapter.prototype.ready = function() {
      this.receiver.ready();
    }, t.exports ? t.exports = s : e.playerjs = s;
  })(window, document);
})(us);
const ra = us.exports;
function B(t, e, r, s, i, a, l, f) {
  var o = typeof t == "function" ? t.options : t;
  e && (o.render = e, o.staticRenderFns = r, o._compiled = !0), s && (o.functional = !0), a && (o._scopeId = "data-v-" + a);
  var n;
  if (l ? (n = function(A) {
    A = A || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !A && typeof __VUE_SSR_CONTEXT__ < "u" && (A = __VUE_SSR_CONTEXT__), i && i.call(this, A), A && A._registeredComponents && A._registeredComponents.add(l);
  }, o._ssrRegister = n) : i && (n = f ? function() {
    i.call(
      this,
      (o.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), n)
    if (o.functional) {
      o._injectStyles = n;
      var c = o.render;
      o.render = function(d, h) {
        return n.call(h), c(d, h);
      };
    } else {
      var u = o.beforeCreate;
      o.beforeCreate = u ? [].concat(u, n) : [n];
    }
  return {
    exports: t,
    options: o
  };
}
const sa = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      receiver: !1
    };
  },
  computed: {
    title() {
      const t = this.store.state.podcast.type === "episodic" ? null : this.store.state.episode.season_number, e = this.store.state.episode.type === "full" && this.store.state.episode.number !== null ? this.store.state.episode.number : null, r = this.store.state.podcast.title;
      let i = `Audio for ${this.store.state.episode.title}, from `;
      return t && (i += `season ${t}`), e && (i += `episode ${e} of`), i += `the podcast ${r}`, i;
    },
    audio() {
      return this.store.state.audio;
    },
    episode() {
      return this.store.state.episode;
    },
    isLoaded() {
      return this.store.state.isLoaded;
    },
    isPlaying() {
      return this.store.state.isPlaying;
    },
    isWaiting() {
      return this.store.state.isWaiting;
    }
  },
  watch: {
    episode(t, e) {
      !e || t.enclosure_url !== e.enclosure_url && (this.store.setLoaded(0), this.store.setAudioCurrentTime(0), this.store.setCurrentTime(0), this.store.setIsWaiting(!0), this.loading(), this.isPlaying && this.audio.play());
    }
  },
  mounted() {
    this.store.setAudio(this.$refs.audio), this.initializeReceiver();
  },
  methods: {
    ended() {
      this.receiver.emit("ended"), this.store.sendCompleteEvent(), this.store.sendPlayEvent();
    },
    initializeReceiver() {
      this.receiver = new ra.Receiver(), this.receiver.on("getDuration", (t) => {
        t(this.store.state.audio.duration);
      }), this.receiver.on("getLoop", (t) => {
        t(this.store.state.audio.loop || !1);
      }), this.receiver.on("getCurrentTime", (t) => {
        const e = this.audio.currentTime;
        t(e);
      }), this.receiver.on("getMuted", (t) => {
        t(this.store.state.isMuted);
      }), this.receiver.on("getPaused", (t) => {
        const e = !this.store.state.isPlaying;
        t(e);
      }), this.receiver.on("getVolume", (t) => {
        const e = this.store.state.audio.volume * 100;
        t(e);
      }), this.receiver.on("mute", () => {
        this.store.setMute(!0);
      }), this.receiver.on("unmute", () => {
        this.store.setMute(!1);
      }), this.receiver.on("pause", () => {
        this.audio.pause();
      }), this.receiver.on("play", () => {
        this.audio.play();
      }), this.receiver.on("setCurrentTime", (t) => {
        this.store.setAudioCurrentTime(t), this.store.setCurrentTime(t), this.receiver.emit("setCurrentTime");
      }), this.receiver.on("setLoop", (t) => {
        this.store.setLoop(t);
      }), this.receiver.on("setVolume", (t) => {
        this.setVolume(t);
      }), this.receiver.ready();
    },
    loadeddata() {
      this.store.setVolume(this.store.state.volume), this.store.setDuration(this.store.state.audio.duration), this.store.setMute(!1), this.loading(), this.store.state.audio.currentTime = this.store.state.currentTime;
    },
    loading() {
      let t = 0;
      this.audio.buffered.length && (t = this.audio.buffered.end(0) / this.store.state.audio.duration), this.store.setLoaded(t), t < 1 && setTimeout(this.loading, 100);
    },
    play() {
      this.store.setIsPlaying(!0), this.receiver.emit("play");
    },
    playing() {
    },
    pause() {
      this.store.setIsPlaying(!1), this.receiver.emit("pause");
    },
    setVolume(t) {
      this.store.setVolume(t / 100), this.receiver.emit("setVolume");
    },
    timeupdate() {
      this.store.setCurrentTime(this.audio.currentTime), this.receiver.emit("timeupdate", {
        seconds: this.audio.currentTime,
        duration: this.audio.duration
      });
    },
    suspend() {
    }
  }
};
var fs = function() {
  var e = this, r = e._self._c;
  return r("audio", { ref: "audio", attrs: { title: e.title, preload: "none" }, on: { ended: e.ended, loadeddata: e.loadeddata, play: e.play, playing: e.playing, pause: e.pause, timeupdate: e.timeupdate, suspend: e.suspend } });
}, ia = [];
fs._withStripped = !0;
var As = /* @__PURE__ */ B(
  sa,
  fs,
  ia,
  !1,
  null,
  null,
  null,
  null
);
As.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Audio.vue";
const hs = As.exports, na = {};
var ds = function() {
  var e = this, r = e._self._c;
  return r("svg", { staticClass: "sc-logo", attrs: { "aria-label": "Simplecast logo", viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("g", { attrs: { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" } }, [r("path", { staticClass: "sc-logo-border", attrs: { d: "M0,19.9996 L19.9996,19.9996 L19.9996,0 L0,0 L0,19.9996 Z M1.3332,18.6664 L18.6668,18.6664 L18.6668,1.3328 L1.3332,1.3328 L1.3332,18.6664 Z" } }), r("polygon", { attrs: { points: "3.99996 3.99964 3.99996 15.99964 15.99996 15.99964" } }), r("polygon", { attrs: { points: "15.057 12.4848 7.515 4.9424 8.4574 3.9996 15.9998 11.5424" } }), r("polygon", { attrs: { points: "15.057 8.71368 11.2858 4.94208 12.229 3.99968 15.9998 7.77088" } })])]);
}, oa = [];
ds._withStripped = !0;
var ps = /* @__PURE__ */ B(
  na,
  ds,
  oa,
  !1,
  null,
  null,
  null,
  null
);
ps.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/sc-logo.vue";
const $t = ps.exports;
const aa = {
  components: { IconLogo: $t },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    },
    podcastId() {
      if (!this.store.state.podcast)
        return null;
      const t = this.store.state.podcast.id;
      if (t)
        return t;
      if (!this.store.state.podcast.href)
        return null;
      const e = /podcasts\/(.*)\//;
      return this.store.state.podcast.href.match(e)[1] || null;
    },
    linkTo() {
      return this.customLogo && this.customLogo.link || "https://simplecast.com";
    },
    siteName() {
      return this.customLogo && this.customLogo.link ? this.customLogo.link : "Simplecast Homepage";
    },
    customLogo() {
      return this.store.state.podcast.embed_customizations && this.store.state.podcast.embed_customizations.logo !== null ? this.store.state.podcast.embed_customizations : !1;
    }
  }
};
var gs = function() {
  var e = this, r = e._self._c;
  return r("a", { staticClass: "logo", class: { dark: e.isDark, [e.size]: e.size, custom: e.customLogo }, attrs: { href: e.linkTo, title: e.siteName, target: "simplecast" } }, [e.customLogo && e.customLogo.logo ? r("img", { staticClass: "custom-logo", attrs: { src: e.isDark ? e.customLogo.logo_dark : e.customLogo.logo } }) : r("IconLogo")], 1);
}, ca = [];
gs._withStripped = !0;
var Es = /* @__PURE__ */ B(
  aa,
  gs,
  ca,
  !1,
  null,
  "42795242",
  null,
  null
);
Es.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Logo.vue";
const Cs = Es.exports;
const la = {
  components: {
    PodcastArtwork: ta
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    episodeArtwork() {
      let t = { image_url: !1 };
      return this.pod && this.pod.image_url && (t = { image_url: this.pod.image_url }), this.epi && this.epi.image_url && (t = { image_url: this.epi.image_url }), t;
    },
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    pod() {
      return this.store.state.podcast;
    }
  }
};
var ms = function() {
  var e = this, r = e._self._c;
  return r("div", { class: ["artwork", { dark: e.isDark }], attrs: { "aria-hidden": "true" } }, [r("podcast-artwork", { attrs: { podcast: e.episodeArtwork } })], 1);
}, ua = [];
ms._withStripped = !0;
var Bs = /* @__PURE__ */ B(
  la,
  ms,
  ua,
  !1,
  null,
  "93e61956",
  null,
  null
);
Bs.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Artwork.vue";
const lt = Bs.exports;
const fa = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      epScrolling: !1,
      podScrolling: !1
    };
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    epiTitle() {
      return this.epi ? this.epi.title : this.isLoaded ? "Audio Not Found" : "";
    },
    showBranding() {
      return this.store.state.podcast.branding === "simplecast";
    },
    isDark() {
      return this.store.state.isDark;
    },
    isLoaded() {
      return this.store.state.isLoaded;
    },
    pod() {
      return this.store.state.podcast;
    },
    podTitle() {
      let t = this.pod.title;
      return t ? (this.seasonEpisode && (t = `${t} | ${this.seasonEpisode}`), t) : this.isLoaded ? t ? "" : "404" : "";
    },
    seasonEpisode() {
      const t = this.epi.number > -1 && this.epi.number !== null ? `EP${this.epi.number}` : null, e = this.pod.type !== "episodic" && this.epi.season && this.epi.season.number > 0 ? `S${this.epi.season.number}` : null, r = this.epi.type === "trailer" || this.epi.type === "bonus" ? this.epi.type.toUpperCase() : null;
      let s = "";
      return e && (s += e), e && t && !r && (s += ":"), t !== null && !r && (s += t), e && r && (s += " - "), r && (s += r), s;
    },
    size() {
      return this.store.state.size;
    }
  },
  watch: {
    "store.state.isPlaying"(t) {
      t ? (this.setEpScrolling(), this.setPodScrolling()) : (this.epScrolling = !1, this.podScrolling = !1);
    },
    "store.state.episode"() {
      window.document.title = this.epiTitle;
    }
  },
  methods: {
    setEpScrolling() {
      !this.$refs.epText || !this.$refs.epHeading || this.$refs.epText.clientWidth >= this.$refs.epHeading.clientWidth && (this.epScrolling = !0);
    },
    setPodScrolling() {
      !this.$refs.podText || !this.$refs.podHeading || this.$refs.podText.clientWidth >= this.$refs.podHeading.clientWidth && (this.podScrolling = !0);
    }
  }
};
var Is = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "meta-info", class: { dark: e.isDark, [e.size]: e.size } }, [r("h2", { ref: "podHeading", class: ["meta-info-pod type-s", { scrolling: e.podScrolling }], on: { mouseenter: e.setPodScrolling, mouseleave: function(s) {
    e.podScrolling = !1;
  } } }, [r("span", { staticClass: "meta-info-static" }, [e._v(e._s(e.podTitle === "" ? "\xA0" : e.podTitle))]), r("span", { ref: "podText", staticClass: "meta-info-ticker", attrs: { "aria-hidden": "true" } }, [e._v(" " + e._s(e.podTitle === "" ? "\xA0" : e.podTitle) + " ")]), r("span", { staticClass: "meta-info-ticker meta-info-ticket-secondary", attrs: { "aria-hidden": "true" } }, [e._v(" " + e._s(e.podTitle === "" ? "\xA0" : e.podTitle) + " ")])]), r("h1", { ref: "epHeading", class: ["meta-info-epi type-xl-wide", { scrolling: e.epScrolling }], on: { mouseenter: e.setEpScrolling, mouseleave: function(s) {
    e.epScrolling = !1;
  } } }, [r("span", { staticClass: "meta-info-static" }, [e._v(e._s(e.epiTitle === "" ? "\xA0" : e.epiTitle))]), r("span", { ref: "epText", staticClass: "meta-info-ticker", attrs: { "aria-hidden": "true" } }, [e._v(" " + e._s(e.epiTitle === "" ? "\xA0" : e.epiTitle) + " ")]), r("span", { staticClass: "meta-info-ticker meta-info-ticket-secondary", attrs: { "aria-hidden": "true" } }, [e._v(" " + e._s(e.epiTitle === "" ? "\xA0" : e.epiTitle) + " ")])]), e.showBranding ? r("div", { staticClass: "powered-by" }, [e._v(" Powered by "), r("a", { attrs: { title: "Simplecast", href: "https://simplecast.com", target: "_blank" } }, [e._v("Simplecast")])]) : e._e()]);
}, Aa = [];
Is._withStripped = !0;
var vs = /* @__PURE__ */ B(
  fa,
  Is,
  Aa,
  !1,
  null,
  "b30b846a",
  null,
  null
);
vs.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/MetaInfo.vue";
const ut = vs.exports;
const ha = {
  components: {
    Artwork: lt,
    MetaInfo: ut
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    size() {
      return this.store.state.size;
    }
  }
};
var ws = function() {
  var e = this, r = e._self._c;
  return e.size !== "size-mini" ? r("div", { staticClass: "artwork-meta", class: { [e.size]: e.size } }, [r("Artwork", { attrs: { store: e.store } }), r("MetaInfo", { attrs: { store: e.store } })], 1) : e._e();
}, da = [];
ws._withStripped = !0;
var Qs = /* @__PURE__ */ B(
  ha,
  ws,
  da,
  !1,
  null,
  "46e9d794",
  null,
  null
);
Qs.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/PlayerMainArtworkMeta.vue";
const pa = Qs.exports, ga = {};
var Ss = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { width: "19px", height: "20px", viewBox: "0 0 19 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("text", { attrs: { id: "15", "font-family": "HelveticaNeue-Bold, Helvetica Neue", "font-size": "10", "font-weight": "bold", "letter-spacing": "0.125" } }, [r("tspan", { attrs: { x: "7", y: "19" } }, [e._v("15")])]), r("path", { attrs: { d: "M5.06671702,4 L14,4 C16.7614237,4 19,6.23857625 19,9 L19,12 C19,14.7614237 16.7614237,17 14,17 L12.8344704,17 L12.8344704,15 L14,15 C15.6568542,15 17,13.6568542 17,12 L17,9 C17,7.34314575 15.6568542,6 14,6 L5.06671702,6 L5.06671702,10 L0,5 L5.06671702,0 L5.06671702,4 Z", id: "Combined-Shape", transform: "translate(9.500000, 8.500000) scale(-1, 1) translate(-9.500000, -8.500000) " } })]);
}, Ea = [];
Ss._withStripped = !0;
var ks = /* @__PURE__ */ B(
  ga,
  Ss,
  Ea,
  !1,
  null,
  null,
  null,
  null
);
ks.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/forward.vue";
const Ca = ks.exports;
const ma = {
  components: { IconForward: Ca },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    played() {
      return this.store.state.hasPlayed;
    }
  },
  methods: {
    forward() {
      this.store.forward();
    }
  }
};
var ys = function() {
  var e = this, r = e._self._c;
  return r("transition", { attrs: { name: "fade" } }, [e.played ? r("button", { class: {
    "controls-forward": !0,
    dark: e.isDark,
    disabled: !e.epi || !e.epi.id
  }, attrs: { disabled: !e.epi || !e.epi.id, "aria-label": "Fast Forward 15 Seconds" }, on: { click: function(s) {
    return s.preventDefault(), e.forward.apply(null, arguments);
  }, touchstart: function(s) {
    return s.preventDefault(), e.forward.apply(null, arguments);
  } } }, [r("IconForward")], 1) : e._e()]);
}, Ba = [];
ys._withStripped = !0;
var Js = /* @__PURE__ */ B(
  ma,
  ys,
  Ba,
  !1,
  null,
  "087df005",
  null,
  null
);
Js.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Forward.vue";
const xs = Js.exports, Ia = {};
var bs = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { width: "19px", height: "20px", viewBox: "0 0 19 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { d: "M5.06671702,4 L14,4 C16.7614237,4 19,6.23857625 19,9 L19,12 C19,14.7614237 16.7614237,17 14,17 L12.8344704,17 L12.8344704,15 L14,15 C15.6568542,15 17,13.6568542 17,12 L17,9 C17,7.34314575 15.6568542,6 14,6 L5.06671702,6 L5.06671702,10 L0,5 L5.06671702,0 L5.06671702,4 Z", id: "Combined-Shape" } }), r("text", { attrs: { id: "15", "font-family": "HelveticaNeue-Bold, Helvetica Neue", "font-size": "10", "font-weight": "bold", "letter-spacing": "0.125" } }, [r("tspan", { attrs: { x: "0", y: "19" } }, [e._v("15")])])]);
}, va = [];
bs._withStripped = !0;
var Ms = /* @__PURE__ */ B(
  Ia,
  bs,
  va,
  !1,
  null,
  null,
  null,
  null
);
Ms.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/rewind.vue";
const wa = Ms.exports;
const Qa = {
  components: { IconRewind: wa },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    played() {
      return this.store.state.hasPlayed;
    }
  },
  methods: {
    rewind() {
      this.store.rewind();
    }
  }
};
var Ts = function() {
  var e = this, r = e._self._c;
  return r("transition", { attrs: { name: "fade" } }, [e.played ? r("button", { key: "rewind", class: {
    "controls-rewind": !0,
    dark: e.isDark,
    disabled: !e.epi || !e.epi.id
  }, attrs: { disabled: !e.epi || !e.epi.id, "aria-label": "Rewind 15 Seconds" }, on: { click: function(s) {
    return s.preventDefault(), e.rewind.apply(null, arguments);
  }, touchstart: function(s) {
    return s.preventDefault(), e.rewind.apply(null, arguments);
  } } }, [e._t("default", function() {
    return [r("IconRewind")];
  })], 2) : e._e()]);
}, Sa = [];
Ts._withStripped = !0;
var Rs = /* @__PURE__ */ B(
  Qa,
  Ts,
  Sa,
  !1,
  null,
  "b39a90ff",
  null,
  null
);
Rs.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Rewind.vue";
const Ls = Rs.exports;
const ka = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      rate: this.store.state.audio.playbackRate || 1
    };
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    }
  },
  methods: {
    playbackRate() {
      this.store.incrementPlaybackRate(), this.rate = this.store.state.audio.playbackRate;
    }
  }
};
var Us = function() {
  var e = this, r = e._self._c;
  return r("button", { staticClass: "controls-speed", class: {
    dark: e.isDark,
    [e.size]: e.size,
    disabled: (!e.epi || !e.epi.id) && e.size !== "size-mini"
  }, attrs: { disabled: (!e.epi || !e.epi.id) && e.size !== "size-mini", "aria-label": `Speed Rate ${e.rate}x` }, on: { click: function(s) {
    return s.preventDefault(), e.playbackRate.apply(null, arguments);
  }, touchstart: function(s) {
    return s.preventDefault(), e.playbackRate.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.rate) + "x ")]);
}, ya = [];
Us._withStripped = !0;
var Ds = /* @__PURE__ */ B(
  ka,
  Us,
  ya,
  !1,
  null,
  "e4fc02a2",
  null,
  null
);
Ds.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Speed.vue";
const er = Ds.exports, Ja = {};
var Ps = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 44 44" } }, [r("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [r("path", { attrs: { fill: "currentColor", d: "M19.333 12.667v18.666H14V12.667h5.333zm10.667 0v18.666h-5.333V12.667H30z" } })])]);
}, xa = [];
Ps._withStripped = !0;
var Os = /* @__PURE__ */ B(
  Ja,
  Ps,
  xa,
  !1,
  null,
  null,
  null,
  null
);
Os.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/pause.vue";
const ba = Os.exports, Ma = {};
var _s = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 44 44", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { d: "M22,44 C9.8497355,44 0,34.1502645 0,22 C0,9.8497355 9.8497355,0 22,0 C34.1502645,0 44,9.8497355 44,22 C44,34.1502645 34.1502645,44 22,44 Z M16.6666667,12.6666667 L16.6666667,31.3333333 L31.3333333,22 L16.6666667,12.6666667 Z" } })]);
}, Ta = [];
_s._withStripped = !0;
var zs = /* @__PURE__ */ B(
  Ma,
  _s,
  Ta,
  !1,
  null,
  null,
  null,
  null
);
zs.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/play.vue";
const Ra = zs.exports;
const La = {
  components: {
    IconPause: ba,
    IconPlay: Ra
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    audio() {
      return this.store.state.audio;
    },
    color() {
      return this.store.state.color;
    },
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    isLoaded() {
      return this.store.state.isLoaded;
    },
    isPlaying() {
      return this.store.state.isPlaying;
    },
    isWaiting() {
      return this.store.state.isWaiting;
    },
    size() {
      return this.store.state.size;
    }
  },
  methods: {
    togglePlay() {
      if (this.audio.src === "") {
        let t = this.epi.enclosure_url;
        this.store.state.adFreeAudio && this.store.state.adFreeAudio !== "" && (t = this.store.state.adFreeAudio), this.store.setAudioSrc(t);
      }
      this.isPlaying ? (this.store.setIsWaiting(!1), this.audio.pause()) : (this.isLoaded || this.store.setIsWaiting(!0), this.audio.play());
    }
  }
};
var Fs = function() {
  var e = this, r = e._self._c;
  return r("button", { staticClass: "play-pause", class: {
    "is-playing": e.isPlaying,
    dark: e.isDark,
    [e.size]: e.size,
    disabled: !e.epi || !e.epi.id
  }, attrs: { disabled: !e.epi || !e.epi.id, "aria-label": e.isPlaying ? "Pause" : "Play" }, on: { click: function(s) {
    return s.preventDefault(), e.togglePlay.apply(null, arguments);
  } } }, [e.isPlaying ? e._t("pause", function() {
    return [r("IconPause")];
  }) : e._t("play", function() {
    return [r("IconPlay")];
  })], 2);
}, Ua = [];
Fs._withStripped = !0;
var Ys = /* @__PURE__ */ B(
  La,
  Fs,
  Ua,
  !1,
  null,
  "2332627e",
  null,
  null
);
Ys.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/PlayPause.vue";
const Hs = Ys.exports;
const Da = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    },
    shareOpen() {
      return this.store.state.showShare;
    },
    epi() {
      return this.store.state.episode;
    },
    isDisabled() {
      return !this.epi || !this.epi.id || this.epi.is_hidden;
    }
  }
};
var js = function() {
  var e = this, r = e._self._c;
  return r("a", { class: {
    "controls-privacy": !0,
    dark: e.isDark,
    [e.size]: e.size,
    disabled: e.isDisabled,
    open: e.shareOpen
  }, attrs: { href: "https://www.simplecast.com/privacy", target: "simplecast-share", title: "Simplecast Privacy Policy" } }, [r("span", { staticClass: "menu-text" }, [e._v("Privacy")])]);
}, Pa = [];
js._withStripped = !0;
var Ks = /* @__PURE__ */ B(
  Da,
  js,
  Pa,
  !1,
  null,
  "44964fd1",
  null,
  null
);
Ks.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Privacy.vue";
const Ns = Ks.exports;
function Ce(t) {
  return function() {
    return t;
  };
}
const Yt = Math.PI, Ht = 2 * Yt, Ae = 1e-6, Oa = Ht - Ae;
function Gs(t) {
  this._ += t[0];
  for (let e = 1, r = t.length; e < r; ++e)
    this._ += arguments[e] + t[e];
}
function _a(t) {
  let e = Math.floor(t);
  if (!(e >= 0))
    throw new Error(`invalid digits: ${t}`);
  if (e > 15)
    return Gs;
  const r = 10 ** e;
  return function(s) {
    this._ += s[0];
    for (let i = 1, a = s.length; i < a; ++i)
      this._ += Math.round(arguments[i] * r) / r + s[i];
  };
}
class za {
  constructor(e) {
    this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "", this._append = e == null ? Gs : _a(e);
  }
  moveTo(e, r) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, r) {
    this._append`L${this._x1 = +e},${this._y1 = +r}`;
  }
  quadraticCurveTo(e, r, s, i) {
    this._append`Q${+e},${+r},${this._x1 = +s},${this._y1 = +i}`;
  }
  bezierCurveTo(e, r, s, i, a, l) {
    this._append`C${+e},${+r},${+s},${+i},${this._x1 = +a},${this._y1 = +l}`;
  }
  arcTo(e, r, s, i, a) {
    if (e = +e, r = +r, s = +s, i = +i, a = +a, a < 0)
      throw new Error(`negative radius: ${a}`);
    let l = this._x1, f = this._y1, o = s - e, n = i - r, c = l - e, u = f - r, A = c * c + u * u;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = r}`;
    else if (A > Ae)
      if (!(Math.abs(u * o - n * c) > Ae) || !a)
        this._append`L${this._x1 = e},${this._y1 = r}`;
      else {
        let d = s - l, h = i - f, C = o * o + n * n, S = d * d + h * h, x = Math.sqrt(C), D = Math.sqrt(A), P = a * Math.tan((Yt - Math.acos((C + A - S) / (2 * x * D))) / 2), v = P / D, R = P / x;
        Math.abs(v - 1) > Ae && this._append`L${e + v * c},${r + v * u}`, this._append`A${a},${a},0,0,${+(u * d > c * h)},${this._x1 = e + R * o},${this._y1 = r + R * n}`;
      }
  }
  arc(e, r, s, i, a, l) {
    if (e = +e, r = +r, s = +s, l = !!l, s < 0)
      throw new Error(`negative radius: ${s}`);
    let f = s * Math.cos(i), o = s * Math.sin(i), n = e + f, c = r + o, u = 1 ^ l, A = l ? i - a : a - i;
    this._x1 === null ? this._append`M${n},${c}` : (Math.abs(this._x1 - n) > Ae || Math.abs(this._y1 - c) > Ae) && this._append`L${n},${c}`, s && (A < 0 && (A = A % Ht + Ht), A > Oa ? this._append`A${s},${s},0,1,${u},${e - f},${r - o}A${s},${s},0,1,${u},${this._x1 = n},${this._y1 = c}` : A > Ae && this._append`A${s},${s},0,${+(A >= Yt)},${u},${this._x1 = e + s * Math.cos(a)},${this._y1 = r + s * Math.sin(a)}`);
  }
  rect(e, r, s, i) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}h${s = +s}v${+i}h${-s}Z`;
  }
  toString() {
    return this._;
  }
}
function Fa(t) {
  let e = 3;
  return t.digits = function(r) {
    if (!arguments.length)
      return e;
    if (r == null)
      e = null;
    else {
      const s = Math.floor(r);
      if (!(s >= 0))
        throw new RangeError(`invalid digits: ${r}`);
      e = s;
    }
    return t;
  }, () => new za(e);
}
function Ya(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Zs(t) {
  this._context = t;
}
Zs.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function Ws(t) {
  return new Zs(t);
}
function Ha(t) {
  return t[0];
}
function ja(t) {
  return t[1];
}
function Ka(t, e) {
  var r = Ce(!0), s = null, i = Ws, a = null, l = Fa(f);
  t = typeof t == "function" ? t : t === void 0 ? Ha : Ce(t), e = typeof e == "function" ? e : e === void 0 ? ja : Ce(e);
  function f(o) {
    var n, c = (o = Ya(o)).length, u, A = !1, d;
    for (s == null && (a = i(d = l())), n = 0; n <= c; ++n)
      !(n < c && r(u = o[n], n, o)) === A && ((A = !A) ? a.lineStart() : a.lineEnd()), A && a.point(+t(u, n, o), +e(u, n, o));
    if (d)
      return a = null, d + "" || null;
  }
  return f.x = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : Ce(+o), f) : t;
  }, f.y = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : Ce(+o), f) : e;
  }, f.defined = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : Ce(!!o), f) : r;
  }, f.curve = function(o) {
    return arguments.length ? (i = o, s != null && (a = i(s)), f) : i;
  }, f.context = function(o) {
    return arguments.length ? (o == null ? s = a = null : a = i(s = o), f) : s;
  }, f;
}
function Ve(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Na(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Vs(t) {
  let e, r, s;
  t.length !== 2 ? (e = Ve, r = (f, o) => Ve(t(f), o), s = (f, o) => t(f) - o) : (e = t === Ve || t === Na ? t : Ga, r = t, s = t);
  function i(f, o, n = 0, c = f.length) {
    if (n < c) {
      if (e(o, o) !== 0)
        return c;
      do {
        const u = n + c >>> 1;
        r(f[u], o) < 0 ? n = u + 1 : c = u;
      } while (n < c);
    }
    return n;
  }
  function a(f, o, n = 0, c = f.length) {
    if (n < c) {
      if (e(o, o) !== 0)
        return c;
      do {
        const u = n + c >>> 1;
        r(f[u], o) <= 0 ? n = u + 1 : c = u;
      } while (n < c);
    }
    return n;
  }
  function l(f, o, n = 0, c = f.length) {
    const u = i(f, o, n, c - 1);
    return u > n && s(f[u - 1], o) > -s(f[u], o) ? u - 1 : u;
  }
  return { left: i, center: l, right: a };
}
function Ga() {
  return 0;
}
function Za(t) {
  return t === null ? NaN : +t;
}
const Wa = Vs(Ve), Va = Wa.right;
Vs(Za).center;
const Xa = Va, qa = Math.sqrt(50), $a = Math.sqrt(10), e1 = Math.sqrt(2);
function tt(t, e, r) {
  const s = (e - t) / Math.max(0, r), i = Math.floor(Math.log10(s)), a = s / Math.pow(10, i), l = a >= qa ? 10 : a >= $a ? 5 : a >= e1 ? 2 : 1;
  let f, o, n;
  return i < 0 ? (n = Math.pow(10, -i) / l, f = Math.round(t * n), o = Math.round(e * n), f / n < t && ++f, o / n > e && --o, n = -n) : (n = Math.pow(10, i) * l, f = Math.round(t / n), o = Math.round(e / n), f * n < t && ++f, o * n > e && --o), o < f && 0.5 <= r && r < 2 ? tt(t, e, r * 2) : [f, o, n];
}
function t1(t, e, r) {
  if (e = +e, t = +t, r = +r, !(r > 0))
    return [];
  if (t === e)
    return [t];
  const s = e < t, [i, a, l] = s ? tt(e, t, r) : tt(t, e, r);
  if (!(a >= i))
    return [];
  const f = a - i + 1, o = new Array(f);
  if (s)
    if (l < 0)
      for (let n = 0; n < f; ++n)
        o[n] = (a - n) / -l;
    else
      for (let n = 0; n < f; ++n)
        o[n] = (a - n) * l;
  else if (l < 0)
    for (let n = 0; n < f; ++n)
      o[n] = (i + n) / -l;
  else
    for (let n = 0; n < f; ++n)
      o[n] = (i + n) * l;
  return o;
}
function jt(t, e, r) {
  return e = +e, t = +t, r = +r, tt(t, e, r)[2];
}
function r1(t, e, r) {
  e = +e, t = +t, r = +r;
  const s = e < t, i = s ? jt(e, t, r) : jt(t, e, r);
  return (s ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function s1(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function tr(t, e, r) {
  t.prototype = e.prototype = r, r.constructor = t;
}
function Xs(t, e) {
  var r = Object.create(t.prototype);
  for (var s in e)
    r[s] = e[s];
  return r;
}
function _e() {
}
var Ue = 0.7, rt = 1 / Ue, ve = "\\s*([+-]?\\d+)\\s*", De = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", ee = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", i1 = /^#([0-9a-f]{3,8})$/, n1 = new RegExp(`^rgb\\(${ve},${ve},${ve}\\)$`), o1 = new RegExp(`^rgb\\(${ee},${ee},${ee}\\)$`), a1 = new RegExp(`^rgba\\(${ve},${ve},${ve},${De}\\)$`), c1 = new RegExp(`^rgba\\(${ee},${ee},${ee},${De}\\)$`), l1 = new RegExp(`^hsl\\(${De},${ee},${ee}\\)$`), u1 = new RegExp(`^hsla\\(${De},${ee},${ee},${De}\\)$`), Ir = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
tr(_e, Pe, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: vr,
  formatHex: vr,
  formatHex8: f1,
  formatHsl: A1,
  formatRgb: wr,
  toString: wr
});
function vr() {
  return this.rgb().formatHex();
}
function f1() {
  return this.rgb().formatHex8();
}
function A1() {
  return qs(this).formatHsl();
}
function wr() {
  return this.rgb().formatRgb();
}
function Pe(t) {
  var e, r;
  return t = (t + "").trim().toLowerCase(), (e = i1.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), r === 6 ? Qr(e) : r === 3 ? new N(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : r === 8 ? Ke(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : r === 4 ? Ke(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = n1.exec(t)) ? new N(e[1], e[2], e[3], 1) : (e = o1.exec(t)) ? new N(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = a1.exec(t)) ? Ke(e[1], e[2], e[3], e[4]) : (e = c1.exec(t)) ? Ke(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = l1.exec(t)) ? yr(e[1], e[2] / 100, e[3] / 100, 1) : (e = u1.exec(t)) ? yr(e[1], e[2] / 100, e[3] / 100, e[4]) : Ir.hasOwnProperty(t) ? Qr(Ir[t]) : t === "transparent" ? new N(NaN, NaN, NaN, 0) : null;
}
function Qr(t) {
  return new N(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Ke(t, e, r, s) {
  return s <= 0 && (t = e = r = NaN), new N(t, e, r, s);
}
function h1(t) {
  return t instanceof _e || (t = Pe(t)), t ? (t = t.rgb(), new N(t.r, t.g, t.b, t.opacity)) : new N();
}
function Kt(t, e, r, s) {
  return arguments.length === 1 ? h1(t) : new N(t, e, r, s == null ? 1 : s);
}
function N(t, e, r, s) {
  this.r = +t, this.g = +e, this.b = +r, this.opacity = +s;
}
tr(N, Kt, Xs(_e, {
  brighter(t) {
    return t = t == null ? rt : Math.pow(rt, t), new N(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Ue : Math.pow(Ue, t), new N(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new N(de(this.r), de(this.g), de(this.b), st(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Sr,
  formatHex: Sr,
  formatHex8: d1,
  formatRgb: kr,
  toString: kr
}));
function Sr() {
  return `#${he(this.r)}${he(this.g)}${he(this.b)}`;
}
function d1() {
  return `#${he(this.r)}${he(this.g)}${he(this.b)}${he((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function kr() {
  const t = st(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${de(this.r)}, ${de(this.g)}, ${de(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function st(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function de(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function he(t) {
  return t = de(t), (t < 16 ? "0" : "") + t.toString(16);
}
function yr(t, e, r, s) {
  return s <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new q(t, e, r, s);
}
function qs(t) {
  if (t instanceof q)
    return new q(t.h, t.s, t.l, t.opacity);
  if (t instanceof _e || (t = Pe(t)), !t)
    return new q();
  if (t instanceof q)
    return t;
  t = t.rgb();
  var e = t.r / 255, r = t.g / 255, s = t.b / 255, i = Math.min(e, r, s), a = Math.max(e, r, s), l = NaN, f = a - i, o = (a + i) / 2;
  return f ? (e === a ? l = (r - s) / f + (r < s) * 6 : r === a ? l = (s - e) / f + 2 : l = (e - r) / f + 4, f /= o < 0.5 ? a + i : 2 - a - i, l *= 60) : f = o > 0 && o < 1 ? 0 : l, new q(l, f, o, t.opacity);
}
function p1(t, e, r, s) {
  return arguments.length === 1 ? qs(t) : new q(t, e, r, s == null ? 1 : s);
}
function q(t, e, r, s) {
  this.h = +t, this.s = +e, this.l = +r, this.opacity = +s;
}
tr(q, p1, Xs(_e, {
  brighter(t) {
    return t = t == null ? rt : Math.pow(rt, t), new q(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Ue : Math.pow(Ue, t), new q(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, r = this.l, s = r + (r < 0.5 ? r : 1 - r) * e, i = 2 * r - s;
    return new N(
      Qt(t >= 240 ? t - 240 : t + 120, i, s),
      Qt(t, i, s),
      Qt(t < 120 ? t + 240 : t - 120, i, s),
      this.opacity
    );
  },
  clamp() {
    return new q(Jr(this.h), Ne(this.s), Ne(this.l), st(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = st(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Jr(this.h)}, ${Ne(this.s) * 100}%, ${Ne(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Jr(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Ne(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function Qt(t, e, r) {
  return (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e) * 255;
}
const rr = (t) => () => t;
function g1(t, e) {
  return function(r) {
    return t + r * e;
  };
}
function E1(t, e, r) {
  return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function(s) {
    return Math.pow(t + s * e, r);
  };
}
function C1(t) {
  return (t = +t) == 1 ? $s : function(e, r) {
    return r - e ? E1(e, r, t) : rr(isNaN(e) ? r : e);
  };
}
function $s(t, e) {
  var r = e - t;
  return r ? g1(t, r) : rr(isNaN(t) ? e : t);
}
const xr = function t(e) {
  var r = C1(e);
  function s(i, a) {
    var l = r((i = Kt(i)).r, (a = Kt(a)).r), f = r(i.g, a.g), o = r(i.b, a.b), n = $s(i.opacity, a.opacity);
    return function(c) {
      return i.r = l(c), i.g = f(c), i.b = o(c), i.opacity = n(c), i + "";
    };
  }
  return s.gamma = t, s;
}(1);
function m1(t, e) {
  e || (e = []);
  var r = t ? Math.min(e.length, t.length) : 0, s = e.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i)
      s[i] = t[i] * (1 - a) + e[i] * a;
    return s;
  };
}
function B1(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function I1(t, e) {
  var r = e ? e.length : 0, s = t ? Math.min(r, t.length) : 0, i = new Array(s), a = new Array(r), l;
  for (l = 0; l < s; ++l)
    i[l] = sr(t[l], e[l]);
  for (; l < r; ++l)
    a[l] = e[l];
  return function(f) {
    for (l = 0; l < s; ++l)
      a[l] = i[l](f);
    return a;
  };
}
function v1(t, e) {
  var r = new Date();
  return t = +t, e = +e, function(s) {
    return r.setTime(t * (1 - s) + e * s), r;
  };
}
function it(t, e) {
  return t = +t, e = +e, function(r) {
    return t * (1 - r) + e * r;
  };
}
function w1(t, e) {
  var r = {}, s = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? r[i] = sr(t[i], e[i]) : s[i] = e[i];
  return function(a) {
    for (i in r)
      s[i] = r[i](a);
    return s;
  };
}
var Nt = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, St = new RegExp(Nt.source, "g");
function Q1(t) {
  return function() {
    return t;
  };
}
function S1(t) {
  return function(e) {
    return t(e) + "";
  };
}
function k1(t, e) {
  var r = Nt.lastIndex = St.lastIndex = 0, s, i, a, l = -1, f = [], o = [];
  for (t = t + "", e = e + ""; (s = Nt.exec(t)) && (i = St.exec(e)); )
    (a = i.index) > r && (a = e.slice(r, a), f[l] ? f[l] += a : f[++l] = a), (s = s[0]) === (i = i[0]) ? f[l] ? f[l] += i : f[++l] = i : (f[++l] = null, o.push({ i: l, x: it(s, i) })), r = St.lastIndex;
  return r < e.length && (a = e.slice(r), f[l] ? f[l] += a : f[++l] = a), f.length < 2 ? o[0] ? S1(o[0].x) : Q1(e) : (e = o.length, function(n) {
    for (var c = 0, u; c < e; ++c)
      f[(u = o[c]).i] = u.x(n);
    return f.join("");
  });
}
function sr(t, e) {
  var r = typeof e, s;
  return e == null || r === "boolean" ? rr(e) : (r === "number" ? it : r === "string" ? (s = Pe(e)) ? (e = s, xr) : k1 : e instanceof Pe ? xr : e instanceof Date ? v1 : B1(e) ? m1 : Array.isArray(e) ? I1 : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? w1 : it)(t, e);
}
function y1(t, e) {
  return t = +t, e = +e, function(r) {
    return Math.round(t * (1 - r) + e * r);
  };
}
function J1(t) {
  return function() {
    return t;
  };
}
function x1(t) {
  return +t;
}
var br = [0, 1];
function Ie(t) {
  return t;
}
function Gt(t, e) {
  return (e -= t = +t) ? function(r) {
    return (r - t) / e;
  } : J1(isNaN(e) ? NaN : 0.5);
}
function b1(t, e) {
  var r;
  return t > e && (r = t, t = e, e = r), function(s) {
    return Math.max(t, Math.min(e, s));
  };
}
function M1(t, e, r) {
  var s = t[0], i = t[1], a = e[0], l = e[1];
  return i < s ? (s = Gt(i, s), a = r(l, a)) : (s = Gt(s, i), a = r(a, l)), function(f) {
    return a(s(f));
  };
}
function T1(t, e, r) {
  var s = Math.min(t.length, e.length) - 1, i = new Array(s), a = new Array(s), l = -1;
  for (t[s] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++l < s; )
    i[l] = Gt(t[l], t[l + 1]), a[l] = r(e[l], e[l + 1]);
  return function(f) {
    var o = Xa(t, f, 1, s) - 1;
    return a[o](i[o](f));
  };
}
function R1(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function L1() {
  var t = br, e = br, r = sr, s, i, a, l = Ie, f, o, n;
  function c() {
    var A = Math.min(t.length, e.length);
    return l !== Ie && (l = b1(t[0], t[A - 1])), f = A > 2 ? T1 : M1, o = n = null, u;
  }
  function u(A) {
    return A == null || isNaN(A = +A) ? a : (o || (o = f(t.map(s), e, r)))(s(l(A)));
  }
  return u.invert = function(A) {
    return l(i((n || (n = f(e, t.map(s), it)))(A)));
  }, u.domain = function(A) {
    return arguments.length ? (t = Array.from(A, x1), c()) : t.slice();
  }, u.range = function(A) {
    return arguments.length ? (e = Array.from(A), c()) : e.slice();
  }, u.rangeRound = function(A) {
    return e = Array.from(A), r = y1, c();
  }, u.clamp = function(A) {
    return arguments.length ? (l = A ? !0 : Ie, c()) : l !== Ie;
  }, u.interpolate = function(A) {
    return arguments.length ? (r = A, c()) : r;
  }, u.unknown = function(A) {
    return arguments.length ? (a = A, u) : a;
  }, function(A, d) {
    return s = A, i = d, c();
  };
}
function U1() {
  return L1()(Ie, Ie);
}
function D1(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function nt(t, e) {
  if ((r = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var r, s = t.slice(0, r);
  return [
    s.length > 1 ? s[0] + s.slice(2) : s,
    +t.slice(r + 1)
  ];
}
function we(t) {
  return t = nt(Math.abs(t)), t ? t[1] : NaN;
}
function P1(t, e) {
  return function(r, s) {
    for (var i = r.length, a = [], l = 0, f = t[0], o = 0; i > 0 && f > 0 && (o + f + 1 > s && (f = Math.max(1, s - o)), a.push(r.substring(i -= f, i + f)), !((o += f + 1) > s)); )
      f = t[l = (l + 1) % t.length];
    return a.reverse().join(e);
  };
}
function O1(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(r) {
      return t[+r];
    });
  };
}
var _1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function ot(t) {
  if (!(e = _1.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new ir({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
ot.prototype = ir.prototype;
function ir(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
ir.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function z1(t) {
  e:
    for (var e = t.length, r = 1, s = -1, i; r < e; ++r)
      switch (t[r]) {
        case ".":
          s = i = r;
          break;
        case "0":
          s === 0 && (s = r), i = r;
          break;
        default:
          if (!+t[r])
            break e;
          s > 0 && (s = 0);
          break;
      }
  return s > 0 ? t.slice(0, s) + t.slice(i + 1) : t;
}
var ei;
function F1(t, e) {
  var r = nt(t, e);
  if (!r)
    return t + "";
  var s = r[0], i = r[1], a = i - (ei = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, l = s.length;
  return a === l ? s : a > l ? s + new Array(a - l + 1).join("0") : a > 0 ? s.slice(0, a) + "." + s.slice(a) : "0." + new Array(1 - a).join("0") + nt(t, Math.max(0, e + a - 1))[0];
}
function Mr(t, e) {
  var r = nt(t, e);
  if (!r)
    return t + "";
  var s = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + s : s.length > i + 1 ? s.slice(0, i + 1) + "." + s.slice(i + 1) : s + new Array(i - s.length + 2).join("0");
}
const Tr = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: D1,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Mr(t * 100, e),
  r: Mr,
  s: F1,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function Rr(t) {
  return t;
}
var Lr = Array.prototype.map, Ur = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Y1(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? Rr : P1(Lr.call(t.grouping, Number), t.thousands + ""), r = t.currency === void 0 ? "" : t.currency[0] + "", s = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", a = t.numerals === void 0 ? Rr : O1(Lr.call(t.numerals, String)), l = t.percent === void 0 ? "%" : t.percent + "", f = t.minus === void 0 ? "\u2212" : t.minus + "", o = t.nan === void 0 ? "NaN" : t.nan + "";
  function n(u) {
    u = ot(u);
    var A = u.fill, d = u.align, h = u.sign, C = u.symbol, S = u.zero, x = u.width, D = u.comma, P = u.precision, v = u.trim, R = u.type;
    R === "n" ? (D = !0, R = "g") : Tr[R] || (P === void 0 && (P = 12), v = !0, R = "g"), (S || A === "0" && d === "=") && (S = !0, A = "0", d = "=");
    var H = C === "$" ? r : C === "#" && /[boxX]/.test(R) ? "0" + R.toLowerCase() : "", Q = C === "$" ? s : /[%p]/.test(R) ? l : "", I = Tr[R], J = /[defgprs%]/.test(R);
    P = P === void 0 ? 6 : /[gprs]/.test(R) ? Math.max(1, Math.min(21, P)) : Math.max(0, Math.min(20, P));
    function E(g) {
      var m = H, w = Q, U, j, K;
      if (R === "c")
        w = I(g) + w, g = "";
      else {
        g = +g;
        var W = g < 0 || 1 / g < 0;
        if (g = isNaN(g) ? o : I(Math.abs(g), P), v && (g = z1(g)), W && +g == 0 && h !== "+" && (W = !1), m = (W ? h === "(" ? h : f : h === "-" || h === "(" ? "" : h) + m, w = (R === "s" ? Ur[8 + ei / 3] : "") + w + (W && h === "(" ? ")" : ""), J) {
          for (U = -1, j = g.length; ++U < j; )
            if (K = g.charCodeAt(U), 48 > K || K > 57) {
              w = (K === 46 ? i + g.slice(U + 1) : g.slice(U)) + w, g = g.slice(0, U);
              break;
            }
        }
      }
      D && !S && (g = e(g, 1 / 0));
      var _ = m.length + g.length + w.length, F = _ < x ? new Array(x - _ + 1).join(A) : "";
      switch (D && S && (g = e(F + g, F.length ? x - w.length : 1 / 0), F = ""), d) {
        case "<":
          g = m + g + w + F;
          break;
        case "=":
          g = m + F + g + w;
          break;
        case "^":
          g = F.slice(0, _ = F.length >> 1) + m + g + w + F.slice(_);
          break;
        default:
          g = F + m + g + w;
          break;
      }
      return a(g);
    }
    return E.toString = function() {
      return u + "";
    }, E;
  }
  function c(u, A) {
    var d = n((u = ot(u), u.type = "f", u)), h = Math.max(-8, Math.min(8, Math.floor(we(A) / 3))) * 3, C = Math.pow(10, -h), S = Ur[8 + h / 3];
    return function(x) {
      return d(C * x) + S;
    };
  }
  return {
    format: n,
    formatPrefix: c
  };
}
var Ge, ti, ri;
H1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function H1(t) {
  return Ge = Y1(t), ti = Ge.format, ri = Ge.formatPrefix, Ge;
}
function j1(t) {
  return Math.max(0, -we(Math.abs(t)));
}
function K1(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(we(e) / 3))) * 3 - we(Math.abs(t)));
}
function N1(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, we(e) - we(t)) + 1;
}
function G1(t, e, r, s) {
  var i = r1(t, e, r), a;
  switch (s = ot(s == null ? ",f" : s), s.type) {
    case "s": {
      var l = Math.max(Math.abs(t), Math.abs(e));
      return s.precision == null && !isNaN(a = K1(i, l)) && (s.precision = a), ri(s, l);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      s.precision == null && !isNaN(a = N1(i, Math.max(Math.abs(t), Math.abs(e)))) && (s.precision = a - (s.type === "e"));
      break;
    }
    case "f":
    case "%": {
      s.precision == null && !isNaN(a = j1(i)) && (s.precision = a - (s.type === "%") * 2);
      break;
    }
  }
  return ti(s);
}
function Z1(t) {
  var e = t.domain;
  return t.ticks = function(r) {
    var s = e();
    return t1(s[0], s[s.length - 1], r == null ? 10 : r);
  }, t.tickFormat = function(r, s) {
    var i = e();
    return G1(i[0], i[i.length - 1], r == null ? 10 : r, s);
  }, t.nice = function(r) {
    r == null && (r = 10);
    var s = e(), i = 0, a = s.length - 1, l = s[i], f = s[a], o, n, c = 10;
    for (f < l && (n = l, l = f, f = n, n = i, i = a, a = n); c-- > 0; ) {
      if (n = jt(l, f, r), n === o)
        return s[i] = l, s[a] = f, e(s);
      if (n > 0)
        l = Math.floor(l / n) * n, f = Math.ceil(f / n) * n;
      else if (n < 0)
        l = Math.ceil(l * n) / n, f = Math.floor(f * n) / n;
      else
        break;
      o = n;
    }
    return t;
  }, t;
}
function at() {
  var t = U1();
  return t.copy = function() {
    return R1(t, at());
  }, s1.apply(t, arguments), Z1(t);
}
const W1 = {};
var si = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 24 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { d: "M23.9931809,9.11979411 C23.9931809,8.69576876 23.9931809,8.35209123 23.2423886,8.35209123 C22.4881338,8.35209123 22.4881338,8.69576876 22.4881338,9.11979411 L22.4881338,9.88280515 C22.4881338,10.3033116 22.4881338,10.6493351 23.2423886,10.6493351 C23.9931809,10.6493351 23.9931809,10.3033116 23.9931809,9.88280515 L23.9931809,9.11979411 Z M21.7333018,6.82349374 C21.7333018,6.40181432 21.7333018,6.05813679 20.9825095,6.05813679 C20.2282547,6.05813679 20.2282547,6.40181432 20.2282547,6.82349374 L20.2282547,10.6473461 C20.2282547,11.0701985 20.2282547,11.415049 20.9825095,11.415049 C21.7333018,11.415049 21.7333018,11.0701985 21.7333018,10.6473461 L21.7333018,6.82349374 Z M19.4780395,0.763011037 C19.4780395,0.343677531 19.4780395,2.84217094e-14 18.7226305,2.84217094e-14 C17.9718382,2.84217094e-14 17.9718382,0.343677531 17.9718382,0.763011037 L17.9718382,16.8319883 C17.9718382,17.2501488 17.9718382,17.5949993 18.7226305,17.5949993 C19.4780395,17.5949993 19.4780395,17.2501488 19.4780395,16.8319883 L19.4780395,0.763011037 Z M17.2181604,5.29300932 C17.2181604,4.87132989 17.2181604,4.52765236 16.4673681,4.52765236 C15.7119591,4.52765236 15.7119591,4.87132989 15.7119591,5.29300932 L15.7119591,13.7090035 C15.7119591,14.127164 15.7119591,14.4755334 16.4673681,14.4755334 C17.2181604,14.4755334 17.2181604,14.127164 17.2181604,13.7090035 L17.2181604,5.29300932 Z M14.9617439,7.58849371 C14.9617439,7.16681429 14.9617439,6.82313676 14.2074891,6.82313676 C13.4566968,6.82313676 13.4566968,7.16681429 13.4566968,7.58849371 C13.4566968,8.64749932 13.4566968,9.47519592 13.4566968,10.0715835 C13.4566968,10.0828995 14.9617439,11.2651966 14.9617439,11.2609627 C14.9617439,10.4747243 14.9617439,9.250568 14.9617439,7.58849371 Z M12.7018649,9.46387004 C12.7018649,8.88882104 12.7018649,8.08657995 12.7018649,7.1239988 C12.7018649,7.06214551 11.5888096,8.03492656 11.2751873,8.32048924 C11.2636494,8.33099489 12.7018649,9.46517019 12.7018649,9.46387004 Z M11.1968177,14.789581 C11.1968177,15.1759464 11.1968177,15.6907147 11.1968177,16.3338857 C11.1968177,16.7520463 11.1968177,17.0968968 11.9510726,17.0968968 C12.7018649,17.0968968 12.7018649,16.7520463 12.7018649,16.3338857 C12.7018649,16.0008761 12.7018649,15.6491932 12.7018649,15.2788369 C12.7018649,15.0837532 12.7018649,14.5637934 12.7018649,14.6697276 C12.7018649,14.6702812 12.3333678,14.7065763 11.9495928,14.6787646 C11.6555997,14.6574592 11.1968177,14.541256 11.1968177,14.5349994 C11.1968177,14.5497789 11.1968177,14.7446725 11.1968177,14.789581 Z" } }), r("path", { attrs: { d: "M2.4292905,9.30046494 C2.84744278,9.26183165 3.26927372,9.31735885 3.66075661,9.46256748 L5.17950381,7.9984155 L3.66075661,6.53426351 C2.61740198,6.92349252 1.42999066,6.65396295 0.683027886,5.85835121 C-0.0639348927,5.06273946 -0.213064124,3.90868087 0.309049308,2.96426273 C0.831162741,2.01984459 1.91450957,1.48405575 3.02581049,1.62063916 C3.79153775,1.71338992 4.47813107,2.11606191 4.90985185,2.72558827 C5.34157263,3.33511464 5.47651654,4.09233261 5.28014368,4.8034267 L7.0770229,6.17171159 L9.14105524,4.18639121 C9.77452414,3.57645449 10.5932069,3.17158722 11.4813898,3.02901393 C12.5774918,2.85294085 13.6864001,3.265555 14.3670095,4.10272539 C14.4138954,4.16282285 14.4025864,4.24746544 14.341392,4.29445958 L5.28014368,11.1881752 C5.37325337,11.5295497 5.39193582,11.8854788 5.33503816,12.233998 C5.12119101,13.5461793 3.88726416,14.4832411 2.49673715,14.3894446 C1.10621014,14.2956481 0.0232189417,13.202301 0.00562107244,11.8745079 C-0.0119767968,10.5467147 1.04169256,9.42767176 2.4292905,9.30046494 Z M2.74472386,5.43422917 C3.084432,5.43422917 3.41022659,5.30568048 3.65043652,5.07686235 C3.89064646,4.84804421 4.02559499,4.53770022 4.02559499,4.21410251 C4.02559499,3.54024517 3.45212945,2.99397586 2.74472386,2.99397586 C2.03731826,2.99397586 1.46385272,3.54024517 1.46385272,4.21410251 C1.46385272,4.88795986 2.03731826,5.43422917 2.74472386,5.43422917 Z M2.74472386,13.1035967 C3.45212945,13.1035967 4.02559499,12.5573274 4.02559499,11.8834701 C4.02559499,11.2096127 3.45212945,10.6633434 2.74472386,10.6633434 C2.03731826,10.6633434 1.46385272,11.2096127 1.46385272,11.8834701 C1.46385272,12.5573274 2.03731826,13.1035967 2.74472386,13.1035967 Z M11.3169452,13.4015699 C10.4287623,13.2589966 9.61007956,12.8541293 8.97661066,12.2441926 L7.61888726,10.9247128 L10.1092667,9.03177342 L14.1897562,12.1448394 C14.2509506,12.1918336 14.2622596,12.2764762 14.2153736,12.3365736 C13.5313777,13.1720115 12.4203685,13.5812734 11.3242645,13.4015699 L11.3169452,13.4015699 Z" } })]);
}, V1 = [];
si._withStripped = !0;
var ii = /* @__PURE__ */ B(
  W1,
  si,
  V1,
  !1,
  null,
  null,
  null,
  null
);
ii.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/recast.vue";
const X1 = ii.exports, Qe = {
  iso(t) {
    if (typeof t != "number")
      return t;
    let e = new Date(t * 1e3).toISOString(), r = 11, s = 8;
    return e.substr(r, 2) === "00" && (r = 14, s = 5), e.substr(r, s);
  },
  url(t) {
    let e = typeof t == "number" ? Qe.iso(t).split(":") : t.split(":");
    return e.length === 3 ? `${parseInt(e[0])}h${parseInt(e[1])}m${parseInt(e[2])}s` : e.length === 2 ? `${parseInt(e[0])}m${parseInt(e[1])}s` : e[0] >= 60 ? Qe.url(parseInt(e[0])) : `${e[0]}s`;
  }
}, q1 = {
  resample(t, e) {
    const s = t.length, i = [];
    let a = 0;
    const l = at().domain([0, t.length]).rangeRound([0, t.length / e]);
    for (a; a < t.length; a += 1)
      i[l(a)] = t[a];
    return i.slice(0, s);
  }
};
const $1 = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    currentTime() {
      return Qe.iso(this.store.state.currentTime);
    }
  }
};
var ni = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "current-time" }, [e._v(e._s(e.currentTime))]);
}, e0 = [];
ni._withStripped = !0;
var oi = /* @__PURE__ */ B(
  $1,
  ni,
  e0,
  !1,
  null,
  "e99473d8",
  null,
  null
);
oi.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/TimeCurrent.vue";
const t0 = oi.exports;
const r0 = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    duration() {
      return Qe.iso(this.store.state.duration);
    },
    isDark() {
      return this.store.state.isDark;
    }
  }
};
var ai = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "total-time", class: { dark: e.isDark } }, [e._v(e._s(e.duration))]);
}, s0 = [];
ai._withStripped = !0;
var ci = /* @__PURE__ */ B(
  r0,
  ai,
  s0,
  !1,
  null,
  "2b6becc4",
  null,
  null
);
ci.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/TimeTotal.vue";
const i0 = ci.exports;
const n0 = {
  components: {
    IconRecast: X1,
    TimeCurrent: t0,
    TimeTotal: i0
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      emptyHeight: 8,
      height: 40,
      width: 300,
      widthHover: 0
    };
  },
  computed: {
    audio() {
      return this.store.state.audio;
    },
    currentTime() {
      return this.store.state.currentTime;
    },
    duration() {
      return this.store.state.duration;
    },
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    isLegacy() {
      return this.store.state.isLegacy;
    },
    loaded() {
      return this.store.state.loaded;
    },
    isNormal() {
      return this.store.state.size === "size-normal" && !this.store.state.isLegacy;
    },
    peaks() {
      if (!this.waveform)
        return !1;
      const t = Math.max(
        Math.round(this.waveform.length / this.width * 2),
        1
      ), e = q1.resample(this.waveform, t), r = Math.max.apply(null, e), s = at().domain([0, r / 3200]).range([this.height / 2.75, 0]), i = at().domain([0, e.length]).rangeRound([0, this.width]), a = e.map((f, o) => [i(o), Math.round(s(f / 3200))]), l = a.map((f) => [f[0], this.height - f[1]]).reverse();
      return Ka().curve(Ws)(a.concat(l));
    },
    size() {
      return this.store.state.size;
    },
    uid() {
      return this.store.state.episode.legacy_token || this.store.state.episode.id;
    },
    waveform() {
      return this.store.state.waveform;
    },
    widthLoader() {
      return Math.floor(this.loaded * this.width);
    },
    widthTime() {
      return Math.floor(this.currentTime / this.duration * this.width);
    }
  },
  watch: {
    "store.state.size"(t) {
      this.resize();
    },
    "store.state.waveform"(t) {
      this.resize();
    }
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.setHeight(), this.setWidth();
  },
  methods: {
    attachListeners() {
      document.addEventListener("mousemove", this.move), document.addEventListener("touchmove", this.move), document.addEventListener("mouseup", this.stop), document.addEventListener("touchend", this.stop);
    },
    attachHoverListeners() {
      document.addEventListener("mousemove", this.hoverMove);
    },
    detachListeners() {
      document.removeEventListener("mousemove", this.move), document.removeEventListener("touchmove", this.move), document.removeEventListener("mouseup", this.stop), document.removeEventListener("touchend", this.stop);
    },
    detachHoverListeners() {
      document.removeEventListener("mousemove", this.hoverMove);
    },
    getOffset(t) {
      return Math.min(1, Math.max((t - this.left) / this.width, 0));
    },
    getTouchPageX(t) {
      return t.touches[0] && t.touches[0].pageX ? t.touches[0].pageX : null;
    },
    hoverMove(t) {
      this.setHoverOffset(t.pageX || this.getTouchPageX(t));
    },
    hoverStart(t) {
      !this.epi.enclosure_url || (this.attachHoverListeners(), this.setBounds(t), this.setHoverOffset(t.pageX || this.getTouchPageX(t)));
    },
    hoverStop(t) {
      this.detachHoverListeners();
    },
    move(t) {
      this.setOffset(t.pageX || this.getTouchPageX(t));
    },
    recast(t) {
      const e = Qe.url(this.widthHover * this.store.state.duration);
      window.open(
        `https://recast.simplecast.xyz/${this.uid}?t=${e}`,
        "simplecast-recast"
      );
    },
    setBounds(t) {
      const e = this.$refs.scrubberWaveform.getBoundingClientRect(), r = window.pageXOffset;
      this.left = e.left + r;
    },
    setHoverOffset(t) {
      const e = this.getOffset(t);
      this.widthHover = e;
    },
    setOffset(t) {
      const e = this.getOffset(t) * this.scaledWidth();
      this.store.setCurrentTime(e * this.store.state.duration), this.store.setAudioCurrentTime(e * this.store.state.duration);
    },
    start(t) {
      !this.epi.enclosure_url || (this.store.setIsScrubbing(!0), this.attachListeners(), this.setBounds(t), this.setOffset(t.pageX || this.getTouchPageX(t)));
    },
    stop(t) {
      this.store.setIsScrubbing(!1), this.detachListeners();
    },
    resize() {
      this.setHeight(), this.setWidth();
    },
    setHeight() {
      this.height = this.$refs.scrubberWaveform.clientHeight;
    },
    setWidth() {
      this.width = this.$refs.scrubberWaveform.getBoundingClientRect().width * this.scaledWidth();
    },
    scaledSize() {
      const t = window.innerHeight;
      return this.isNormal && t < 200 ? t / 200 : 1;
    },
    scaledWidth() {
      const t = window.innerHeight;
      if (this.isNormal && t < 200) {
        const e = window.innerWidth, r = e * this.scaledSize();
        return e / r;
      }
      return 1;
    }
  }
};
var li = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "scrubberWaveform", staticClass: "scrubber-waveform", class: { dark: e.isDark, disabled: !e.epi.enclosure_url }, on: { mousedown: function(s) {
    return s.preventDefault(), e.start.apply(null, arguments);
  }, mouseout: function(s) {
    return s.preventDefault(), e.hoverStop.apply(null, arguments);
  }, mouseover: function(s) {
    return s.preventDefault(), e.hoverStart.apply(null, arguments);
  }, mouseup: function(s) {
    return s.preventDefault(), e.stop.apply(null, arguments);
  }, touchstart: function(s) {
    return s.preventDefault(), e.start.apply(null, arguments);
  }, touchend: function(s) {
    return s.preventDefault(), e.stop.apply(null, arguments);
  } } }, [e.epi ? r("div", [r("TimeCurrent", { attrs: { store: e.store } }), r("TimeTotal", { attrs: { store: e.store } }), r("svg", { staticClass: "scrubber-time", class: { "no-waveform": !e.waveform }, attrs: { height: e.height, width: e.widthTime, "aria-hidden": "true" } }, [e.waveform ? r("path", { attrs: { d: e.peaks } }) : r("rect", { attrs: { height: e.emptyHeight, width: e.widthTime, y: e.height / 2 - e.emptyHeight / 2 } })]), e.isLegacy ? e._e() : r("div", { staticClass: "scrubber-hover" }, [e.size !== "size-mini" ? r("div", { staticClass: "scrubber-hover-recast", style: { left: `${e.widthHover * 100}%` }, on: { mousedown: function(s) {
    return s.preventDefault(), s.stopPropagation(), e.recast.apply(null, arguments);
  }, touchstart: function(s) {
    return s.preventDefault(), s.stopPropagation(), e.recast.apply(null, arguments);
  } } }, [e._v(" Recast "), r("IconRecast")], 1) : e._e(), r("svg", { class: { "no-waveform": !e.waveform }, attrs: { height: e.height, width: `${e.widthHover * 100}%`, "aria-hidden": "true" } }, [e.waveform ? r("path", { attrs: { d: e.peaks } }) : r("rect", { attrs: { height: e.emptyHeight, width: e.widthLoader, y: e.height / 2 - e.emptyHeight / 2 } })])]), r("svg", { staticClass: "scrubber-loader", class: { "no-waveform": !e.waveform }, attrs: { height: e.height, width: e.widthLoader, "aria-hidden": "true" } }, [e.waveform ? r("path", { attrs: { d: e.peaks } }) : r("rect", { attrs: { height: e.emptyHeight, width: e.widthLoader, y: e.height / 2 - e.emptyHeight / 2 } })]), r("svg", { staticClass: "scrubber-bg", class: { "no-waveform": !e.waveform }, attrs: { height: e.height, "aria-hidden": "true" } }, [e.waveform ? r("path", { attrs: { d: e.peaks } }) : r("rect", { attrs: { height: e.emptyHeight, y: e.height / 2 - e.emptyHeight / 2, width: "100%" } })])], 1) : r("div", { class: { "waveform-placeholder": !0, [e.size]: e.size }, attrs: { "aria-hidden": "true" } })]);
}, o0 = [];
li._withStripped = !0;
var ui = /* @__PURE__ */ B(
  n0,
  li,
  o0,
  !1,
  null,
  "dcc0c261",
  null,
  null
);
ui.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Waveform.vue";
const a0 = ui.exports;
const c0 = {
  components: {
    Waveform: a0
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      left: 0,
      width: 0
    };
  },
  computed: {
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    },
    scrubberStyles() {
      let t = 1;
      return this.size === "size-mini" && (this.store.state.showShare === !0 || this.store.state.showSubscribe === !0) && (t = 0), {
        opacity: t
      };
    },
    showShare() {
      return this.store.state.showShare;
    },
    showSubscribe() {
      return this.store.state.showSubscribe;
    }
  }
};
var fi = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "scrubber", staticClass: "scrubber", class: { dark: e.isDark, [e.size]: e.size }, style: e.scrubberStyles }, [r("Waveform", { attrs: { store: e.store } })], 1);
}, l0 = [];
fi._withStripped = !0;
var Ai = /* @__PURE__ */ B(
  c0,
  fi,
  l0,
  !1,
  null,
  "1b46c092",
  null,
  null
);
Ai.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Scrubber.vue";
const hi = Ai.exports;
const u0 = {
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    },
    isDisabled() {
      return !this.epi || !this.epi.id || this.epi.is_hidden;
    },
    shareOpen() {
      return this.store.state.showShare;
    }
  },
  methods: {
    toggleShare() {
      this.store.setShowShare(!this.store.state.showShare);
    }
  }
};
var di = function() {
  var e = this, r = e._self._c;
  return r("button", { class: {
    "controls-share": !0,
    dark: e.isDark,
    [e.size]: e.size,
    disabled: e.isDisabled,
    open: e.shareOpen
  }, attrs: { disabled: e.isDisabled, "aria-label": e.store.state.showShare ? "Close Share" : "Open Share", "aria-expanded": e.shareOpen ? "true" : "false" }, on: { click: e.toggleShare } }, [r("span", { staticClass: "menu-text" }, [e._v("Share")])]);
}, f0 = [];
di._withStripped = !0;
var pi = /* @__PURE__ */ B(
  u0,
  di,
  f0,
  !1,
  null,
  "f212185e",
  null,
  null
);
pi.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Share.vue";
const gi = pi.exports, A0 = {};
var Ei = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { width: "14px", height: "6px", viewBox: "0 0 14 6", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { d: "M0,0 L14,0 L14,1.75 L0,1.75 L0,0 Z M0,3.5 L8.75,3.5 L8.75,5.25 L0,5.25 L0,3.5 Z" } })]);
}, h0 = [];
Ei._withStripped = !0;
var Ci = /* @__PURE__ */ B(
  A0,
  Ei,
  h0,
  !1,
  null,
  null,
  null,
  null
);
Ci.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/share.vue";
const d0 = Ci.exports;
const p0 = {
  components: { IconShare: d0 },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    },
    isDisabled() {
      return !this.epi || !this.epi.id || this.epi.is_hidden;
    },
    subscribeOpen() {
      return this.store.state.showSubscribe;
    }
  },
  methods: {
    toggleSubscribe() {
      this.store.setShowSubscribe(!this.store.state.showSubscribe);
    }
  }
};
var mi = function() {
  var e = this, r = e._self._c;
  return r("button", { class: {
    "controls-subscribe": !0,
    dark: e.isDark,
    [e.size]: e.size,
    disabled: e.isDisabled,
    open: e.subscribeOpen
  }, attrs: { disabled: e.isDisabled, "aria-label": e.size === "size-mini" ? "Open Player Settings" : "Open Subscribe", "aria-expanded": e.subscribeOpen ? "true" : "false" }, on: { click: e.toggleSubscribe } }, [r("IconShare"), e._v(" "), r("span", { staticClass: "menu-icon" }), r("span", { staticClass: "menu-text" }, [e._v("Subscribe")])], 1);
}, g0 = [];
mi._withStripped = !0;
var Bi = /* @__PURE__ */ B(
  p0,
  mi,
  g0,
  !1,
  null,
  "c4d15af5",
  null,
  null
);
Bi.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Subscribe.vue";
const Ii = Bi.exports;
const E0 = {
  components: {
    Artwork: lt,
    Forward: xs,
    Rewind: Ls,
    Speed: er,
    MetaInfo: ut,
    PlayPause: Hs,
    Privacy: Ns,
    Scrubber: hi,
    Share: gi,
    Subscribe: Ii
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    epi() {
      return this.store.state.episode;
    },
    showShareSubButtons() {
      return !this.store.state.hideShareSubscribeButtons;
    },
    hideShareSubscribeButtons() {
      return this.store.state.hideShareSubscribeButtons;
    },
    loaded() {
      return this.store.state.isLoaded;
    },
    size() {
      return this.store.state.size;
    }
  }
};
var vi = function() {
  var e = this, r = e._self._c;
  return e.loaded ? r("div", { staticClass: "controls", class: { [e.size]: e.size } }, [e.size !== "size-mini" ? r("MetaInfo", { attrs: { store: e.store } }) : e._e(), r("div", { staticClass: "player-controls" }, [r("PlayPause", { attrs: { store: e.store } }), r("div", { class: {
    "scrubber-timer": !0,
    disabled: !e.epi || !e.epi.enclosure_url
  } }, [r("Scrubber", { attrs: { store: e.store } }), r("div", { staticClass: "controls-share-subscribe" }, [e.hideShareSubscribeButtons ? e._e() : r("Privacy", { attrs: { store: e.store } }), e.showShareSubButtons ? r("Share", { attrs: { store: e.store } }) : e._e(), e.showShareSubButtons ? r("Subscribe", { attrs: { store: e.store } }) : e._e()], 1), r("div", { staticClass: "left" }, [r("Speed", { attrs: { store: e.store } })], 1), r("div", { staticClass: "middle" }, [e.epi ? r("Rewind", { attrs: { store: e.store } }) : e._e(), r("PlayPause", { attrs: { store: e.store } }), e.epi ? r("Forward", { attrs: { store: e.store } }) : e._e()], 1), r("div", { staticClass: "right" }, [e.hideShareSubscribeButtons ? e._e() : r("Privacy", { attrs: { store: e.store } }), e.showShareSubButtons ? r("Share", { attrs: { store: e.store } }) : e._e(), e.showShareSubButtons ? r("Subscribe", { attrs: { store: e.store } }) : e._e(), r("Artwork", { attrs: { store: e.store } })], 1)], 1)], 1)], 1) : e._e();
}, C0 = [];
vi._withStripped = !0;
var wi = /* @__PURE__ */ B(
  E0,
  vi,
  C0,
  !1,
  null,
  "a69582cf",
  null,
  null
);
wi.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/PlayerMainControls.vue";
const m0 = wi.exports;
const B0 = {
  components: {
    Audio: hs,
    Logo: Cs,
    PlayerMainArtworkMeta: pa,
    PlayerMainControls: m0
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    isDark() {
      return this.store.state.isDark;
    },
    showBranding() {
      return this.store.state.podcast.branding === "simplecast";
    },
    playerStyles() {
      return {
        background: this.store.state.color
      };
    },
    showSubscribe() {
      return this.store.state.showSubscribe;
    },
    size() {
      return this.store.state.size;
    }
  }
};
var Qi = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "main", style: e.playerStyles }, [r("div", { class: [
    "main-wrap",
    { hide: e.showSubscribe && e.size !== "size-mini" },
    { dark: e.isDark },
    { [e.size]: e.size }
  ] }, [r("Audio", { attrs: { store: e.store } }), e.showBranding ? r("Logo", { attrs: { store: e.store } }) : e._e(), r("PlayerMainArtworkMeta", { attrs: { store: e.store } }), r("PlayerMainControls", { attrs: { store: e.store } })], 1)]);
}, I0 = [];
Qi._withStripped = !0;
var Si = /* @__PURE__ */ B(
  B0,
  Qi,
  I0,
  !1,
  null,
  "b55083c2",
  null,
  null
);
Si.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/PlayerMain.vue";
const v0 = Si.exports;
function ki(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: yi } = Object.prototype, { getPrototypeOf: nr } = Object, or = ((t) => (e) => {
  const r = yi.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ne = (t) => (t = t.toLowerCase(), (e) => or(e) === t), ft = (t) => (e) => typeof e === t, { isArray: xe } = Array, Oe = ft("undefined");
function w0(t) {
  return t !== null && !Oe(t) && t.constructor !== null && !Oe(t.constructor) && pe(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Ji = ne("ArrayBuffer");
function Q0(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Ji(t.buffer), e;
}
const S0 = ft("string"), pe = ft("function"), xi = ft("number"), ar = (t) => t !== null && typeof t == "object", k0 = (t) => t === !0 || t === !1, Xe = (t) => {
  if (or(t) !== "object")
    return !1;
  const e = nr(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, y0 = ne("Date"), J0 = ne("File"), x0 = ne("Blob"), b0 = ne("FileList"), M0 = (t) => ar(t) && pe(t.pipe), T0 = (t) => {
  const e = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || yi.call(t) === e || pe(t.toString) && t.toString() === e);
}, R0 = ne("URLSearchParams"), L0 = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ze(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, i;
  if (typeof t != "object" && (t = [t]), xe(t))
    for (s = 0, i = t.length; s < i; s++)
      e.call(null, t[s], s, t);
  else {
    const a = r ? Object.getOwnPropertyNames(t) : Object.keys(t), l = a.length;
    let f;
    for (s = 0; s < l; s++)
      f = a[s], e.call(null, t[f], f, t);
  }
}
function bi(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let s = r.length, i;
  for (; s-- > 0; )
    if (i = r[s], e === i.toLowerCase())
      return i;
  return null;
}
const Mi = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Ti = (t) => !Oe(t) && t !== Mi;
function Zt() {
  const { caseless: t } = Ti(this) && this || {}, e = {}, r = (s, i) => {
    const a = t && bi(e, i) || i;
    Xe(e[a]) && Xe(s) ? e[a] = Zt(e[a], s) : Xe(s) ? e[a] = Zt({}, s) : xe(s) ? e[a] = s.slice() : e[a] = s;
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && ze(arguments[s], r);
  return e;
}
const U0 = (t, e, r, { allOwnKeys: s } = {}) => (ze(e, (i, a) => {
  r && pe(i) ? t[a] = ki(i, r) : t[a] = i;
}, { allOwnKeys: s }), t), D0 = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), P0 = (t, e, r, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, O0 = (t, e, r, s) => {
  let i, a, l;
  const f = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (i = Object.getOwnPropertyNames(t), a = i.length; a-- > 0; )
      l = i[a], (!s || s(l, t, e)) && !f[l] && (e[l] = t[l], f[l] = !0);
    t = r !== !1 && nr(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, _0 = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const s = t.indexOf(e, r);
  return s !== -1 && s === r;
}, z0 = (t) => {
  if (!t)
    return null;
  if (xe(t))
    return t;
  let e = t.length;
  if (!xi(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, F0 = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && nr(Uint8Array)), Y0 = (t, e) => {
  const s = (t && t[Symbol.iterator]).call(t);
  let i;
  for (; (i = s.next()) && !i.done; ) {
    const a = i.value;
    e.call(t, a[0], a[1]);
  }
}, H0 = (t, e) => {
  let r;
  const s = [];
  for (; (r = t.exec(e)) !== null; )
    s.push(r);
  return s;
}, j0 = ne("HTMLFormElement"), K0 = (t) => t.toLowerCase().replace(
  /[_-\s]([a-z\d])(\w*)/g,
  function(r, s, i) {
    return s.toUpperCase() + i;
  }
), Dr = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), N0 = ne("RegExp"), Ri = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), s = {};
  ze(r, (i, a) => {
    e(i, a, t) !== !1 && (s[a] = i);
  }), Object.defineProperties(t, s);
}, G0 = (t) => {
  Ri(t, (e, r) => {
    if (pe(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const s = t[r];
    if (!!pe(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Z0 = (t, e) => {
  const r = {}, s = (i) => {
    i.forEach((a) => {
      r[a] = !0;
    });
  };
  return xe(t) ? s(t) : s(String(t).split(e)), r;
}, W0 = () => {
}, V0 = (t, e) => (t = +t, Number.isFinite(t) ? t : e), X0 = (t) => {
  const e = new Array(10), r = (s, i) => {
    if (ar(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[i] = s;
        const a = xe(s) ? [] : {};
        return ze(s, (l, f) => {
          const o = r(l, i + 1);
          !Oe(o) && (a[f] = o);
        }), e[i] = void 0, a;
      }
    }
    return s;
  };
  return r(t, 0);
}, p = {
  isArray: xe,
  isArrayBuffer: Ji,
  isBuffer: w0,
  isFormData: T0,
  isArrayBufferView: Q0,
  isString: S0,
  isNumber: xi,
  isBoolean: k0,
  isObject: ar,
  isPlainObject: Xe,
  isUndefined: Oe,
  isDate: y0,
  isFile: J0,
  isBlob: x0,
  isRegExp: N0,
  isFunction: pe,
  isStream: M0,
  isURLSearchParams: R0,
  isTypedArray: F0,
  isFileList: b0,
  forEach: ze,
  merge: Zt,
  extend: U0,
  trim: L0,
  stripBOM: D0,
  inherits: P0,
  toFlatObject: O0,
  kindOf: or,
  kindOfTest: ne,
  endsWith: _0,
  toArray: z0,
  forEachEntry: Y0,
  matchAll: H0,
  isHTMLForm: j0,
  hasOwnProperty: Dr,
  hasOwnProp: Dr,
  reduceDescriptors: Ri,
  freezeMethods: G0,
  toObjectSet: Z0,
  toCamelCase: K0,
  noop: W0,
  toFiniteNumber: V0,
  findKey: bi,
  global: Mi,
  isContextDefined: Ti,
  toJSONObject: X0
};
function T(t, e, r, s, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), s && (this.request = s), i && (this.response = i);
}
p.inherits(T, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: p.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Li = T.prototype, Ui = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((t) => {
  Ui[t] = { value: t };
});
Object.defineProperties(T, Ui);
Object.defineProperty(Li, "isAxiosError", { value: !0 });
T.from = (t, e, r, s, i, a) => {
  const l = Object.create(Li);
  return p.toFlatObject(t, l, function(o) {
    return o !== Error.prototype;
  }, (f) => f !== "isAxiosError"), T.call(l, t.message, e, r, s, i), l.cause = t, l.name = t.name, a && Object.assign(l, a), l;
};
var q0 = typeof self == "object" ? self.FormData : window.FormData;
const $0 = q0;
function Wt(t) {
  return p.isPlainObject(t) || p.isArray(t);
}
function Di(t) {
  return p.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Pr(t, e, r) {
  return t ? t.concat(e).map(function(i, a) {
    return i = Di(i), !r && a ? "[" + i + "]" : i;
  }).join(r ? "." : "") : e;
}
function ec(t) {
  return p.isArray(t) && !t.some(Wt);
}
const tc = p.toFlatObject(p, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function rc(t) {
  return t && p.isFunction(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator];
}
function At(t, e, r) {
  if (!p.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new ($0 || FormData)(), r = p.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(C, S) {
    return !p.isUndefined(S[C]);
  });
  const s = r.metaTokens, i = r.visitor || c, a = r.dots, l = r.indexes, o = (r.Blob || typeof Blob < "u" && Blob) && rc(e);
  if (!p.isFunction(i))
    throw new TypeError("visitor must be a function");
  function n(h) {
    if (h === null)
      return "";
    if (p.isDate(h))
      return h.toISOString();
    if (!o && p.isBlob(h))
      throw new T("Blob is not supported. Use a Buffer instead.");
    return p.isArrayBuffer(h) || p.isTypedArray(h) ? o && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, C, S) {
    let x = h;
    if (h && !S && typeof h == "object") {
      if (p.endsWith(C, "{}"))
        C = s ? C : C.slice(0, -2), h = JSON.stringify(h);
      else if (p.isArray(h) && ec(h) || p.isFileList(h) || p.endsWith(C, "[]") && (x = p.toArray(h)))
        return C = Di(C), x.forEach(function(P, v) {
          !(p.isUndefined(P) || P === null) && e.append(
            l === !0 ? Pr([C], v, a) : l === null ? C : C + "[]",
            n(P)
          );
        }), !1;
    }
    return Wt(h) ? !0 : (e.append(Pr(S, C, a), n(h)), !1);
  }
  const u = [], A = Object.assign(tc, {
    defaultVisitor: c,
    convertValue: n,
    isVisitable: Wt
  });
  function d(h, C) {
    if (!p.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + C.join("."));
      u.push(h), p.forEach(h, function(x, D) {
        (!(p.isUndefined(x) || x === null) && i.call(
          e,
          x,
          p.isString(D) ? D.trim() : D,
          C,
          A
        )) === !0 && d(x, C ? C.concat(D) : [D]);
      }), u.pop();
    }
  }
  if (!p.isObject(t))
    throw new TypeError("data must be an object");
  return d(t), e;
}
function Or(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function cr(t, e) {
  this._pairs = [], t && At(t, this, e);
}
const Pi = cr.prototype;
Pi.append = function(e, r) {
  this._pairs.push([e, r]);
};
Pi.toString = function(e) {
  const r = e ? function(s) {
    return e.call(this, s, Or);
  } : Or;
  return this._pairs.map(function(i) {
    return r(i[0]) + "=" + r(i[1]);
  }, "").join("&");
};
function sc(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Oi(t, e, r) {
  if (!e)
    return t;
  const s = r && r.encode || sc, i = r && r.serialize;
  let a;
  if (i ? a = i(e, r) : a = p.isURLSearchParams(e) ? e.toString() : new cr(e, r).toString(s), a) {
    const l = t.indexOf("#");
    l !== -1 && (t = t.slice(0, l)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class ic {
  constructor() {
    this.handlers = [];
  }
  use(e, r, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    p.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const _r = ic, _i = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, nc = typeof URLSearchParams < "u" ? URLSearchParams : cr, oc = FormData, ac = (() => {
  let t;
  return typeof navigator < "u" && ((t = navigator.product) === "ReactNative" || t === "NativeScript" || t === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), cc = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), $ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: nc,
    FormData: oc,
    Blob
  },
  isStandardBrowserEnv: ac,
  isStandardBrowserWebWorkerEnv: cc,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function lc(t, e) {
  return At(t, new $.classes.URLSearchParams(), Object.assign({
    visitor: function(r, s, i, a) {
      return $.isNode && p.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function uc(t) {
  return p.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function fc(t) {
  const e = {}, r = Object.keys(t);
  let s;
  const i = r.length;
  let a;
  for (s = 0; s < i; s++)
    a = r[s], e[a] = t[a];
  return e;
}
function zi(t) {
  function e(r, s, i, a) {
    let l = r[a++];
    const f = Number.isFinite(+l), o = a >= r.length;
    return l = !l && p.isArray(i) ? i.length : l, o ? (p.hasOwnProp(i, l) ? i[l] = [i[l], s] : i[l] = s, !f) : ((!i[l] || !p.isObject(i[l])) && (i[l] = []), e(r, s, i[l], a) && p.isArray(i[l]) && (i[l] = fc(i[l])), !f);
  }
  if (p.isFormData(t) && p.isFunction(t.entries)) {
    const r = {};
    return p.forEachEntry(t, (s, i) => {
      e(uc(s), i, r, 0);
    }), r;
  }
  return null;
}
const Ac = {
  "Content-Type": void 0
};
function hc(t, e, r) {
  if (p.isString(t))
    try {
      return (e || JSON.parse)(t), p.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (r || JSON.stringify)(t);
}
const ht = {
  transitional: _i,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, r) {
    const s = r.getContentType() || "", i = s.indexOf("application/json") > -1, a = p.isObject(e);
    if (a && p.isHTMLForm(e) && (e = new FormData(e)), p.isFormData(e))
      return i && i ? JSON.stringify(zi(e)) : e;
    if (p.isArrayBuffer(e) || p.isBuffer(e) || p.isStream(e) || p.isFile(e) || p.isBlob(e))
      return e;
    if (p.isArrayBufferView(e))
      return e.buffer;
    if (p.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let f;
    if (a) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return lc(e, this.formSerializer).toString();
      if ((f = p.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const o = this.env && this.env.FormData;
        return At(
          f ? { "files[]": e } : e,
          o && new o(),
          this.formSerializer
        );
      }
    }
    return a || i ? (r.setContentType("application/json", !1), hc(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || ht.transitional, s = r && r.forcedJSONParsing, i = this.responseType === "json";
    if (e && p.isString(e) && (s && !this.responseType || i)) {
      const l = !(r && r.silentJSONParsing) && i;
      try {
        return JSON.parse(e);
      } catch (f) {
        if (l)
          throw f.name === "SyntaxError" ? T.from(f, T.ERR_BAD_RESPONSE, this, null, this.response) : f;
      }
    }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: $.classes.FormData,
    Blob: $.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
p.forEach(["delete", "get", "head"], function(e) {
  ht.headers[e] = {};
});
p.forEach(["post", "put", "patch"], function(e) {
  ht.headers[e] = p.merge(Ac);
});
const lr = ht, dc = p.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), pc = (t) => {
  const e = {};
  let r, s, i;
  return t && t.split(`
`).forEach(function(l) {
    i = l.indexOf(":"), r = l.substring(0, i).trim().toLowerCase(), s = l.substring(i + 1).trim(), !(!r || e[r] && dc[r]) && (r === "set-cookie" ? e[r] ? e[r].push(s) : e[r] = [s] : e[r] = e[r] ? e[r] + ", " + s : s);
  }), e;
}, zr = Symbol("internals");
function Me(t) {
  return t && String(t).trim().toLowerCase();
}
function qe(t) {
  return t === !1 || t == null ? t : p.isArray(t) ? t.map(qe) : String(t);
}
function gc(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = r.exec(t); )
    e[s[1]] = s[2];
  return e;
}
function Ec(t) {
  return /^[-_a-zA-Z]+$/.test(t.trim());
}
function Fr(t, e, r, s) {
  if (p.isFunction(s))
    return s.call(this, e, r);
  if (!!p.isString(e)) {
    if (p.isString(s))
      return e.indexOf(s) !== -1;
    if (p.isRegExp(s))
      return s.test(e);
  }
}
function Cc(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, s) => r.toUpperCase() + s);
}
function mc(t, e) {
  const r = p.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + r, {
      value: function(i, a, l) {
        return this[s].call(this, e, i, a, l);
      },
      configurable: !0
    });
  });
}
class dt {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, s) {
    const i = this;
    function a(f, o, n) {
      const c = Me(o);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = p.findKey(i, c);
      (!u || i[u] === void 0 || n === !0 || n === void 0 && i[u] !== !1) && (i[u || o] = qe(f));
    }
    const l = (f, o) => p.forEach(f, (n, c) => a(n, c, o));
    return p.isPlainObject(e) || e instanceof this.constructor ? l(e, r) : p.isString(e) && (e = e.trim()) && !Ec(e) ? l(pc(e), r) : e != null && a(r, e, s), this;
  }
  get(e, r) {
    if (e = Me(e), e) {
      const s = p.findKey(this, e);
      if (s) {
        const i = this[s];
        if (!r)
          return i;
        if (r === !0)
          return gc(i);
        if (p.isFunction(r))
          return r.call(this, i, s);
        if (p.isRegExp(r))
          return r.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = Me(e), e) {
      const s = p.findKey(this, e);
      return !!(s && (!r || Fr(this, this[s], s, r)));
    }
    return !1;
  }
  delete(e, r) {
    const s = this;
    let i = !1;
    function a(l) {
      if (l = Me(l), l) {
        const f = p.findKey(s, l);
        f && (!r || Fr(s, s[f], f, r)) && (delete s[f], i = !0);
      }
    }
    return p.isArray(e) ? e.forEach(a) : a(e), i;
  }
  clear() {
    return Object.keys(this).forEach(this.delete.bind(this));
  }
  normalize(e) {
    const r = this, s = {};
    return p.forEach(this, (i, a) => {
      const l = p.findKey(s, a);
      if (l) {
        r[l] = qe(i), delete r[a];
        return;
      }
      const f = e ? Cc(a) : String(a).trim();
      f !== a && delete r[a], r[f] = qe(i), s[f] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return p.forEach(this, (s, i) => {
      s != null && s !== !1 && (r[i] = e && p.isArray(s) ? s.join(", ") : s);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const s = new this(e);
    return r.forEach((i) => s.set(i)), s;
  }
  static accessor(e) {
    const s = (this[zr] = this[zr] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function a(l) {
      const f = Me(l);
      s[f] || (mc(i, l), s[f] = !0);
    }
    return p.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
dt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent"]);
p.freezeMethods(dt.prototype);
p.freezeMethods(dt);
const ie = dt;
function kt(t, e) {
  const r = this || lr, s = e || r, i = ie.from(s.headers);
  let a = s.data;
  return p.forEach(t, function(f) {
    a = f.call(r, a, i.normalize(), e ? e.status : void 0);
  }), i.normalize(), a;
}
function Fi(t) {
  return !!(t && t.__CANCEL__);
}
function Fe(t, e, r) {
  T.call(this, t == null ? "canceled" : t, T.ERR_CANCELED, e, r), this.name = "CanceledError";
}
p.inherits(Fe, T, {
  __CANCEL__: !0
});
const Bc = null;
function Ic(t, e, r) {
  const s = r.config.validateStatus;
  !r.status || !s || s(r.status) ? t(r) : e(new T(
    "Request failed with status code " + r.status,
    [T.ERR_BAD_REQUEST, T.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const vc = $.isStandardBrowserEnv ? function() {
  return {
    write: function(r, s, i, a, l, f) {
      const o = [];
      o.push(r + "=" + encodeURIComponent(s)), p.isNumber(i) && o.push("expires=" + new Date(i).toGMTString()), p.isString(a) && o.push("path=" + a), p.isString(l) && o.push("domain=" + l), f === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read: function(r) {
      const s = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
      return s ? decodeURIComponent(s[3]) : null;
    },
    remove: function(r) {
      this.write(r, "", Date.now() - 864e5);
    }
  };
}() : function() {
  return {
    write: function() {
    },
    read: function() {
      return null;
    },
    remove: function() {
    }
  };
}();
function wc(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Qc(t, e) {
  return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Yi(t, e) {
  return t && !wc(e) ? Qc(t, e) : e;
}
const Sc = $.isStandardBrowserEnv ? function() {
  const e = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
  let s;
  function i(a) {
    let l = a;
    return e && (r.setAttribute("href", l), l = r.href), r.setAttribute("href", l), {
      href: r.href,
      protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
      host: r.host,
      search: r.search ? r.search.replace(/^\?/, "") : "",
      hash: r.hash ? r.hash.replace(/^#/, "") : "",
      hostname: r.hostname,
      port: r.port,
      pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
    };
  }
  return s = i(window.location.href), function(l) {
    const f = p.isString(l) ? i(l) : l;
    return f.protocol === s.protocol && f.host === s.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function kc(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function yc(t, e) {
  t = t || 10;
  const r = new Array(t), s = new Array(t);
  let i = 0, a = 0, l;
  return e = e !== void 0 ? e : 1e3, function(o) {
    const n = Date.now(), c = s[a];
    l || (l = n), r[i] = o, s[i] = n;
    let u = a, A = 0;
    for (; u !== i; )
      A += r[u++], u = u % t;
    if (i = (i + 1) % t, i === a && (a = (a + 1) % t), n - l < e)
      return;
    const d = c && n - c;
    return d ? Math.round(A * 1e3 / d) : void 0;
  };
}
function Yr(t, e) {
  let r = 0;
  const s = yc(50, 250);
  return (i) => {
    const a = i.loaded, l = i.lengthComputable ? i.total : void 0, f = a - r, o = s(f), n = a <= l;
    r = a;
    const c = {
      loaded: a,
      total: l,
      progress: l ? a / l : void 0,
      bytes: f,
      rate: o || void 0,
      estimated: o && l && n ? (l - a) / o : void 0,
      event: i
    };
    c[e ? "download" : "upload"] = !0, t(c);
  };
}
const Jc = typeof XMLHttpRequest < "u", xc = Jc && function(t) {
  return new Promise(function(r, s) {
    let i = t.data;
    const a = ie.from(t.headers).normalize(), l = t.responseType;
    let f;
    function o() {
      t.cancelToken && t.cancelToken.unsubscribe(f), t.signal && t.signal.removeEventListener("abort", f);
    }
    p.isFormData(i) && ($.isStandardBrowserEnv || $.isStandardBrowserWebWorkerEnv) && a.setContentType(!1);
    let n = new XMLHttpRequest();
    if (t.auth) {
      const d = t.auth.username || "", h = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(d + ":" + h));
    }
    const c = Yi(t.baseURL, t.url);
    n.open(t.method.toUpperCase(), Oi(c, t.params, t.paramsSerializer), !0), n.timeout = t.timeout;
    function u() {
      if (!n)
        return;
      const d = ie.from(
        "getAllResponseHeaders" in n && n.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? n.responseText : n.response,
        status: n.status,
        statusText: n.statusText,
        headers: d,
        config: t,
        request: n
      };
      Ic(function(x) {
        r(x), o();
      }, function(x) {
        s(x), o();
      }, C), n = null;
    }
    if ("onloadend" in n ? n.onloadend = u : n.onreadystatechange = function() {
      !n || n.readyState !== 4 || n.status === 0 && !(n.responseURL && n.responseURL.indexOf("file:") === 0) || setTimeout(u);
    }, n.onabort = function() {
      !n || (s(new T("Request aborted", T.ECONNABORTED, t, n)), n = null);
    }, n.onerror = function() {
      s(new T("Network Error", T.ERR_NETWORK, t, n)), n = null;
    }, n.ontimeout = function() {
      let h = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const C = t.transitional || _i;
      t.timeoutErrorMessage && (h = t.timeoutErrorMessage), s(new T(
        h,
        C.clarifyTimeoutError ? T.ETIMEDOUT : T.ECONNABORTED,
        t,
        n
      )), n = null;
    }, $.isStandardBrowserEnv) {
      const d = (t.withCredentials || Sc(c)) && t.xsrfCookieName && vc.read(t.xsrfCookieName);
      d && a.set(t.xsrfHeaderName, d);
    }
    i === void 0 && a.setContentType(null), "setRequestHeader" in n && p.forEach(a.toJSON(), function(h, C) {
      n.setRequestHeader(C, h);
    }), p.isUndefined(t.withCredentials) || (n.withCredentials = !!t.withCredentials), l && l !== "json" && (n.responseType = t.responseType), typeof t.onDownloadProgress == "function" && n.addEventListener("progress", Yr(t.onDownloadProgress, !0)), typeof t.onUploadProgress == "function" && n.upload && n.upload.addEventListener("progress", Yr(t.onUploadProgress)), (t.cancelToken || t.signal) && (f = (d) => {
      !n || (s(!d || d.type ? new Fe(null, t, n) : d), n.abort(), n = null);
    }, t.cancelToken && t.cancelToken.subscribe(f), t.signal && (t.signal.aborted ? f() : t.signal.addEventListener("abort", f)));
    const A = kc(c);
    if (A && $.protocols.indexOf(A) === -1) {
      s(new T("Unsupported protocol " + A + ":", T.ERR_BAD_REQUEST, t));
      return;
    }
    n.send(i || null);
  });
}, $e = {
  http: Bc,
  xhr: xc
};
p.forEach($e, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const bc = {
  getAdapter: (t) => {
    t = p.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, s;
    for (let i = 0; i < e && (r = t[i], !(s = p.isString(r) ? $e[r.toLowerCase()] : r)); i++)
      ;
    if (!s)
      throw s === !1 ? new T(
        `Adapter ${r} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        p.hasOwnProp($e, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`
      );
    if (!p.isFunction(s))
      throw new TypeError("adapter is not a function");
    return s;
  },
  adapters: $e
};
function yt(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Fe(null, t);
}
function Hr(t) {
  return yt(t), t.headers = ie.from(t.headers), t.data = kt.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), bc.getAdapter(t.adapter || lr.adapter)(t).then(function(s) {
    return yt(t), s.data = kt.call(
      t,
      t.transformResponse,
      s
    ), s.headers = ie.from(s.headers), s;
  }, function(s) {
    return Fi(s) || (yt(t), s && s.response && (s.response.data = kt.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = ie.from(s.response.headers))), Promise.reject(s);
  });
}
const jr = (t) => t instanceof ie ? t.toJSON() : t;
function Se(t, e) {
  e = e || {};
  const r = {};
  function s(n, c, u) {
    return p.isPlainObject(n) && p.isPlainObject(c) ? p.merge.call({ caseless: u }, n, c) : p.isPlainObject(c) ? p.merge({}, c) : p.isArray(c) ? c.slice() : c;
  }
  function i(n, c, u) {
    if (p.isUndefined(c)) {
      if (!p.isUndefined(n))
        return s(void 0, n, u);
    } else
      return s(n, c, u);
  }
  function a(n, c) {
    if (!p.isUndefined(c))
      return s(void 0, c);
  }
  function l(n, c) {
    if (p.isUndefined(c)) {
      if (!p.isUndefined(n))
        return s(void 0, n);
    } else
      return s(void 0, c);
  }
  function f(n, c, u) {
    if (u in e)
      return s(n, c);
    if (u in t)
      return s(void 0, n);
  }
  const o = {
    url: a,
    method: a,
    data: a,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: f,
    headers: (n, c) => i(jr(n), jr(c), !0)
  };
  return p.forEach(Object.keys(t).concat(Object.keys(e)), function(c) {
    const u = o[c] || i, A = u(t[c], e[c], c);
    p.isUndefined(A) && u !== f || (r[c] = A);
  }), r;
}
const Hi = "1.2.5", ur = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ur[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Kr = {};
ur.transitional = function(e, r, s) {
  function i(a, l) {
    return "[Axios v" + Hi + "] Transitional option '" + a + "'" + l + (s ? ". " + s : "");
  }
  return (a, l, f) => {
    if (e === !1)
      throw new T(
        i(l, " has been removed" + (r ? " in " + r : "")),
        T.ERR_DEPRECATED
      );
    return r && !Kr[l] && (Kr[l] = !0, console.warn(
      i(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, l, f) : !0;
  };
};
function Mc(t, e, r) {
  if (typeof t != "object")
    throw new T("options must be an object", T.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let i = s.length;
  for (; i-- > 0; ) {
    const a = s[i], l = e[a];
    if (l) {
      const f = t[a], o = f === void 0 || l(f, a, t);
      if (o !== !0)
        throw new T("option " + a + " must be " + o, T.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new T("Unknown option " + a, T.ERR_BAD_OPTION);
  }
}
const Vt = {
  assertOptions: Mc,
  validators: ur
}, ae = Vt.validators;
class ct {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new _r(),
      response: new _r()
    };
  }
  request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Se(this.defaults, r);
    const { transitional: s, paramsSerializer: i, headers: a } = r;
    s !== void 0 && Vt.assertOptions(s, {
      silentJSONParsing: ae.transitional(ae.boolean),
      forcedJSONParsing: ae.transitional(ae.boolean),
      clarifyTimeoutError: ae.transitional(ae.boolean)
    }, !1), i !== void 0 && Vt.assertOptions(i, {
      encode: ae.function,
      serialize: ae.function
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l;
    l = a && p.merge(
      a.common,
      a[r.method]
    ), l && p.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete a[h];
      }
    ), r.headers = ie.concat(l, a);
    const f = [];
    let o = !0;
    this.interceptors.request.forEach(function(C) {
      typeof C.runWhen == "function" && C.runWhen(r) === !1 || (o = o && C.synchronous, f.unshift(C.fulfilled, C.rejected));
    });
    const n = [];
    this.interceptors.response.forEach(function(C) {
      n.push(C.fulfilled, C.rejected);
    });
    let c, u = 0, A;
    if (!o) {
      const h = [Hr.bind(this), void 0];
      for (h.unshift.apply(h, f), h.push.apply(h, n), A = h.length, c = Promise.resolve(r); u < A; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    A = f.length;
    let d = r;
    for (u = 0; u < A; ) {
      const h = f[u++], C = f[u++];
      try {
        d = h(d);
      } catch (S) {
        C.call(this, S);
        break;
      }
    }
    try {
      c = Hr.call(this, d);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, A = n.length; u < A; )
      c = c.then(n[u++], n[u++]);
    return c;
  }
  getUri(e) {
    e = Se(this.defaults, e);
    const r = Yi(e.baseURL, e.url);
    return Oi(r, e.params, e.paramsSerializer);
  }
}
p.forEach(["delete", "get", "head", "options"], function(e) {
  ct.prototype[e] = function(r, s) {
    return this.request(Se(s || {}, {
      method: e,
      url: r,
      data: (s || {}).data
    }));
  };
});
p.forEach(["post", "put", "patch"], function(e) {
  function r(s) {
    return function(a, l, f) {
      return this.request(Se(f || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: l
      }));
    };
  }
  ct.prototype[e] = r(), ct.prototype[e + "Form"] = r(!0);
});
const et = ct;
class fr {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const s = this;
    this.promise.then((i) => {
      if (!s._listeners)
        return;
      let a = s._listeners.length;
      for (; a-- > 0; )
        s._listeners[a](i);
      s._listeners = null;
    }), this.promise.then = (i) => {
      let a;
      const l = new Promise((f) => {
        s.subscribe(f), a = f;
      }).then(i);
      return l.cancel = function() {
        s.unsubscribe(a);
      }, l;
    }, e(function(a, l, f) {
      s.reason || (s.reason = new Fe(a, l, f), r(s.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  static source() {
    let e;
    return {
      token: new fr(function(i) {
        e = i;
      }),
      cancel: e
    };
  }
}
const Tc = fr;
function Rc(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Lc(t) {
  return p.isObject(t) && t.isAxiosError === !0;
}
const Xt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Xt).forEach(([t, e]) => {
  Xt[e] = t;
});
const Uc = Xt;
function ji(t) {
  const e = new et(t), r = ki(et.prototype.request, e);
  return p.extend(r, et.prototype, e, { allOwnKeys: !0 }), p.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(i) {
    return ji(Se(t, i));
  }, r;
}
const z = ji(lr);
z.Axios = et;
z.CanceledError = Fe;
z.CancelToken = Tc;
z.isCancel = Fi;
z.VERSION = Hi;
z.toFormData = At;
z.AxiosError = T;
z.Cancel = z.CanceledError;
z.all = function(e) {
  return Promise.all(e);
};
z.spread = Rc;
z.isAxiosError = Lc;
z.mergeConfig = Se;
z.AxiosHeaders = ie;
z.formToJSON = (t) => zi(p.isHTMLForm(t) ? new FormData(t) : t);
z.HttpStatusCode = Uc;
z.default = z;
const Dc = z;
var Ee = {}, Jt = {}, xt = {}, bt = {}, pt = {}, Mt = {}, Pc = Tt(typeof Buffer < "u" && Buffer) || Tt(Ft.Buffer) || Tt(typeof window < "u" && window.Buffer) || Ft.Buffer;
function Tt(t) {
  return t && t.isBuffer && t;
}
var Oc = {}.toString, Ar = Array.isArray || function(t) {
  return Oc.call(t) == "[object Array]";
}, Rt = { exports: {} }, Nr;
function _c() {
  if (Nr)
    return Rt.exports;
  Nr = 1;
  var t = Z(), e = Rt.exports = r(0);
  e.alloc = r, e.concat = t.concat, e.from = s;
  function r(i) {
    return new Array(i);
  }
  function s(i) {
    if (!t.isBuffer(i) && t.isView(i))
      i = t.Uint8Array.from(i);
    else if (t.isArrayBuffer(i))
      i = new Uint8Array(i);
    else {
      if (typeof i == "string")
        return t.from.call(e, i);
      if (typeof i == "number")
        throw new TypeError('"value" argument must not be a number');
    }
    return Array.prototype.slice.call(i);
  }
  return Rt.exports;
}
var Lt = { exports: {} }, Gr;
function zc() {
  if (Gr)
    return Lt.exports;
  Gr = 1;
  var t = Z(), e = t.global, r = Lt.exports = t.hasBuffer ? s(0) : [];
  r.alloc = t.hasBuffer && e.alloc || s, r.concat = t.concat, r.from = i;
  function s(a) {
    return new e(a);
  }
  function i(a) {
    if (!t.isBuffer(a) && t.isView(a))
      a = t.Uint8Array.from(a);
    else if (t.isArrayBuffer(a))
      a = new Uint8Array(a);
    else {
      if (typeof a == "string")
        return t.from.call(r, a);
      if (typeof a == "number")
        throw new TypeError('"value" argument must not be a number');
    }
    return e.from && e.from.length !== 1 ? e.from(a) : new e(a);
  }
  return Lt.exports;
}
var Ut = { exports: {} }, Zr;
function Fc() {
  if (Zr)
    return Ut.exports;
  Zr = 1;
  var t = Z(), e = Ut.exports = t.hasArrayBuffer ? r(0) : [];
  e.alloc = r, e.concat = t.concat, e.from = s;
  function r(i) {
    return new Uint8Array(i);
  }
  function s(i) {
    if (t.isView(i)) {
      var a = i.byteOffset, l = i.byteLength;
      i = i.buffer, i.byteLength !== l && (i.slice ? i = i.slice(a, a + l) : (i = new Uint8Array(i), i.byteLength !== l && (i = Array.prototype.slice.call(i, a, a + l))));
    } else {
      if (typeof i == "string")
        return t.from.call(e, i);
      if (typeof i == "number")
        throw new TypeError('"value" argument must not be a number');
    }
    return new Uint8Array(i);
  }
  return Ut.exports;
}
var me = {}, gt = {};
gt.copy = jc;
gt.toString = Hc;
gt.write = Yc;
function Yc(t, e) {
  for (var r = this, s = e || (e |= 0), i = t.length, a = 0, l = 0; l < i; )
    a = t.charCodeAt(l++), a < 128 ? r[s++] = a : a < 2048 ? (r[s++] = 192 | a >>> 6, r[s++] = 128 | a & 63) : a < 55296 || a > 57343 ? (r[s++] = 224 | a >>> 12, r[s++] = 128 | a >>> 6 & 63, r[s++] = 128 | a & 63) : (a = (a - 55296 << 10 | t.charCodeAt(l++) - 56320) + 65536, r[s++] = 240 | a >>> 18, r[s++] = 128 | a >>> 12 & 63, r[s++] = 128 | a >>> 6 & 63, r[s++] = 128 | a & 63);
  return s - e;
}
function Hc(t, e, r) {
  var s = this, i = e | 0;
  r || (r = s.length);
  for (var a = "", l = 0; i < r; ) {
    if (l = s[i++], l < 128) {
      a += String.fromCharCode(l);
      continue;
    }
    (l & 224) === 192 ? l = (l & 31) << 6 | s[i++] & 63 : (l & 240) === 224 ? l = (l & 15) << 12 | (s[i++] & 63) << 6 | s[i++] & 63 : (l & 248) === 240 && (l = (l & 7) << 18 | (s[i++] & 63) << 12 | (s[i++] & 63) << 6 | s[i++] & 63), l >= 65536 ? (l -= 65536, a += String.fromCharCode((l >>> 10) + 55296, (l & 1023) + 56320)) : a += String.fromCharCode(l);
  }
  return a;
}
function jc(t, e, r, s) {
  var i;
  r || (r = 0), !s && s !== 0 && (s = this.length), e || (e = 0);
  var a = s - r;
  if (t === this && r < e && e < s)
    for (i = a - 1; i >= 0; i--)
      t[i + e] = this[i + r];
  else
    for (i = 0; i < a; i++)
      t[i + e] = this[i + r];
  return a;
}
var Wr;
function hr() {
  if (Wr)
    return me;
  Wr = 1;
  var t = gt;
  me.copy = a, me.slice = l, me.toString = f, me.write = o("write");
  var e = Z(), r = e.global, s = e.hasBuffer && "TYPED_ARRAY_SUPPORT" in r, i = s && !r.TYPED_ARRAY_SUPPORT;
  function a(n, c, u, A) {
    var d = e.isBuffer(this), h = e.isBuffer(n);
    if (d && h)
      return this.copy(n, c, u, A);
    if (!i && !d && !h && e.isView(this) && e.isView(n)) {
      var C = u || A != null ? l.call(this, u, A) : this;
      return n.set(C, c), C.length;
    } else
      return t.copy.call(this, n, c, u, A);
  }
  function l(n, c) {
    var u = this.slice || !i && this.subarray;
    if (u)
      return u.call(this, n, c);
    var A = e.alloc.call(this, c - n);
    return a.call(this, A, 0, n, c), A;
  }
  function f(n, c, u) {
    var A = !s && e.isBuffer(this) ? this.toString : t.toString;
    return A.apply(this, arguments);
  }
  function o(n) {
    return c;
    function c() {
      var u = this[n] || t[n];
      return u.apply(this, arguments);
    }
  }
  return me;
}
var Vr;
function Z() {
  return Vr || (Vr = 1, function(t) {
    var e = t.global = Pc, r = t.hasBuffer = e && !!e.isBuffer, s = t.hasArrayBuffer = typeof ArrayBuffer < "u", i = t.isArray = Ar;
    t.isArrayBuffer = s ? C : D;
    var a = t.isBuffer = r ? e.isBuffer : D, l = t.isView = s ? ArrayBuffer.isView || P("ArrayBuffer", "buffer") : D;
    t.alloc = A, t.concat = d, t.from = u;
    var f = t.Array = _c(), o = t.Buffer = zc(), n = t.Uint8Array = Fc(), c = t.prototype = hr();
    function u(v) {
      return typeof v == "string" ? S.call(this, v) : x(this).from(v);
    }
    function A(v) {
      return x(this).alloc(v);
    }
    function d(v, R) {
      R || (R = 0, Array.prototype.forEach.call(v, J));
      var H = this !== t && this || v[0], Q = A.call(H, R), I = 0;
      return Array.prototype.forEach.call(v, E), Q;
      function J(g) {
        R += g.length;
      }
      function E(g) {
        I += c.copy.call(g, Q, I);
      }
    }
    var h = P("ArrayBuffer");
    function C(v) {
      return v instanceof ArrayBuffer || h(v);
    }
    function S(v) {
      var R = v.length * 3, H = A.call(this, R), Q = c.write.call(H, v);
      return R !== Q && (H = c.slice.call(H, 0, Q)), H;
    }
    function x(v) {
      return a(v) ? o : l(v) ? n : i(v) ? f : r ? o : s ? n : f;
    }
    function D() {
      return !1;
    }
    function P(v, R) {
      return v = "[object " + v + "]", function(H) {
        return H != null && {}.toString.call(R ? H[R] : H) === v;
      };
    }
  }(Mt)), Mt;
}
pt.ExtBuffer = qt;
var Kc = Z();
function qt(t, e) {
  if (!(this instanceof qt))
    return new qt(t, e);
  this.buffer = Kc.from(t), this.type = e;
}
var Dt = {}, Xr;
function Nc() {
  if (Xr)
    return Dt;
  Xr = 1, Dt.setExtPackers = a;
  var t = Z(), e = t.global, r = t.Uint8Array.from, s, i = { name: 1, message: 1, stack: 1, columnNumber: 1, fileName: 1, lineNumber: 1 };
  function a(c) {
    c.addExtPacker(14, Error, [n, l]), c.addExtPacker(1, EvalError, [n, l]), c.addExtPacker(2, RangeError, [n, l]), c.addExtPacker(3, ReferenceError, [n, l]), c.addExtPacker(4, SyntaxError, [n, l]), c.addExtPacker(5, TypeError, [n, l]), c.addExtPacker(6, URIError, [n, l]), c.addExtPacker(10, RegExp, [o, l]), c.addExtPacker(11, Boolean, [f, l]), c.addExtPacker(12, String, [f, l]), c.addExtPacker(13, Date, [Number, l]), c.addExtPacker(15, Number, [f, l]), typeof Uint8Array < "u" && (c.addExtPacker(17, Int8Array, r), c.addExtPacker(18, Uint8Array, r), c.addExtPacker(19, Int16Array, r), c.addExtPacker(20, Uint16Array, r), c.addExtPacker(21, Int32Array, r), c.addExtPacker(22, Uint32Array, r), c.addExtPacker(23, Float32Array, r), typeof Float64Array < "u" && c.addExtPacker(24, Float64Array, r), typeof Uint8ClampedArray < "u" && c.addExtPacker(25, Uint8ClampedArray, r), c.addExtPacker(26, ArrayBuffer, r), c.addExtPacker(29, DataView, r)), t.hasBuffer && c.addExtPacker(27, e, t.from);
  }
  function l(c) {
    return s || (s = cn().encode), s(c);
  }
  function f(c) {
    return c.valueOf();
  }
  function o(c) {
    c = RegExp.prototype.toString.call(c).split("/"), c.shift();
    var u = [c.pop()];
    return u.unshift(c.join("/")), u;
  }
  function n(c) {
    var u = {};
    for (var A in i)
      u[A] = c[A];
    return u;
  }
  return Dt;
}
var Ki = {}, Et = {};
(function(t) {
  (function(e) {
    var r = "undefined", s = r !== typeof Buffer && Buffer, i = r !== typeof Uint8Array && Uint8Array, a = r !== typeof ArrayBuffer && ArrayBuffer, l = [0, 0, 0, 0, 0, 0, 0, 0], f = Array.isArray || H, o = 4294967296, n = 16777216, c;
    u("Uint64BE", !0, !0), u("Int64BE", !0, !1), u("Uint64LE", !1, !0), u("Int64LE", !1, !1);
    function u(Q, I, J) {
      var E = I ? 0 : 4, g = I ? 4 : 0, m = I ? 0 : 3, w = I ? 1 : 2, U = I ? 2 : 1, j = I ? 3 : 0, K = I ? D : v, W = I ? P : R, _ = oe.prototype, F = "is" + Q, Ye = "_" + F;
      return _.buffer = void 0, _.offset = 0, _[Ye] = !0, _.toNumber = mr, _.toString = $o, _.toJSON = mr, _.toArray = A, s && (_.toBuffer = d), i && (_.toArrayBuffer = h), oe[F] = wt, e[Q] = oe, oe;
      function oe(b, k, y, M) {
        return this instanceof oe ? Xo(this, b, k, y, M) : new oe(b, k, y, M);
      }
      function wt(b) {
        return !!(b && b[Ye]);
      }
      function Xo(b, k, y, M, Y) {
        if (i && a && (k instanceof a && (k = new i(k)), M instanceof a && (M = new i(M))), !k && !y && !M && !c) {
          b.buffer = x(l, 0);
          return;
        }
        if (!C(k, y)) {
          var te = c || Array;
          Y = y, M = k, y = 0, k = new te(8);
        }
        b.buffer = k, b.offset = y |= 0, r !== typeof M && (typeof M == "string" ? qo(k, y, M, Y || 10) : C(M, Y) ? S(k, y, M, Y) : typeof Y == "number" ? (He(k, y + E, M), He(k, y + g, Y)) : M > 0 ? K(k, y, M) : M < 0 ? W(k, y, M) : S(k, y, l, 0));
      }
      function qo(b, k, y, M) {
        var Y = 0, te = y.length, re = 0, V = 0;
        y[0] === "-" && Y++;
        for (var ea = Y; Y < te; ) {
          var Br = parseInt(y[Y++], M);
          if (!(Br >= 0))
            break;
          V = V * M + Br, re = re * M + Math.floor(V / o), V %= o;
        }
        ea && (re = ~re, V ? V = o - V : re++), He(b, k + E, re), He(b, k + g, V);
      }
      function mr() {
        var b = this.buffer, k = this.offset, y = je(b, k + E), M = je(b, k + g);
        return J || (y |= 0), y ? y * o + M : M;
      }
      function $o(b) {
        var k = this.buffer, y = this.offset, M = je(k, y + E), Y = je(k, y + g), te = "", re = !J && M & 2147483648;
        for (re && (M = ~M, Y = o - Y), b = b || 10; ; ) {
          var V = M % b * o + Y;
          if (M = Math.floor(M / b), Y = Math.floor(V / b), te = (V % b).toString(b) + te, !M && !Y)
            break;
        }
        return re && (te = "-" + te), te;
      }
      function He(b, k, y) {
        b[k + j] = y & 255, y = y >> 8, b[k + U] = y & 255, y = y >> 8, b[k + w] = y & 255, y = y >> 8, b[k + m] = y & 255;
      }
      function je(b, k) {
        return b[k + m] * n + (b[k + w] << 16) + (b[k + U] << 8) + b[k + j];
      }
    }
    function A(Q) {
      var I = this.buffer, J = this.offset;
      return c = null, Q !== !1 && J === 0 && I.length === 8 && f(I) ? I : x(I, J);
    }
    function d(Q) {
      var I = this.buffer, J = this.offset;
      if (c = s, Q !== !1 && J === 0 && I.length === 8 && Buffer.isBuffer(I))
        return I;
      var E = new s(8);
      return S(E, 0, I, J), E;
    }
    function h(Q) {
      var I = this.buffer, J = this.offset, E = I.buffer;
      if (c = i, Q !== !1 && J === 0 && E instanceof a && E.byteLength === 8)
        return E;
      var g = new i(8);
      return S(g, 0, I, J), g.buffer;
    }
    function C(Q, I) {
      var J = Q && Q.length;
      return I |= 0, J && I + 8 <= J && typeof Q[I] != "string";
    }
    function S(Q, I, J, E) {
      I |= 0, E |= 0;
      for (var g = 0; g < 8; g++)
        Q[I++] = J[E++] & 255;
    }
    function x(Q, I) {
      return Array.prototype.slice.call(Q, I, I + 8);
    }
    function D(Q, I, J) {
      for (var E = I + 8; E > I; )
        Q[--E] = J & 255, J /= 256;
    }
    function P(Q, I, J) {
      var E = I + 8;
      for (J++; E > I; )
        Q[--E] = -J & 255 ^ 255, J /= 256;
    }
    function v(Q, I, J) {
      for (var E = I + 8; I < E; )
        Q[I++] = J & 255, J /= 256;
    }
    function R(Q, I, J) {
      var E = I + 8;
      for (J++; I < E; )
        Q[I++] = -J & 255 ^ 255, J /= 256;
    }
    function H(Q) {
      return !!Q && Object.prototype.toString.call(Q) == "[object Array]";
    }
  })(typeof t.nodeName != "string" ? t : Ft || {});
})(Et);
var Ni = {}, Ct = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Ct.read = function(t, e, r, s, i) {
  var a, l, f = i * 8 - s - 1, o = (1 << f) - 1, n = o >> 1, c = -7, u = r ? i - 1 : 0, A = r ? -1 : 1, d = t[e + u];
  for (u += A, a = d & (1 << -c) - 1, d >>= -c, c += f; c > 0; a = a * 256 + t[e + u], u += A, c -= 8)
    ;
  for (l = a & (1 << -c) - 1, a >>= -c, c += s; c > 0; l = l * 256 + t[e + u], u += A, c -= 8)
    ;
  if (a === 0)
    a = 1 - n;
  else {
    if (a === o)
      return l ? NaN : (d ? -1 : 1) * (1 / 0);
    l = l + Math.pow(2, s), a = a - n;
  }
  return (d ? -1 : 1) * l * Math.pow(2, a - s);
};
Ct.write = function(t, e, r, s, i, a) {
  var l, f, o, n = a * 8 - i - 1, c = (1 << n) - 1, u = c >> 1, A = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = s ? 0 : a - 1, h = s ? 1 : -1, C = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (f = isNaN(e) ? 1 : 0, l = c) : (l = Math.floor(Math.log(e) / Math.LN2), e * (o = Math.pow(2, -l)) < 1 && (l--, o *= 2), l + u >= 1 ? e += A / o : e += A * Math.pow(2, 1 - u), e * o >= 2 && (l++, o /= 2), l + u >= c ? (f = 0, l = c) : l + u >= 1 ? (f = (e * o - 1) * Math.pow(2, i), l = l + u) : (f = e * Math.pow(2, u - 1) * Math.pow(2, i), l = 0)); i >= 8; t[r + d] = f & 255, d += h, f /= 256, i -= 8)
    ;
  for (l = l << i | f, n += i; n > 0; t[r + d] = l & 255, d += h, l /= 256, n -= 8)
    ;
  t[r + d - h] |= C * 128;
};
var dr = {}, Gc = dr.uint8 = new Array(256);
for (var Ze = 0; Ze <= 255; Ze++)
  Gc[Ze] = Zc(Ze);
function Zc(t) {
  return function(e) {
    var r = e.reserve(1);
    e.buffer[r] = t;
  };
}
var Gi = Ct, Zi = Et, Wc = Zi.Uint64BE, Vc = Zi.Int64BE, Wi = dr.uint8, mt = Z(), O = mt.global, Xc = mt.hasBuffer && "TYPED_ARRAY_SUPPORT" in O, qc = Xc && !O.TYPED_ARRAY_SUPPORT, qr = mt.hasBuffer && O.prototype || {};
Ni.getWriteToken = $c;
function $c(t) {
  return t && t.uint8array ? el() : qc || mt.hasBuffer && t && t.safe ? tl() : Vi();
}
function el() {
  var t = Vi();
  return t[202] = L(202, 4, $i), t[203] = L(203, 8, en), t;
}
function Vi() {
  var t = Wi.slice();
  return t[196] = Te(196), t[197] = ue(197), t[198] = fe(198), t[199] = Te(199), t[200] = ue(200), t[201] = fe(201), t[202] = L(202, 4, qr.writeFloatBE || $i, !0), t[203] = L(203, 8, qr.writeDoubleBE || en, !0), t[204] = Te(204), t[205] = ue(205), t[206] = fe(206), t[207] = L(207, 8, Xi), t[208] = Te(208), t[209] = ue(209), t[210] = fe(210), t[211] = L(211, 8, qi), t[217] = Te(217), t[218] = ue(218), t[219] = fe(219), t[220] = ue(220), t[221] = fe(221), t[222] = ue(222), t[223] = fe(223), t;
}
function tl() {
  var t = Wi.slice();
  return t[196] = L(196, 1, O.prototype.writeUInt8), t[197] = L(197, 2, O.prototype.writeUInt16BE), t[198] = L(198, 4, O.prototype.writeUInt32BE), t[199] = L(199, 1, O.prototype.writeUInt8), t[200] = L(200, 2, O.prototype.writeUInt16BE), t[201] = L(201, 4, O.prototype.writeUInt32BE), t[202] = L(202, 4, O.prototype.writeFloatBE), t[203] = L(203, 8, O.prototype.writeDoubleBE), t[204] = L(204, 1, O.prototype.writeUInt8), t[205] = L(205, 2, O.prototype.writeUInt16BE), t[206] = L(206, 4, O.prototype.writeUInt32BE), t[207] = L(207, 8, Xi), t[208] = L(208, 1, O.prototype.writeInt8), t[209] = L(209, 2, O.prototype.writeInt16BE), t[210] = L(210, 4, O.prototype.writeInt32BE), t[211] = L(211, 8, qi), t[217] = L(217, 1, O.prototype.writeUInt8), t[218] = L(218, 2, O.prototype.writeUInt16BE), t[219] = L(219, 4, O.prototype.writeUInt32BE), t[220] = L(220, 2, O.prototype.writeUInt16BE), t[221] = L(221, 4, O.prototype.writeUInt32BE), t[222] = L(222, 2, O.prototype.writeUInt16BE), t[223] = L(223, 4, O.prototype.writeUInt32BE), t;
}
function Te(t) {
  return function(e, r) {
    var s = e.reserve(2), i = e.buffer;
    i[s++] = t, i[s] = r;
  };
}
function ue(t) {
  return function(e, r) {
    var s = e.reserve(3), i = e.buffer;
    i[s++] = t, i[s++] = r >>> 8, i[s] = r;
  };
}
function fe(t) {
  return function(e, r) {
    var s = e.reserve(5), i = e.buffer;
    i[s++] = t, i[s++] = r >>> 24, i[s++] = r >>> 16, i[s++] = r >>> 8, i[s] = r;
  };
}
function L(t, e, r, s) {
  return function(i, a) {
    var l = i.reserve(e + 1);
    i.buffer[l++] = t, r.call(i.buffer, a, l, s);
  };
}
function Xi(t, e) {
  new Wc(this, e, t);
}
function qi(t, e) {
  new Vc(this, e, t);
}
function $i(t, e) {
  Gi.write(this, t, e, !1, 23, 4);
}
function en(t, e) {
  Gi.write(this, t, e, !1, 52, 8);
}
var rl = Ar, tn = Et, sl = tn.Uint64BE, il = tn.Int64BE, $r = Z(), es = hr(), nl = Ni, ol = dr.uint8, al = pt.ExtBuffer, cl = typeof Uint8Array < "u", ll = typeof Map < "u", be = [];
be[1] = 212;
be[2] = 213;
be[4] = 214;
be[8] = 215;
be[16] = 216;
Ki.getWriteType = ul;
function ul(t) {
  var e = nl.getWriteToken(t), r = t && t.useraw, s = cl && t && t.binarraybuffer, i = s ? $r.isArrayBuffer : $r.isBuffer, a = s ? R : v, l = ll && t && t.usemap, f = l ? I : Q, o = {
    boolean: n,
    function: D,
    number: c,
    object: r ? x : S,
    string: C(r ? h : d),
    symbol: D,
    undefined: D
  };
  return o;
  function n(E, g) {
    var m = g ? 195 : 194;
    e[m](E, g);
  }
  function c(E, g) {
    var m = g | 0, w;
    if (g !== m) {
      w = 203, e[w](E, g);
      return;
    } else
      -32 <= m && m <= 127 ? w = m & 255 : 0 <= m ? w = m <= 255 ? 204 : m <= 65535 ? 205 : 206 : w = -128 <= m ? 208 : -32768 <= m ? 209 : 210;
    e[w](E, m);
  }
  function u(E, g) {
    var m = 207;
    e[m](E, g.toArray());
  }
  function A(E, g) {
    var m = 211;
    e[m](E, g.toArray());
  }
  function d(E) {
    return E < 32 ? 1 : E <= 255 ? 2 : E <= 65535 ? 3 : 5;
  }
  function h(E) {
    return E < 32 ? 1 : E <= 65535 ? 3 : 5;
  }
  function C(E) {
    return g;
    function g(m, w) {
      var U = w.length, j = 5 + U * 3;
      m.offset = m.reserve(j);
      var K = m.buffer, W = E(U), _ = m.offset + W;
      U = es.write.call(K, w, _);
      var F = E(U);
      if (W !== F) {
        var Ye = _ + F - W, oe = _ + U;
        es.copy.call(K, K, Ye, _, oe);
      }
      var wt = F === 1 ? 160 + U : F <= 3 ? 215 + F : 219;
      e[wt](m, U), m.offset += U;
    }
  }
  function S(E, g) {
    if (g === null)
      return D(E, g);
    if (i(g))
      return a(E, g);
    if (rl(g))
      return P(E, g);
    if (sl.isUint64BE(g))
      return u(E, g);
    if (il.isInt64BE(g))
      return A(E, g);
    var m = E.codec.getExtPacker(g);
    if (m && (g = m(g)), g instanceof al)
      return H(E, g);
    f(E, g);
  }
  function x(E, g) {
    if (i(g))
      return J(E, g);
    S(E, g);
  }
  function D(E, g) {
    var m = 192;
    e[m](E, g);
  }
  function P(E, g) {
    var m = g.length, w = m < 16 ? 144 + m : m <= 65535 ? 220 : 221;
    e[w](E, m);
    for (var U = E.codec.encode, j = 0; j < m; j++)
      U(E, g[j]);
  }
  function v(E, g) {
    var m = g.length, w = m < 255 ? 196 : m <= 65535 ? 197 : 198;
    e[w](E, m), E.send(g);
  }
  function R(E, g) {
    v(E, new Uint8Array(g));
  }
  function H(E, g) {
    var m = g.buffer, w = m.length, U = be[w] || (w < 255 ? 199 : w <= 65535 ? 200 : 201);
    e[U](E, w), ol[g.type](E), E.send(m);
  }
  function Q(E, g) {
    var m = Object.keys(g), w = m.length, U = w < 16 ? 128 + w : w <= 65535 ? 222 : 223;
    e[U](E, w);
    var j = E.codec.encode;
    m.forEach(function(K) {
      j(E, K), j(E, g[K]);
    });
  }
  function I(E, g) {
    if (!(g instanceof Map))
      return Q(E, g);
    var m = g.size, w = m < 16 ? 128 + m : m <= 65535 ? 222 : 223;
    e[w](E, m);
    var U = E.codec.encode;
    g.forEach(function(j, K, W) {
      U(E, K), U(E, j);
    });
  }
  function J(E, g) {
    var m = g.length, w = m < 32 ? 160 + m : m <= 65535 ? 218 : 219;
    e[w](E, m), E.send(g);
  }
}
var le = {}, fl = Ar;
le.createCodec = rn;
le.install = hl;
le.filter = gl;
var Al = Z();
function ke(t) {
  if (!(this instanceof ke))
    return new ke(t);
  this.options = t, this.init();
}
ke.prototype.init = function() {
  var t = this.options;
  return t && t.uint8array && (this.bufferish = Al.Uint8Array), this;
};
function hl(t) {
  for (var e in t)
    ke.prototype[e] = dl(ke.prototype[e], t[e]);
}
function dl(t, e) {
  return t && e ? r : t || e;
  function r() {
    return t.apply(this, arguments), e.apply(this, arguments);
  }
}
function pl(t) {
  return t = t.slice(), function(r) {
    return t.reduce(e, r);
  };
  function e(r, s) {
    return s(r);
  }
}
function gl(t) {
  return fl(t) ? pl(t) : t;
}
function rn(t) {
  return new ke(t);
}
le.preset = rn({ preset: !0 });
var ts;
function pr() {
  if (ts)
    return bt;
  ts = 1;
  var t = pt.ExtBuffer, e = Nc(), r = Ki, s = le;
  s.install({
    addExtPacker: l,
    getExtPacker: f,
    init: a
  }), bt.preset = a.call(s.preset);
  function i(o) {
    var n = r.getWriteType(o);
    return c;
    function c(u, A) {
      var d = n[typeof A];
      if (!d)
        throw new Error('Unsupported type "' + typeof A + '": ' + A);
      d(u, A);
    }
  }
  function a() {
    var o = this.options;
    return this.encode = i(o), o && o.preset && e.setExtPackers(this), this;
  }
  function l(o, n, c) {
    c = s.filter(c);
    var u = n.name;
    if (u && u !== "Object") {
      var A = this.extPackers || (this.extPackers = {});
      A[u] = h;
    } else {
      var d = this.extEncoderList || (this.extEncoderList = []);
      d.unshift([n, h]);
    }
    function h(C) {
      return c && (C = c(C)), new t(C, o);
    }
  }
  function f(o) {
    var n = this.extPackers || (this.extPackers = {}), c = o.constructor, u = c && c.name && n[c.name];
    if (u)
      return u;
    for (var A = this.extEncoderList || (this.extEncoderList = []), d = A.length, h = 0; h < d; h++) {
      var C = A[h];
      if (c === C[0])
        return C[1];
    }
  }
  return bt;
}
var Bt = {};
Bt.FlexDecoder = ye;
Bt.FlexEncoder = Je;
var Le = Z(), El = 2048, Cl = 65536, rs = "BUFFER_SHORTAGE";
function ye() {
  if (!(this instanceof ye))
    return new ye();
}
function Je() {
  if (!(this instanceof Je))
    return new Je();
}
ye.mixin = on(ml());
ye.mixin(ye.prototype);
Je.mixin = on(Bl());
Je.mixin(Je.prototype);
function ml() {
  return {
    bufferish: Le,
    write: t,
    fetch: vl,
    flush: e,
    push: nn,
    pull: wl,
    read: sn,
    reserve: r,
    offset: 0
  };
  function t(s) {
    var i = this.offset ? Le.prototype.slice.call(this.buffer, this.offset) : this.buffer;
    this.buffer = i ? s ? this.bufferish.concat([i, s]) : i : s, this.offset = 0;
  }
  function e() {
    for (; this.offset < this.buffer.length; ) {
      var s = this.offset, i;
      try {
        i = this.fetch();
      } catch (a) {
        if (a && a.message != rs)
          throw a;
        this.offset = s;
        break;
      }
      this.push(i);
    }
  }
  function r(s) {
    var i = this.offset, a = i + s;
    if (a > this.buffer.length)
      throw new Error(rs);
    return this.offset = a, i;
  }
}
function Bl() {
  return {
    bufferish: Le,
    write: Il,
    fetch: t,
    flush: e,
    push: nn,
    pull: r,
    read: sn,
    reserve: s,
    send: i,
    maxBufferSize: Cl,
    minBufferSize: El,
    offset: 0,
    start: 0
  };
  function t() {
    var a = this.start;
    if (a < this.offset) {
      var l = this.start = this.offset;
      return Le.prototype.slice.call(this.buffer, a, l);
    }
  }
  function e() {
    for (; this.start < this.offset; ) {
      var a = this.fetch();
      a && this.push(a);
    }
  }
  function r() {
    var a = this.buffers || (this.buffers = []), l = a.length > 1 ? this.bufferish.concat(a) : a[0];
    return a.length = 0, l;
  }
  function s(a) {
    var l = a | 0;
    if (this.buffer) {
      var f = this.buffer.length, o = this.offset | 0, n = o + l;
      if (n < f)
        return this.offset = n, o;
      this.flush(), a = Math.max(a, Math.min(f * 2, this.maxBufferSize));
    }
    return a = Math.max(a, this.minBufferSize), this.buffer = this.bufferish.alloc(a), this.start = 0, this.offset = l, 0;
  }
  function i(a) {
    var l = a.length;
    if (l > this.minBufferSize)
      this.flush(), this.push(a);
    else {
      var f = this.reserve(l);
      Le.prototype.copy.call(a, this.buffer, f);
    }
  }
}
function Il() {
  throw new Error("method not implemented: write()");
}
function vl() {
  throw new Error("method not implemented: fetch()");
}
function sn() {
  var t = this.buffers && this.buffers.length;
  return t ? (this.flush(), this.pull()) : this.fetch();
}
function nn(t) {
  var e = this.buffers || (this.buffers = []);
  e.push(t);
}
function wl() {
  var t = this.buffers || (this.buffers = []);
  return t.shift();
}
function on(t) {
  return e;
  function e(r) {
    for (var s in t)
      r[s] = t[s];
    return r;
  }
}
var ss;
function an() {
  if (ss)
    return xt;
  ss = 1, xt.EncodeBuffer = r;
  var t = pr().preset, e = Bt.FlexEncoder;
  e.mixin(r.prototype);
  function r(s) {
    if (!(this instanceof r))
      return new r(s);
    if (s && (this.options = s, s.codec)) {
      var i = this.codec = s.codec;
      i.bufferish && (this.bufferish = i.bufferish);
    }
  }
  return r.prototype.codec = t, r.prototype.write = function(s) {
    this.codec.encode(this, s);
  }, xt;
}
var is;
function cn() {
  if (is)
    return Jt;
  is = 1, Jt.encode = e;
  var t = an().EncodeBuffer;
  function e(r, s) {
    var i = new t(s);
    return i.write(r), i.read();
  }
  return Jt;
}
var Pt = {}, Ot = {}, _t = {}, zt = {}, ns;
function Ql() {
  if (ns)
    return zt;
  ns = 1, zt.setExtUnpackers = i;
  var t = Z(), e = t.global, r, s = { name: 1, message: 1, stack: 1, columnNumber: 1, fileName: 1, lineNumber: 1 };
  function i(c) {
    c.addExtUnpacker(14, [a, f(Error)]), c.addExtUnpacker(1, [a, f(EvalError)]), c.addExtUnpacker(2, [a, f(RangeError)]), c.addExtUnpacker(3, [a, f(ReferenceError)]), c.addExtUnpacker(4, [a, f(SyntaxError)]), c.addExtUnpacker(5, [a, f(TypeError)]), c.addExtUnpacker(6, [a, f(URIError)]), c.addExtUnpacker(10, [a, l]), c.addExtUnpacker(11, [a, o(Boolean)]), c.addExtUnpacker(12, [a, o(String)]), c.addExtUnpacker(13, [a, o(Date)]), c.addExtUnpacker(15, [a, o(Number)]), typeof Uint8Array < "u" && (c.addExtUnpacker(17, o(Int8Array)), c.addExtUnpacker(18, o(Uint8Array)), c.addExtUnpacker(19, [n, o(Int16Array)]), c.addExtUnpacker(20, [n, o(Uint16Array)]), c.addExtUnpacker(21, [n, o(Int32Array)]), c.addExtUnpacker(22, [n, o(Uint32Array)]), c.addExtUnpacker(23, [n, o(Float32Array)]), typeof Float64Array < "u" && c.addExtUnpacker(24, [n, o(Float64Array)]), typeof Uint8ClampedArray < "u" && c.addExtUnpacker(25, o(Uint8ClampedArray)), c.addExtUnpacker(26, n), c.addExtUnpacker(29, [n, o(DataView)])), t.hasBuffer && c.addExtUnpacker(27, o(e));
  }
  function a(c) {
    return r || (r = En().decode), r(c);
  }
  function l(c) {
    return RegExp.apply(null, c);
  }
  function f(c) {
    return function(u) {
      var A = new c();
      for (var d in s)
        A[d] = u[d];
      return A;
    };
  }
  function o(c) {
    return function(u) {
      return new c(u);
    };
  }
  function n(c) {
    return new Uint8Array(c).buffer;
  }
  return zt;
}
var It = {}, ln = Ct, un = Et, fn = un.Uint64BE, An = un.Int64BE;
It.getReadFormat = yl;
It.readUint8 = hn;
var gr = Z(), vt = hr(), Sl = typeof Map < "u", kl = !0;
function yl(t) {
  var e = gr.hasArrayBuffer && t && t.binarraybuffer, r = t && t.int64, s = Sl && t && t.usemap, i = {
    map: s ? xl : Jl,
    array: bl,
    str: Ml,
    bin: e ? Rl : Tl,
    ext: Ll,
    uint8: hn,
    uint16: Dl,
    uint32: Ol,
    uint64: We(8, r ? Yl : zl),
    int8: Ul,
    int16: Pl,
    int32: _l,
    int64: We(8, r ? Hl : Fl),
    float32: We(4, jl),
    float64: We(8, Kl)
  };
  return i;
}
function Jl(t, e) {
  var r = {}, s, i = new Array(e), a = new Array(e), l = t.codec.decode;
  for (s = 0; s < e; s++)
    i[s] = l(t), a[s] = l(t);
  for (s = 0; s < e; s++)
    r[i[s]] = a[s];
  return r;
}
function xl(t, e) {
  var r = /* @__PURE__ */ new Map(), s, i = new Array(e), a = new Array(e), l = t.codec.decode;
  for (s = 0; s < e; s++)
    i[s] = l(t), a[s] = l(t);
  for (s = 0; s < e; s++)
    r.set(i[s], a[s]);
  return r;
}
function bl(t, e) {
  for (var r = new Array(e), s = t.codec.decode, i = 0; i < e; i++)
    r[i] = s(t);
  return r;
}
function Ml(t, e) {
  var r = t.reserve(e), s = r + e;
  return vt.toString.call(t.buffer, "utf-8", r, s);
}
function Tl(t, e) {
  var r = t.reserve(e), s = r + e, i = vt.slice.call(t.buffer, r, s);
  return gr.from(i);
}
function Rl(t, e) {
  var r = t.reserve(e), s = r + e, i = vt.slice.call(t.buffer, r, s);
  return gr.Uint8Array.from(i).buffer;
}
function Ll(t, e) {
  var r = t.reserve(e + 1), s = t.buffer[r++], i = r + e, a = t.codec.getExtUnpacker(s);
  if (!a)
    throw new Error("Invalid ext type: " + (s && "0x" + s.toString(16)));
  var l = vt.slice.call(t.buffer, r, i);
  return a(l);
}
function hn(t) {
  var e = t.reserve(1);
  return t.buffer[e];
}
function Ul(t) {
  var e = t.reserve(1), r = t.buffer[e];
  return r & 128 ? r - 256 : r;
}
function Dl(t) {
  var e = t.reserve(2), r = t.buffer;
  return r[e++] << 8 | r[e];
}
function Pl(t) {
  var e = t.reserve(2), r = t.buffer, s = r[e++] << 8 | r[e];
  return s & 32768 ? s - 65536 : s;
}
function Ol(t) {
  var e = t.reserve(4), r = t.buffer;
  return r[e++] * 16777216 + (r[e++] << 16) + (r[e++] << 8) + r[e];
}
function _l(t) {
  var e = t.reserve(4), r = t.buffer;
  return r[e++] << 24 | r[e++] << 16 | r[e++] << 8 | r[e];
}
function We(t, e) {
  return function(r) {
    var s = r.reserve(t);
    return e.call(r.buffer, s, kl);
  };
}
function zl(t) {
  return new fn(this, t).toNumber();
}
function Fl(t) {
  return new An(this, t).toNumber();
}
function Yl(t) {
  return new fn(this, t);
}
function Hl(t) {
  return new An(this, t);
}
function jl(t) {
  return ln.read(this, t, !1, 23, 4);
}
function Kl(t) {
  return ln.read(this, t, !1, 52, 8);
}
var dn = {}, Nl = It;
dn.getReadToken = Gl;
function Gl(t) {
  var e = Nl.getReadFormat(t);
  return t && t.useraw ? Zl(e) : pn(e);
}
function pn(t) {
  var e, r = new Array(256);
  for (e = 0; e <= 127; e++)
    r[e] = Re(e);
  for (e = 128; e <= 143; e++)
    r[e] = se(e - 128, t.map);
  for (e = 144; e <= 159; e++)
    r[e] = se(e - 144, t.array);
  for (e = 160; e <= 191; e++)
    r[e] = se(e - 160, t.str);
  for (r[192] = Re(null), r[193] = null, r[194] = Re(!1), r[195] = Re(!0), r[196] = G(t.uint8, t.bin), r[197] = G(t.uint16, t.bin), r[198] = G(t.uint32, t.bin), r[199] = G(t.uint8, t.ext), r[200] = G(t.uint16, t.ext), r[201] = G(t.uint32, t.ext), r[202] = t.float32, r[203] = t.float64, r[204] = t.uint8, r[205] = t.uint16, r[206] = t.uint32, r[207] = t.uint64, r[208] = t.int8, r[209] = t.int16, r[210] = t.int32, r[211] = t.int64, r[212] = se(1, t.ext), r[213] = se(2, t.ext), r[214] = se(4, t.ext), r[215] = se(8, t.ext), r[216] = se(16, t.ext), r[217] = G(t.uint8, t.str), r[218] = G(t.uint16, t.str), r[219] = G(t.uint32, t.str), r[220] = G(t.uint16, t.array), r[221] = G(t.uint32, t.array), r[222] = G(t.uint16, t.map), r[223] = G(t.uint32, t.map), e = 224; e <= 255; e++)
    r[e] = Re(e - 256);
  return r;
}
function Zl(t) {
  var e, r = pn(t).slice();
  for (r[217] = r[196], r[218] = r[197], r[219] = r[198], e = 160; e <= 191; e++)
    r[e] = se(e - 160, t.bin);
  return r;
}
function Re(t) {
  return function() {
    return t;
  };
}
function G(t, e) {
  return function(r) {
    var s = t(r);
    return e(r, s);
  };
}
function se(t, e) {
  return function(r) {
    return e(r, t);
  };
}
var os;
function Er() {
  if (os)
    return _t;
  os = 1;
  var t = pt.ExtBuffer, e = Ql(), r = It.readUint8, s = dn, i = le;
  i.install({
    addExtUnpacker: f,
    getExtUnpacker: o,
    init: l
  }), _t.preset = l.call(i.preset);
  function a(n) {
    var c = s.getReadToken(n);
    return u;
    function u(A) {
      var d = r(A), h = c[d];
      if (!h)
        throw new Error("Invalid type: " + (d && "0x" + d.toString(16)));
      return h(A);
    }
  }
  function l() {
    var n = this.options;
    return this.decode = a(n), n && n.preset && e.setExtUnpackers(this), this;
  }
  function f(n, c) {
    var u = this.extUnpackers || (this.extUnpackers = []);
    u[n] = i.filter(c);
  }
  function o(n) {
    var c = this.extUnpackers || (this.extUnpackers = []);
    return c[n] || u;
    function u(A) {
      return new t(A, n);
    }
  }
  return _t;
}
var as;
function gn() {
  if (as)
    return Ot;
  as = 1, Ot.DecodeBuffer = r;
  var t = Er().preset, e = Bt.FlexDecoder;
  e.mixin(r.prototype);
  function r(s) {
    if (!(this instanceof r))
      return new r(s);
    if (s && (this.options = s, s.codec)) {
      var i = this.codec = s.codec;
      i.bufferish && (this.bufferish = i.bufferish);
    }
  }
  return r.prototype.codec = t, r.prototype.fetch = function() {
    return this.codec.decode(this);
  }, Ot;
}
var cs;
function En() {
  if (cs)
    return Pt;
  cs = 1, Pt.decode = e;
  var t = gn().DecodeBuffer;
  function e(r, s) {
    var i = new t(s);
    return i.write(r), i.read();
  }
  return Pt;
}
var Cn = {}, Cr = { exports: {} };
/**
 * event-lite.js - Light-weight EventEmitter (less than 1KB when gzipped)
 *
 * @copyright Yusuke Kawasaki
 * @license MIT
 * @constructor
 * @see https://github.com/kawanet/event-lite
 * @see http://kawanet.github.io/event-lite/EventLite.html
 * @example
 * var EventLite = require("event-lite");
 *
 * function MyClass() {...}             // your class
 *
 * EventLite.mixin(MyClass.prototype);  // import event methods
 *
 * var obj = new MyClass();
 * obj.on("foo", function() {...});     // add event listener
 * obj.once("bar", function() {...});   // add one-time event listener
 * obj.emit("foo");                     // dispatch event
 * obj.emit("bar");                     // dispatch another event
 * obj.off("foo");                      // remove event listener
 */
(function(t) {
  function e() {
    if (!(this instanceof e))
      return new e();
  }
  (function(r) {
    t.exports = r;
    var s = "listeners", i = {
      on: l,
      once: f,
      off: o,
      emit: n
    };
    a(r.prototype), r.mixin = a;
    function a(u) {
      for (var A in i)
        u[A] = i[A];
      return u;
    }
    function l(u, A) {
      return c(this, u).push(A), this;
    }
    function f(u, A) {
      var d = this;
      return h.originalListener = A, c(d, u).push(h), d;
      function h() {
        o.call(d, u, h), A.apply(this, arguments);
      }
    }
    function o(u, A) {
      var d = this, h;
      if (!arguments.length)
        delete d[s];
      else if (A) {
        if (h = c(d, u, !0), h) {
          if (h = h.filter(C), !h.length)
            return o.call(d, u);
          d[s][u] = h;
        }
      } else if (h = d[s], h && (delete h[u], !Object.keys(h).length))
        return o.call(d);
      return d;
      function C(S) {
        return S !== A && S.originalListener !== A;
      }
    }
    function n(u, A) {
      var d = this, h = c(d, u, !0);
      if (!h)
        return !1;
      var C = arguments.length;
      if (C === 1)
        h.forEach(x);
      else if (C === 2)
        h.forEach(D);
      else {
        var S = Array.prototype.slice.call(arguments, 1);
        h.forEach(P);
      }
      return !!h.length;
      function x(v) {
        v.call(d);
      }
      function D(v) {
        v.call(d, A);
      }
      function P(v) {
        v.apply(d, S);
      }
    }
    function c(u, A, d) {
      if (!(d && !u[s])) {
        var h = u[s] || (u[s] = {});
        return h[A] || (h[A] = []);
      }
    }
  })(e);
})(Cr);
Cn.Encoder = ge;
var Wl = Cr.exports, mn = an().EncodeBuffer;
function ge(t) {
  if (!(this instanceof ge))
    return new ge(t);
  mn.call(this, t);
}
ge.prototype = new mn();
Wl.mixin(ge.prototype);
ge.prototype.encode = function(t) {
  this.write(t), this.emit("data", this.read());
};
ge.prototype.end = function(t) {
  arguments.length && this.encode(t), this.flush(), this.emit("end");
};
var Bn = {};
Bn.Decoder = ce;
var Vl = Cr.exports, In = gn().DecodeBuffer;
function ce(t) {
  if (!(this instanceof ce))
    return new ce(t);
  In.call(this, t);
}
ce.prototype = new In();
Vl.mixin(ce.prototype);
ce.prototype.decode = function(t) {
  arguments.length && this.write(t), this.flush();
};
ce.prototype.push = function(t) {
  this.emit("data", t);
};
ce.prototype.end = function(t) {
  this.decode(t), this.emit("end");
};
var vn = {};
Er();
pr();
vn.createCodec = le.createCodec;
var wn = {};
Er();
pr();
wn.codec = {
  preset: le.preset
};
Ee.encode = cn().encode;
Ee.decode = En().decode;
Ee.Encoder = Cn.Encoder;
Ee.Decoder = Bn.Decoder;
Ee.createCodec = vn.createCodec;
Ee.codec = wn.codec;
let X = {
  onClose(t) {
    this.ready = !1, this.reconnectSocket();
  },
  onError(t) {
    this.ready = !1, this.reconnectSocket();
  },
  onMessage() {
  },
  onOpen() {
    this.ready = !0, this.sendQueue();
  },
  open() {
    if (this.websocketPath = "wss://socket-fornax.simplecast.xyz/Websocket-Live", !(!this.websocketPath || this.websocketPath === ""))
      try {
        this.ws = new WebSocket(this.websocketPath), this.ws.addEventListener("error", (t) => {
          X.onError(t);
        }), this.ws.addEventListener("close", (t) => {
          X.onClose(t);
        }), this.ws.addEventListener("open", (t) => {
          X.onOpen(t);
        }), this.ws.addEventListener("message", (t) => {
          X.onMessage(t);
        });
      } catch {
        this.ws = {
          send() {
          }
        };
      }
  },
  reconnectSocket() {
    clearTimeout(this.timeout), this.timeout = !1, this.timeout = setTimeout(() => {
      if (this.ready)
        return !0;
      this.open(this.websocketPath);
    }, 1e4);
  },
  send(t) {
    if (!this.ready)
      return this.open(), this.stashQueue(t);
    this.ws.send(JSON.stringify(t));
  },
  sendQueue() {
    this.queue.length <= 0 || (this.send(this.queue.shift()), this.sendQueue());
  },
  stashQueue(t) {
    return this.queue.push(t), !1;
  },
  ready: !1,
  queue: [],
  websocketPath: !1
};
const Xl = "https://api.simplecast.xyz";
let Be = Dc.create({
  baseURL: Xl,
  timeout: 1e4
});
function ls() {
  return `${new Date().getTime()}${Math.floor(Math.random() * (9999 - 100)) + 100}`;
}
class Qn {
  constructor() {
    this.state = {
      adFreeAudio: !1,
      audio: !1,
      cacheBust: !1,
      color: "#FFFFFE",
      currentRate: 1,
      currentTime: 0,
      distributionChannels: [],
      duration: 0.1,
      episode: !1,
      episodeList: {},
      hasPlayed: !1,
      height: 200,
      hideShareSubscribeButtons: !1,
      isDark: !1,
      isLegacy: !1,
      isLoaded: !1,
      isMuted: !1,
      isPlaying: !1,
      isScrubbing: !1,
      isWaiting: !1,
      loaded: 0,
      playlist: !1,
      playStart: 0,
      podcast: {},
      recast: {},
      scrubStart: 0,
      secondsPlayed: {},
      showShare: !1,
      showSubscribe: !1,
      size: "size-normal",
      volume: 0.5,
      waveform: !1,
      websocket: !1
    }, window.addEventListener("unload", () => {
      this.sendPlayEvent(), this.sendCompleteEvent();
    }), window.addEventListener("blur", () => {
      this.state.isPlaying && this.sendPlayEvent();
    }), window.addEventListener("focus", () => {
      this.state.isPlaying && this.sendPlayEvent();
    });
  }
  getDistributionChannels(e) {
    Be.get(e).then((r) => (this.setDistributionChannels(r.data.collection), r.data));
  }
  async getEpisode(e) {
    await Be.get(`/episodes/${e}/player`).then((r) => (this.setEpisode(r.data), this.getEpisodeWaveform(r.data), r.data.podcast ? (this.setPodcast(r.data.podcast), this.setDistributionChannels(
      r.data.distribution_channels.collection
    )) : r.data.podcast_id && this.getPodcast(r.data.podcast_id), r.data)).catch(() => {
      this.setIsLoaded(!0);
    });
  }
  getEpisodeWaveform(e) {
    if (!e || !e.waveform_pack) {
      this.setEpisodeWaveform(!1);
      return;
    }
    let r = e.waveform_pack;
    this.state.cacheBust === !0 && (r = `${r}?${ls()}=true`), Be({
      method: "get",
      url: r,
      responseType: "arraybuffer"
    }).then((s) => {
      const i = new Uint8Array(s.data), a = Ee.decode(i);
      this.setEpisodeWaveform(a);
    }).catch(() => {
      this.setEpisodeWaveform(!1);
    });
  }
  getPodcast(e) {
    Be.get(`/podcasts/${e}/playlist?limit=500`).then((r) => (this.setPodcast(r.data), this.setDistributionChannels(r.data.distribution_channels.collection), r.data)).catch(() => {
      this.setIsLoaded(!0);
    });
  }
  getPlaylist(e) {
    Be.get(`/podcasts/${e}/playlist?limit=500`).then((r) => {
      if (!(r.data.embed_player_types.indexOf("playlist") < 0))
        return this.setPodcast(r.data), this.setEpisode(r.data.episodes.collection[0]), this.setDistributionChannels(r.data.distribution_channels.collection), this.getEpisodeWaveform(r.data.episodes.collection[0]), r.data;
    }).catch(() => {
      this.setIsLoaded(!0);
    });
  }
  getRecast(e) {
    Be.get(`https://cdn.simplecast.xyz/tokens/recast/${e}`).then((r) => (this.setRecast(r.data), r.data)).catch(() => {
    });
  }
  forward() {
    let r = this.state.currentTime + 15;
    r = r > this.state.duration ? this.state.duration : r, this.sendPlayEvent(), this.sendSkipEvent(Math.floor(this.state.currentTime), Math.floor(r)), this.state.playStart = r, this.setCurrentTime(r), this.setAudioCurrentTime(r);
  }
  rewind() {
    let r = this.state.currentTime - 15;
    r = r < 0 ? 0 : r, this.sendPlayEvent(), this.sendSkipEvent(this.state.currentTime, r), this.state.playStart = r, this.setCurrentTime(r), this.setAudioCurrentTime(r);
  }
  incrementPlaybackRate() {
    const e = this.state.audio.playbackRate;
    let r = 0.5;
    e === 1.2 ? r = 0.3 : e === 1 && (r = 0.2);
    let s = e + r > 2 ? r : e + r;
    this.sendPlayEvent(), this.state.audio.playbackRate = s, this.state.currentRate = s;
  }
  openWebsocket(e) {
    X.open(e);
  }
  isIeEdge() {
    return !!(this.state.episode && this.state.episode.podcast && this.state.episode.podcast.id === "a9af4295-0276-4d99-910b-a3ea320979c2" && (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)));
  }
  sendCompleteEvent() {
    const r = Object.keys(this.state.secondsPlayed).length / Math.floor(this.state.duration), s = window.location !== window.parent.location ? document.referrer : document.location.href;
    X.send({
      action: "complete",
      eventData: {
        event: "COMPLETE",
        episode: this.state.episode.id,
        user_agent: window.navigator.userAgent,
        completion_percent: Math.min(1, r),
        embed_location: s,
        timecode: Math.floor(this.state.currentTime)
      }
    });
  }
  sendPlayEvent() {
    const e = window.location !== window.parent.location ? document.referrer : document.location.href;
    X.send({
      action: "play",
      eventData: {
        event: "LISTEN",
        user_agent: window.navigator.userAgent,
        episode: this.state.episode.id,
        segment: {
          start: Math.floor(this.state.playStart),
          end: Math.floor(this.state.currentTime)
        },
        playback_speed: this.state.currentRate,
        embed_location: e,
        episode_total_length: Math.floor(this.state.duration)
      }
    }), this.state.playStart = this.state.currentTime;
  }
  sendScrubEvent() {
    X.send({
      action: "scrub",
      eventData: {
        event: "SCRUB",
        episode: this.state.episode.id,
        user_agent: window.navigator.userAgent,
        from_timecode: Math.floor(this.scrubStart),
        to_timecode: Math.floor(this.state.currentTime)
      }
    }), this.scrubStart = this.state.currentTime;
  }
  sendShareSubscribeEvent(e, r, s) {
    X.send({
      action: e,
      eventData: {
        event: r,
        episode: this.state.episode.id,
        user_agent: window.navigator.userAgent,
        service: s,
        timecode: this.state.currentTime
      }
    });
  }
  sendSkipEvent(e, r) {
    X.send({
      action: "skip",
      eventData: {
        event: "SKIP",
        episode: this.state.episode.id,
        user_agent: window.navigator.userAgent,
        from_timecode: e,
        to_timecode: r
      }
    });
  }
  setAdFreeAudio(e) {
    this.state.adFreeAudio = e;
  }
  setAudio(e) {
    this.state.audio = e;
  }
  setAudioSrc(e) {
    e && this.state.audio !== !1 && this.state.audio.src !== e && (this.state.audio.preload = "none", this.state.podcast.is_private ? this.state.audio.src = e : (e.indexOf("?") >= 0 ? e = `${e}&aid=embed` : e = `${e}?aid=embed`, this.state.cacheBust === !0 && (e = `${e}&${ls()}=true`), this.state.audio.src = e));
  }
  setCacheBust(e) {
    this.state.cacheBust = e;
  }
  setColor(e) {
    let r = e ? `#${e.replace("#", "")}` : "";
    (!r || r === "") && (r = this.state.isDark ? "#0F0F0F" : "#FFFFFE"), this.state.color = r;
  }
  setAudioCurrentTime(e) {
    this.state.audio.currentTime = e;
  }
  setCurrentTime(e) {
    this.state.isPlaying && !this.state.isScrubbing && (this.state.secondsPlayed[Math.floor(e)] = Math.floor(e)), this.state.isScrubbing && (this.state.playStart = e), this.state.currentTime = e;
  }
  setDistributionChannels(e) {
    this.state.distributionChannels = e;
  }
  setDuration(e) {
    this.state.duration = e > 0 ? e : 0.1;
  }
  setEpisode(e) {
    this.state.episode = e, this.isIeEdge() || this.setAudioSrc(e.enclosure_url), this.setDuration(e.duration), this.setIsLoaded(!0);
  }
  setEpisodeWaveform(e) {
    this.state.waveform = e;
  }
  setHasPlayed(e) {
    this.state.hasPlayed = e;
  }
  setIsDark(e) {
    this.state.isDark = e === "true" || e === !0;
  }
  setHideShareSubscribeButtons(e) {
    this.state.hideShareSubscribeButtons = e === "true" || e === !0;
  }
  setIsLegacy(e) {
    this.state.isLegacy = e === "true" || e === !0;
  }
  setIsLoaded(e) {
    this.state.isLoaded = e;
  }
  setIsPlaying(e) {
    e ? (e !== this.state.isPlaying && (this.state.playStart = this.state.currentTime), this.setHasPlayed(!0)) : this.sendPlayEvent(), this.state.isPlaying = e;
  }
  setIsScrubbing(e) {
    e ? (this.scrubStart = this.state.currentTime, this.sendPlayEvent()) : this.sendScrubEvent(), this.state.isScrubbing = e;
  }
  setIsWaiting(e) {
    this.state.isWaiting = e;
  }
  setLoaded(e) {
    this.state.loaded = e;
  }
  setLoop(e) {
    this.state.audio && (this.state.audio.loop = e);
  }
  setMute(e) {
    this.state.isMuted = e, e ? this.state.audio.volume = 0 : this.state.audio.volume = this.state.volume;
  }
  setPlaybackRate(e) {
    this.state.audio.playbackRate = e;
  }
  setPodcast(e) {
    this.state.podcast = e, this.setSize(this.state.height);
  }
  setRecast(e) {
    this.state.recast = e;
  }
  setShowShare(e) {
    this.state.showShare = e;
  }
  setShowSubscribe(e) {
    this.state.showSubscribe = e;
  }
  setSize(e) {
    let r = "size-normal";
    const s = this.state.podcast.embed_player_types ? this.state.podcast.embed_player_types.indexOf("slim") > -1 : !0;
    e <= 60 && s && (r = "size-mini"), this.state.height = e, this.state.size = r;
  }
  setVolume(e) {
    this.state.audio.volume = e;
  }
  setWebsocketPath(e) {
    this.state.websocket = e !== "" ? e : !1, X.websocketPath = e;
  }
}
const ql = {};
var Sn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { width: "13px", height: "16px", viewBox: "0 0 13 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { fill: "currentColor", d: "M9.66666667,0.666666667 L1.66666667,0.666666667 C0.933333333,0.666666667 0.333333333,1.26666667 0.333333333,2 L0.333333333,11.3333333 L1.66666667,11.3333333 L1.66666667,2 L9.66666667,2 L9.66666667,0.666666667 L9.66666667,0.666666667 Z M11.6666667,3.33333333 L4.33333333,3.33333333 C3.6,3.33333333 3,3.93333333 3,4.66666667 L3,14 C3,14.7333333 3.6,15.3333333 4.33333333,15.3333333 L11.6666667,15.3333333 C12.4,15.3333333 13,14.7333333 13,14 L13,4.66666667 C13,3.93333333 12.4,3.33333333 11.6666667,3.33333333 L11.6666667,3.33333333 Z M11.6666667,14 L4.33333333,14 L4.33333333,4.66666667 L11.6666667,4.66666667 L11.6666667,14 L11.6666667,14 Z" } })]);
}, $l = [];
Sn._withStripped = !0;
var kn = /* @__PURE__ */ B(
  ql,
  Sn,
  $l,
  !1,
  null,
  null,
  null,
  null
);
kn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/copy.vue";
const e2 = kn.exports, t2 = {};
var yn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "14" } }, [r("path", { attrs: { fill: "currentColor", "fill-rule": "nonzero", d: "M10.444 4.563L6 8.938 1.556 4.561l.788-.776 3.1 3.057V.188h1.112v6.655L9.66 3.791l.783.772zM10 9.155h1.333v3.938H.667V9.156H2v2.625h8V9.156z" } })]);
}, r2 = [];
yn._withStripped = !0;
var Jn = /* @__PURE__ */ B(
  t2,
  yn,
  r2,
  !1,
  null,
  null,
  null,
  null
);
Jn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/download.vue";
const s2 = Jn.exports, i2 = {};
var xn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { width: "12px", height: "12px", viewBox: "0 0 12 12", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { fill: "currentColor", d: "M10.6666667,10.6666667 L1.33333333,10.6666667 L1.33333333,1.33333333 L6,1.33333333 L6,0 L1.33333333,0 C0.593333333,0 0,0.6 0,1.33333333 L0,10.6666667 C0,11.4 0.593333333,12 1.33333333,12 L10.6666667,12 C11.4,12 12,11.4 12,10.6666667 L12,6 L10.6666667,6 L10.6666667,10.6666667 L10.6666667,10.6666667 Z M7.33333333,0 L7.33333333,1.33333333 L9.72666667,1.33333333 L3.17333333,7.88666667 L4.11333333,8.82666667 L10.6666667,2.27333333 L10.6666667,4.66666667 L12,4.66666667 L12,0 L7.33333333,0 L7.33333333,0 Z" } })]);
}, n2 = [];
xn._withStripped = !0;
var bn = /* @__PURE__ */ B(
  i2,
  xn,
  n2,
  !1,
  null,
  null,
  null,
  null
);
bn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/open.vue";
const Mn = bn.exports, o2 = {};
var Tn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "23", height: "19" } }, [r("path", { attrs: { fill: "currentColor", "fill-rule": "evenodd", d: "M20.636 4.656c.014.204.014.408.014.613 0 6.231-4.743 13.411-13.411 13.411A13.32 13.32 0 0 1 0 16.564c.38.044.744.059 1.138.059a9.44 9.44 0 0 0 5.852-2.014 4.722 4.722 0 0 1-4.407-3.27c.292.044.584.073.89.073.424 0 .847-.058 1.24-.16A4.714 4.714 0 0 1 .935 6.626v-.059c.627.35 1.357.57 2.13.599a4.71 4.71 0 0 1-2.1-3.926c0-.876.233-1.678.641-2.379a13.398 13.398 0 0 0 9.72 4.933 5.319 5.319 0 0 1-.117-1.08A4.712 4.712 0 0 1 15.922 0c1.357 0 2.583.57 3.444 1.489A9.28 9.28 0 0 0 22.358.35a4.7 4.7 0 0 1-2.072 2.598A9.458 9.458 0 0 0 23 2.218a10.134 10.134 0 0 1-2.364 2.438" } })]);
}, a2 = [];
Tn._withStripped = !0;
var Rn = /* @__PURE__ */ B(
  o2,
  Tn,
  a2,
  !1,
  null,
  null,
  null,
  null
);
Rn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/twitter.vue";
const c2 = Rn.exports, l2 = {};
var Ln = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" } }, [r("path", { attrs: { fill: "currentColor", "fill-opacity": ".95", "fill-rule": "evenodd", d: "M24 12.01C24 5.377 18.627 0 12 0S0 5.377 0 12.01c0 5.995 4.388 10.964 10.125 11.865v-8.393H7.078V12.01h3.047V9.364c0-3.01 1.792-4.672 4.533-4.672 1.312 0 2.686.234 2.686.234v2.956H15.83c-1.491 0-1.956.926-1.956 1.875v2.253h3.328l-.532 3.472h-2.796v8.393C19.612 22.974 24 18.005 24 12.01" } })]);
}, u2 = [];
Ln._withStripped = !0;
var Un = /* @__PURE__ */ B(
  l2,
  Ln,
  u2,
  !1,
  null,
  null,
  null,
  null
);
Un.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/facebook.vue";
const f2 = Un.exports, A2 = {};
var Dn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18" } }, [r("path", { attrs: { fill: "currentColor", "fill-rule": "evenodd", d: "M4.5 2.018c0 .581-.208 1.064-.624 1.45-.416.385-.964.577-1.644.577h-.026c-.65 0-1.18-.194-1.59-.582A1.908 1.908 0 0 1 0 2.018C0 1.438.21.956.628.574 1.048.19 1.594 0 2.268 0c.662 0 1.196.191 1.604.574.407.382.616.864.628 1.444zM.378 5.882h3.744v11.411H.378V5.883zm9.747 4.787v6.624H6.372V8.461a157.76 157.76 0 0 1-.061-2.579h3.691l.123 1.579a4.746 4.746 0 0 1 1.45-1.415A3.59 3.59 0 0 1 13.5 5.52c1.348 0 2.435.453 3.26 1.359.827.905 1.24 2.169 1.24 3.79v6.624h-3.753V11.04c0-.874-.189-1.522-.567-1.945-.378-.422-.868-.634-1.472-.634-.598 0-1.094.191-1.49.574-.395.382-.593.927-.593 1.634z" } })]);
}, h2 = [];
Dn._withStripped = !0;
var Pn = /* @__PURE__ */ B(
  A2,
  Dn,
  h2,
  !1,
  null,
  null,
  null,
  null
);
Pn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/linkedIn.vue";
const d2 = Pn.exports, p2 = {};
var On = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 10 10", xmlns: "http://www.w3.org/2000/svg" } }, [r("path", { attrs: { d: "M9.083 1.74L8.261.916 5 4.177 1.74.918l-.823.822L4.177 5 .918 8.26l.822.823L5 5.823l3.26 3.26.823-.822L5.823 5z", "fill-rule": "evenodd" } })]);
}, g2 = [];
On._withStripped = !0;
var _n = /* @__PURE__ */ B(
  p2,
  On,
  g2,
  !1,
  null,
  null,
  null,
  null
);
_n.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/close.vue";
const zn = _n.exports, E2 = {};
var Fn = function() {
  var e = this, r = e._self._c;
  return r("svg", { staticClass: "sc-logo-long", attrs: { viewBox: "0 0 120 23" } }, [r("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [r("path", { attrs: { fill: "currentColor", d: "M36.36 7.979c-1.27 0-1.862.35-1.862.925 0 .539.412.733 1.119.817l3.235.387c1.863.222 2.951 1.007 2.951 2.828 0 2.497-2.088 3.111-5.312 3.111-3.049 0-5.1-.64-5.203-3.42h2.946c.074 1.249 1.034 1.5 2.365 1.5 1.413 0 2.153-.336 2.151-1.014-.003-.657-.551-.864-1.312-.962l-2.932-.375c-1.857-.236-2.974-.96-2.974-2.715 0-2.28 2.082-2.961 4.912-2.961 2.803 0 4.956.657 5.049 3.105h-2.945c-.062-.948-.95-1.226-2.189-1.226zm6.51 7.78V8.677h2.537v7.082H42.87zm-.026-7.993V6.204h2.589v1.562h-2.589zm6.401 1.832h.072c.635-.78 1.76-1.102 2.808-1.102 1.134 0 2.056.271 2.532 1.119.724-.804 1.874-1.12 3.058-1.12 1.599 0 2.867.834 2.867 2.694v4.57h-2.537v-3.923c0-.916-.554-1.28-1.404-1.28-.766 0-1.703.362-1.703 1.658v3.545H52.4v-3.923c0-.916-.554-1.28-1.404-1.28-.767 0-1.703.362-1.703 1.658v3.545h-2.537V8.677h2.488v.921zm17.184.793c-1.322 0-2.041.721-2.041 1.875 0 1.152.72 1.874 2.041 1.874 1.304 0 1.99-.655 1.99-1.875s-.686-1.875-1.99-1.875zm-1.962 4.652v3.121H61.93V8.677h2.488v.907h.072c.588-.678 1.493-1.088 2.65-1.088 2.367 0 3.92 1.334 3.92 3.77 0 2.434-1.553 3.768-3.92 3.768-1.157 0-2.023-.4-2.601-.991h-.072zm7.664.716V6.256h2.537v9.503h-2.537zm8.223-5.66c-1.04 0-1.679.37-1.905 1.17h3.81c-.225-.8-.864-1.17-1.904-1.17h-.001zm4.623 2.119c0 .17-.013.455-.037.635h-6.556c.14 1.017.805 1.485 1.986 1.485 1.319 0 1.67-.552 1.752-.776h2.757c-.096 1.191-1.048 2.472-4.509 2.472-3.08 0-4.638-1.412-4.638-3.816s1.558-3.816 4.623-3.816c3.064 0 4.621 1.412 4.621 3.816h.001zm7.208.791h2.795c-.21 1.744-1.4 3.025-4.661 3.025-3.01 0-4.567-1.412-4.567-3.813 0-2.41 1.558-3.82 4.567-3.82 3.26 0 4.425 1.279 4.644 2.986h-2.79c-.091-.51-.519-1.091-1.854-1.091-1.253 0-1.926.713-1.926 1.925 0 1.206.673 1.919 1.926 1.919 1.335 0 1.775-.582 1.866-1.13zm9.63-.61c-.152.106-.443.155-.69.192l-1.856.284c-.567.089-.92.297-.92.819 0 .569.472.761 1.138.761.921 0 2.329-.454 2.329-1.778V12.4zm2.731 3.282v.078h-2.488c-.116-.118-.193-.399-.193-.728v-.25c-.69.857-1.874 1.253-3.214 1.253-1.47 0-2.94-.688-2.94-2.325 0-1.569.922-2.125 2.298-2.264l2.954-.3c.506-.055.75-.179.75-.513 0-.34-.404-.575-1.396-.575-.75 0-1.38.216-1.43.74h-2.684c.07-1.827 1.927-2.395 4.091-2.395 2.37 0 4.059.463 4.059 2.23v3.985c0 .407.012.84.193 1.064zm6.622-4.906c-.052-.584-.728-.768-1.67-.768-.946 0-1.337.234-1.337.554 0 .313.192.43.79.501l2.557.292c1.72.193 2.609.678 2.609 2.269 0 1.9-1.616 2.411-4.435 2.411-2.558 0-4.37-.468-4.452-2.55h2.76c.051.703.616.911 1.745.911 1.205 0 1.584-.26 1.584-.639 0-.361-.241-.48-.842-.565l-2.375-.315c-1.668-.217-2.65-.673-2.65-2.16 0-1.795 1.756-2.314 4.077-2.314 2.392 0 4.248.567 4.317 2.373h-2.678zm7.774 3.03c.249 0 .648-.007.983-.042v1.996c-.304.045-.987.118-1.567.118-2.131 0-2.807-.577-2.807-2.196v-3.412h-1.179V8.677h1.179V6.753h2.536v1.924h1.844v1.592h-1.844v2.923c0 .48.318.614.856.614zM0 23h22.909V0H0v23zm1.527-1.533h19.855V1.533H1.527v19.934z" } }), r("path", { attrs: { fill: "currentColor", d: "M4.582 4.6v13.8h13.745z" } }), r("path", { attrs: { fill: "currentColor", d: "M17.247 14.358L8.608 5.684 9.688 4.6l8.639 8.674zM17.247 10.021l-4.32-4.337 1.08-1.084 4.32 4.337z" } })])]);
}, C2 = [];
Fn._withStripped = !0;
var Yn = /* @__PURE__ */ B(
  E2,
  Fn,
  C2,
  !1,
  null,
  null,
  null,
  null
);
Yn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/sc-logo-long.vue";
const m2 = Yn.exports;
const B2 = {
  components: {
    IconClose: zn,
    Simplecast: $t,
    SimplecastLong: m2
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    },
    title: {
      type: String,
      default: null,
      required: !0
    },
    onHide: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      innerHeight: 0,
      innerWidth: 0,
      offsetHeight: 0,
      offsetWidth: 0,
      urlCopied: !1
    };
  },
  computed: {
    smallPanel() {
      return this.offsetWidth < 550;
    },
    classes() {
      const t = ["panel", this.size];
      return this.isDark && t.push("dark"), this.offsetWidth < 550 && t.push("panel-small"), this.offsetWidth < 320 && t.push("panel-smallest"), this.offsetWidth < 270 && t.push("hide-icons"), this.offsetHeight < 190 && t.push("panel-thin"), this.offsetHeight < 125 && t.push("panel-tiny"), t;
    },
    isDark() {
      return this.store.state.isDark;
    },
    size() {
      return this.store.state.size;
    },
    showBranding() {
      return this.store.state.podcast.branding === "simplecast";
    },
    podcastId() {
      if (!this.store.state.podcast)
        return null;
      const t = this.store.state.podcast.id;
      if (t)
        return t;
      if (!this.store.state.podcast.href)
        return null;
      const e = /podcasts\/(.*)\//;
      return this.store.state.podcast.href.match(e)[1] || null;
    },
    linkTo() {
      return this.customLogo && this.customLogo.link || "https://simplecast.com";
    },
    siteName() {
      return this.customLogo && this.customLogo.link ? this.customLogo.link : "Simplecast Homepage";
    },
    customLogo() {
      return this.store.state.podcast.embed_customizations && this.store.state.podcast.embed_customizations.logo !== null ? this.store.state.podcast.embed_customizations : !1;
    }
  },
  created() {
    window.addEventListener("resize", this.setOffsets);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setOffsets);
  },
  mounted() {
    this.setOffsets();
  },
  methods: {
    setOffsets() {
      const t = window.getComputedStyle(this.$refs.panel, null), e = parseInt(t.getPropertyValue("height")), r = parseInt(t.getPropertyValue("padding") || 0), s = parseInt(t.getPropertyValue("border-width"));
      this.innerHeight = e - r * 2 - s * 2, this.offsetWidth = this.$refs.panel.offsetWidth + r, this.offsetHeight = this.$refs.panel.offsetHeight;
    }
  }
};
var Hn = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "panel", class: e.classes }, [r("div", { staticClass: "panel-header" }, [r("h2", { staticClass: "panel-header_title" }, [e._v(e._s(e.title))]), r("button", { staticClass: "panel-header_close", attrs: { "aria-label": `close ${e.title} panel` }, on: { click: e.onHide } }, [r("icon-close")], 1)]), r("div", { staticClass: "panel-content" }, [e._t("default"), r("div", { staticClass: "panel-footer" }, [r("div", { staticClass: "panel-footer_left" }, [e._t("footer")], 2), e.showBranding ? r("a", { staticClass: "panel-footer_simplecast", attrs: { href: e.linkTo, title: e.siteName, target: "_blank" } }, [e.smallPanel ? [e.customLogo && e.customLogo.logo ? r("img", { staticClass: "custom-logo", attrs: { src: e.isDark ? e.customLogo.logo_dark : e.customLogo.logo } }) : r("simplecast")] : [e.customLogo && e.customLogo.drawer_logo ? r("img", { staticClass: "custom-logo", attrs: { src: e.isDark ? e.customLogo.drawer_logo_dark : e.customLogo.drawer_logo } }) : r("simplecast-long")]], 2) : e._e()])], 2)]);
}, I2 = [];
Hn._withStripped = !0;
var jn = /* @__PURE__ */ B(
  B2,
  Hn,
  I2,
  !1,
  null,
  null,
  null,
  null
);
jn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Panel.vue";
const Kn = jn.exports;
const v2 = {
  components: {
    IconCopy: e2,
    IconDownload: s2,
    IconOpen: Mn,
    Twitter: c2,
    Facebook: f2,
    Linkedin: d2,
    Panel: Kn
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      urlCopied: !1
    };
  },
  computed: {
    podcast() {
      return this.store.state.podcast;
    },
    episode() {
      return this.store.state.episode;
    },
    mp3Url() {
      return this.podcast.allow_mp3_downloads ? this.store.state.episode.enclosure_url : !1;
    },
    episodeUrl() {
      return this.store.state.episode.custom_url && this.store.state.episode.custom_url !== "" ? this.store.state.episode.custom_url : this.store.state.episode.episode_url;
    },
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.episodeUrl
      )}`;
    },
    linkedInUrl() {
      let t = `${this.podcast.title} - ${this.episode.title}`, e = `Have you checked out ${this.podcast.title} yet? Listen here: ${this.episodeUrl}`;
      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        this.episodeUrl
      )}&title=${encodeURIComponent(t)}&summary=${encodeURIComponent(
        e
      )}&source=Simplecast`;
    },
    twitterUrl() {
      let t = `Have you listened to ${this.podcast.title} yet? Check it out here: ${this.episodeUrl}`;
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(t)}`;
    },
    hideMoreOptions() {
      return this.podcast.embed_customizations ? this.podcast.embed_customizations.hide_more_share_options : !1;
    }
  },
  watch: {
    urlCopied(t) {
      t && setTimeout(() => {
        this.urlCopied = !1;
      }, 2e3);
    }
  },
  methods: {
    onHide() {
      this.store.setShowShare(!1);
    },
    copied() {
      this.urlCopied = !0;
    }
  }
};
var Nn = function() {
  var e = this, r = e._self._c;
  return r("panel", { attrs: { "on-hide": e.onHide, store: e.store, title: "Share" } }, [r("template", { slot: "footer" }, [e.hideMoreOptions ? e._e() : r("a", { staticClass: "share-tools", attrs: { href: `${e.store.state.episode.episode_url}?share=true`, target: "simplecast-share", title: "More Sharing Options" }, on: { click: function(s) {
    return e.store.sendShareSubscribeEvent("share", " CLICK", "share");
  } } }, [e._v("More Options "), r("icon-open")], 1), e.mp3Url ? r("a", { class: ["share-mp3", { "no-margin": e.hideMoreOptions }], attrs: { href: e.mp3Url, target: "blank", title: "Download MP3" }, on: { click: function(s) {
    return e.store.sendShareSubscribeEvent("share", "DOWNLOAD", "mp3");
  } } }, [r("span", [e._v("Download\xA0")]), e._v("MP3 "), r("icon-download")], 1) : e._e()]), r("div", { staticClass: "share-links" }, [r("div", { class: ["share-url", { copied: e.urlCopied }] }, [r("div", { staticClass: "focusable" }, [r("input", { staticClass: "share-url_input", attrs: { title: "Episode URL", type: "text", readonly: "" }, domProps: { value: e.episodeUrl } })]), r("button", { directives: [{ name: "clipboard", rawName: "v-clipboard:copy", value: e.episodeUrl, expression: "episodeUrl", arg: "copy" }, { name: "clipboard", rawName: "v-clipboard:success", value: e.copied, expression: "copied", arg: "success" }], staticClass: "share-url_button", attrs: { "aria-label": "Copy Episode URL" }, on: { click: function(s) {
    return e.store.sendShareSubscribeEvent("share", "COPY", "url");
  } } }, [r("span", [e._v("Copy Link")]), e._v(" "), r("icon-copy")], 1)]), r("ul", { staticClass: "social-links" }, [r("li", { staticClass: "twitter" }, [r("a", { attrs: { href: e.twitterUrl, title: "Share on Twitter", target: "simplecast-share" } }, [r("twitter")], 1)]), r("li", { staticClass: "facebook" }, [r("a", { attrs: { href: e.facebookUrl, title: "Share on Facebook", target: "simplecast-share" } }, [r("facebook")], 1)]), r("li", { staticClass: "linkedin" }, [r("a", { attrs: { href: e.linkedInUrl, title: "Share on LinkedIn", target: "simplecast-share" } }, [r("linkedin")], 1)])])])], 2);
}, w2 = [];
Nn._withStripped = !0;
var Gn = /* @__PURE__ */ B(
  v2,
  Nn,
  w2,
  !1,
  null,
  null,
  null,
  null
);
Gn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/SharePanel.vue";
const Zn = Gn.exports, Q2 = {};
var Wn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 36 36", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("rect", { attrs: { id: "Rectangle-path", fill: "#FFA500", x: "0", y: "0", width: "36", height: "36", rx: "1.5" } }), r("circle", { attrs: { id: "Oval", fill: "#FFFFFF", cx: "8.79069767", cy: "27.2093023", r: "4.60465116" } }), r("path", { attrs: { d: "M4.18604651,17.7906977 C11.8152824,17.7906977 18,23.6942918 18,30.9767442 L22.6046512,30.9767442 C22.6046512,21.2668077 14.358361,13.3953488 4.18604651,13.3953488 L4.18604651,17.7906977 Z", id: "Shape", fill: "#FFFFFF" } }), r("path", { attrs: { d: "M4.18604651,8.65116279 C10.1071588,8.65116279 15.7857578,11.0033155 19.9726165,15.1901742 C24.1594752,19.3770329 26.5116279,25.0556319 26.5116279,30.9767442 L30.9767442,30.9767442 C30.9767442,16.1806504 18.9821403,4.18604651 4.18604651,4.18604651 L4.18604651,8.65116279 Z", id: "Shape", fill: "#FFFFFF" } })]);
}, S2 = [];
Wn._withStripped = !0;
var Vn = /* @__PURE__ */ B(
  Q2,
  Wn,
  S2,
  !1,
  null,
  null,
  null,
  null
);
Vn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/rss.vue";
const k2 = Vn.exports, y2 = {};
var Xn = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg" } }, [r("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [r("path", { attrs: { fill: "#FAB908", d: "M11 8v9h3V8z" } }), r("path", { attrs: { d: "M1.547 9.984a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 0-3.095", fill: "#0066D9" } }), r("path", { attrs: { d: "M1.547 11.672a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 0-3.095", fill: "#0066D9" } }), r("path", { attrs: { fill: "#0066D9", d: "M0 13.219h3.094V11.53H0z" } }), r("path", { attrs: { d: "M23.203 11.672a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 .001-3.095", fill: "#4285F4" } }), r("path", { attrs: { d: "M23.203 9.984a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 .001-3.095", fill: "#4285F4" } }), r("path", { attrs: { fill: "#4285F4", d: "M21.656 13.219h3.094V11.53h-3.094z" } }), r("path", { attrs: { d: "M6.89 15.047a1.547 1.547 0 1 1 0 3.093 1.547 1.547 0 0 1 0-3.093", fill: "#EA4335" } }), r("path", { attrs: { d: "M6.89 16.734a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094", fill: "#EA4335" } }), r("path", { attrs: { fill: "#EA4335", d: "M5.344 18.281h3.093v-1.687H5.345zM6.89 4.922a1.547 1.547 0 1 1 0 3.095 1.547 1.547 0 0 1 0-3.095M6.89 10.406a1.547 1.547 0 1 1 0 3.095 1.547 1.547 0 0 1 0-3.095" } }), r("path", { attrs: { fill: "#EA4335", d: "M5.344 11.988h3.093v-5.52H5.345z" } }), r("path", { attrs: { d: "M17.86 6.61a1.547 1.547 0 1 1-.002 3.094 1.547 1.547 0 0 1 .001-3.095", fill: "#34A853" } }), r("path", { attrs: { d: "M17.86 4.922a1.547 1.547 0 1 1-.002 3.095 1.547 1.547 0 0 1 .001-3.095", fill: "#34A853" } }), r("path", { attrs: { fill: "#34A853", d: "M16.313 8.156h3.093V6.47h-3.093z" } }), r("path", { attrs: { d: "M12.375 1.688a1.547 1.547 0 1 1-.001 3.094 1.547 1.547 0 0 1 .001-3.095", fill: "#FAB908" } }), r("path", { attrs: { d: "M12.375 0a1.547 1.547 0 1 1-.001 3.095A1.547 1.547 0 0 1 12.375 0", fill: "#FAB908" } }), r("path", { attrs: { fill: "#FAB908", d: "M10.828 3.234h3.094V1.547h-3.094zM12.375 21.656a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094" } }), r("path", { attrs: { d: "M12.375 19.969a1.547 1.547 0 1 1 0 3.093 1.547 1.547 0 0 1 0-3.093", fill: "#FAB908" } }), r("path", { attrs: { fill: "#FAB908", d: "M10.828 23.203h3.094v-1.687h-3.094z" } }), r("path", { attrs: { d: "M17.86 16.734a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094M17.86 11.25a1.547 1.547 0 1 1-.002 3.095 1.547 1.547 0 0 1 .001-3.095", fill: "#34A853" } }), r("path", { attrs: { fill: "#34A853", d: "M16.313 18.281h3.093v-5.484h-3.093z" } }), r("path", { attrs: { d: "M12.375 6.328a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 .001-3.095M12.375 15.328a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094", fill: "#FAB908" } })])]);
}, J2 = [];
Xn._withStripped = !0;
var qn = /* @__PURE__ */ B(
  y2,
  Xn,
  J2,
  !1,
  null,
  null,
  null,
  null
);
qn.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/google-podcasts.vue";
const x2 = qn.exports, b2 = {};
var $n = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 26 26", "xml:space": "preserve" } }, [r("linearGradient", { attrs: { id: "XMLID_2_", gradientUnits: "userSpaceOnUse", x1: "20.0983", y1: "7.4183", x2: "20.0983", y2: "32.5813" } }, [r("stop", { staticStyle: { "stop-color": "#f452ff" }, attrs: { offset: "0" } }), r("stop", { staticStyle: { "stop-color": "#832bc1" }, attrs: { offset: "1" } })], 1), r("g", { attrs: { transform: "translate(-7,-7)" } }, [r("path", { attrs: { id: "XMLID_662_", "fill-rule": "evenodd", "clip-rule": "evenodd", fill: "url(#XMLID_2_)", d: "M32.1821,29.2281 c-0.2446,0.6213-0.809,1.4961-1.6094,2.1123c-0.4621,0.3559-1.0138,0.6961-1.7716,0.9206 c-0.8078,0.2394-1.8028,0.3203-3.0412,0.3203H14.4366c-1.2383,0-2.2333-0.0809-3.0412-0.3203 c-0.7578-0.2245-1.3094-0.5647-1.7716-0.9206c-0.8003-0.6163-1.3648-1.491-1.6094-2.1123 c-0.4927-1.2518-0.4977-2.6721-0.4977-3.5666l0,0V14.3381l0,0c0-0.8945,0.005-2.3148,0.4977-3.5666 c0.2446-0.6213,0.809-1.4961,1.6094-2.1123c0.4621-0.3559,1.0138-0.6961,1.7716-0.9206c0.8078-0.2394,1.8028-0.3203,3.0412-0.3203 l0,0H25.76l0,0c1.2383,0,2.2333,0.0809,3.0412,0.3203c0.7578,0.2245,1.3094,0.5648,1.7716,0.9206 c0.8003,0.6163,1.3648,1.491,1.6094,2.1123c0.4927,1.2518,0.4977,2.6721,0.4977,3.5666v11.3234 C32.6798,26.5559,32.6748,27.9762,32.1821,29.2281z" } }), r("path", { attrs: { id: "XMLID_660_", "fill-rule": "evenodd", "clip-rule": "evenodd", fill: "none", d: "M32.1821,29.2281 c-0.2446,0.6213-0.809,1.4961-1.6094,2.1123c-0.4621,0.3559-1.0138,0.6961-1.7716,0.9206 c-0.8078,0.2394-1.8028,0.3203-3.0412,0.3203H14.4366c-1.2383,0-2.2333-0.0809-3.0412-0.3203 c-0.7578-0.2245-1.3094-0.5647-1.7716-0.9206c-0.8003-0.6163-1.3648-1.491-1.6094-2.1123 c-0.4927-1.2518-0.4977-2.6721-0.4977-3.5666l0,0V14.3381l0,0c0-0.8945,0.005-2.3148,0.4977-3.5666 c0.2446-0.6213,0.809-1.4961,1.6094-2.1123c0.4621-0.3559,1.0138-0.6961,1.7716-0.9206c0.8078-0.2394,1.8028-0.3203,3.0412-0.3203 l0,0H25.76l0,0c1.2383,0,2.2333,0.0809,3.0412,0.3203c0.7578,0.2245,1.3094,0.5648,1.7716,0.9206 c0.8003,0.6163,1.3648,1.491,1.6094,2.1123c0.4927,1.2518,0.4977,2.6721,0.4977,3.5666v11.3234 C32.6798,26.5559,32.6748,27.9762,32.1821,29.2281z" } }), r("path", { attrs: { fill: "#FFFFFF", d: "M21.9232,21.8815c-0.3776-0.3984-1.0408-0.6538-1.8237-0.6538c-0.783,0-1.4462,0.2554-1.8238,0.6538 c-0.197,0.2079-0.3012,0.421-0.334,0.7246c-0.0636,0.5879-0.0279,1.0941,0.041,1.9034c0.0656,0.7712,0.1902,1.7996,0.3528,2.847 c0.1157,0.7454,0.2097,1.1477,0.2953,1.4358c0.1388,0.4669,0.6575,0.8752,1.4687,0.8752c0.8111,0,1.3298-0.4084,1.4686-0.8752 c0.0856-0.2881,0.1796-0.6904,0.2953-1.4358c0.1626-1.0474,0.2872-2.0758,0.3528-2.847 c0.0689-0.8094,0.1046-1.3156,0.041-1.9034C22.2244,22.3026,22.1202,22.0894,21.9232,21.8815z M18.0421,18.3342 c0,1.1373,0.922,2.0593,2.0593,2.0593c1.1374,0,2.0594-0.922,2.0594-2.0593c0-1.1374-0.922-2.0594-2.0594-2.0594 C18.9641,16.2748,18.0421,17.1968,18.0421,18.3342z M20.0759,10.2072c-4.8163,0.0137-8.7628,3.921-8.8224,8.737 c-0.0484,3.9013,2.442,7.2385,5.9195,8.4617c0.0844,0.0297,0.1701-0.0404,0.1568-0.1289 c-0.0456-0.3029-0.0886-0.6073-0.1281-0.9066c-0.014-0.1058-0.0814-0.197-0.1791-0.2397 c-2.7486-1.2008-4.6679-3.9574-4.6371-7.1505c0.0404-4.1904,3.4622-7.6066,7.6526-7.6405c4.2839-0.0346,7.78,3.4402,7.78,7.7162 c0,3.1611-1.9109,5.8839-4.6381,7.0751c-0.0977,0.0427-0.1647,0.1342-0.1786,0.2399c-0.0395,0.2992-0.0825,0.6035-0.128,0.9061 c-0.0134,0.0885,0.0723,0.1586,0.1567,0.129c3.4443-1.2115,5.9202-4.4968,5.9202-8.35 C28.9501,14.1681,24.9668,10.1932,20.0759,10.2072z M19.916,14.2667c2.7303-0.1057,4.9851,2.0847,4.9851,4.7919 c0,1.3768-0.5833,2.6198-1.5156,3.4952c-0.0791,0.0742-0.1216,0.1796-0.1155,0.2879c0.0186,0.3293,0.0118,0.6493-0.0101,1.0107 c-0.0059,0.0963,0.1021,0.1578,0.1818,0.1035c1.5634-1.0684,2.5917-2.8649,2.5917-4.8973c0-3.3464-2.7874-6.0541-6.1623-5.9233 c-3.1364,0.1216-5.6527,2.7075-5.6929,5.8461c-0.0264,2.0642,1.0082,3.8929,2.5917,4.9747 c0.0795,0.0543,0.1872-0.0073,0.1813-0.1035c-0.022-0.3616-0.0287-0.6816-0.0102-1.0109 c0.0061-0.1082-0.0363-0.2136-0.1152-0.2877c-0.9614-0.9026-1.5518-2.1961-1.5142-3.6241 C15.3778,16.4169,17.4039,14.364,19.916,14.2667z" } })])], 1);
}, M2 = [];
$n._withStripped = !0;
var eo = /* @__PURE__ */ B(
  b2,
  $n,
  M2,
  !1,
  null,
  null,
  null,
  null
);
eo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/apple-podcasts.vue";
const T2 = eo.exports, R2 = {};
var to = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 28 21", xmlns: "http://www.w3.org/2000/svg" } }, [r("path", { attrs: { d: "M24.522 7.122c0 2.087-1.129 4.145-3.353 6.117a.516.516 0 0 1-.685-.773c1.994-1.767 3.005-3.565 3.005-5.344v-.025c0-1.444-.906-3.145-2.062-3.87a.516.516 0 1 1 .549-.875c1.45.911 2.546 2.951 2.546 4.745v.025zm-6.7 4.356a.516.516 0 0 1-.504-.9c1.194-.67 1.998-1.971 2.001-3.24a3.134 3.134 0 0 0-1.68-2.773.516.516 0 1 1 .48-.914 4.164 4.164 0 0 1 2.233 3.679v.016c-.007 1.628-1.022 3.287-2.53 4.132zM13.677 9.96a2.24 2.24 0 1 1 .002-4.481 2.24 2.24 0 0 1-.002 4.48zm-3.442 1.318a.516.516 0 0 1-.703.199c-1.508-.845-2.524-2.504-2.53-4.132V7.33a4.164 4.164 0 0 1 2.232-3.679.517.517 0 0 1 .48.914 3.134 3.134 0 0 0-1.68 2.772c.003 1.27.807 2.57 2.002 3.24.25.139.338.454.199.702zm-3.322 1.916a.515.515 0 0 1-.728.044c-2.225-1.972-3.353-4.03-3.353-6.117v-.025c0-1.794 1.095-3.834 2.546-4.745a.517.517 0 0 1 .549.875c-1.157.725-2.063 2.426-2.063 3.87v.025c0 1.779 1.011 3.577 3.005 5.344.214.19.233.516.044.729zM19.903 0c-2.582 0-4.89 1.368-6.226 3.367C12.34 1.368 10.033 0 7.45 0A7.449 7.449 0 0 0 0 7.45c0 2.611 1.654 4.493 3.381 6.235l6.755 6.386a.555.555 0 0 0 .936-.403v-4.976a2.61 2.61 0 0 1 2.605-2.609 2.61 2.61 0 0 1 2.605 2.61v4.975c0 .487.582.738.936.403l6.754-6.386c1.728-1.742 3.381-3.624 3.381-6.235A7.449 7.449 0 0 0 19.903 0z", fill: "#C6002B", "fill-rule": "evenodd" } })]);
}, L2 = [];
to._withStripped = !0;
var ro = /* @__PURE__ */ B(
  R2,
  to,
  L2,
  !1,
  null,
  null,
  null,
  null
);
ro.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/iheart.vue";
const U2 = ro.exports, D2 = {};
var so = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" } }, [r("path", { attrs: { d: "M18 36C8.025 36 0 27.975 0 18S8.025 0 18 0s18 8.025 18 18-8.025 18-18 18zm0-7.125l1.35-1.35L18 22.35l-1.35 5.175 1.35 1.35zm-1.725-.075l-.675 2.55 1.575-1.575-.9-.975zm3.45 0l-.9.9 1.575 1.575-.675-2.475zM21 33.45l-3-3-3 3c.975.15 1.95.3 3 .3s2.025-.075 3-.3zm-3-31.2C9.3 2.25 2.25 9.3 2.25 18c0 6.9 4.425 12.75 10.575 14.85L16.2 20.325c-.75-.525-1.2-1.425-1.2-2.4 0-1.65 1.35-3 3-3s3 1.35 3 3c0 .975-.45 1.8-1.2 2.4l3.375 12.525A15.673 15.673 0 0 0 33.75 18C33.75 9.3 26.7 2.25 18 2.25zM28.275 25.8c-.375.45-1.05.6-1.575.225-.525-.375-.6-1.05-.225-1.5 0 0 2.025-2.7 2.025-6.525s-2.025-6.525-2.025-6.525c-.375-.45-.3-1.125.225-1.5s1.2-.225 1.575.225c.15.15 2.475 3.225 2.475 7.8 0 4.575-2.325 7.65-2.475 7.8zM22.8 22.875c-.45-.45-.375-1.275.075-1.725 0 0 1.125-1.2 1.125-3.15s-1.125-3.075-1.125-3.15c-.45-.45-.45-1.2-.075-1.725.45-.525 1.125-.525 1.575-.075.075.075 1.875 1.95 1.875 4.95s-1.8 4.875-1.875 4.95c-.45.45-1.125.375-1.575-.075zm-9.6 0c-.45.45-1.125.525-1.575.075C11.55 22.8 9.75 21 9.75 18s1.8-4.8 1.875-4.95c.45-.45 1.2-.45 1.575.075.45.45.375 1.275-.075 1.725 0 .075-1.125 1.2-1.125 3.15s1.125 3.15 1.125 3.15c.45.45.525 1.2.075 1.725zm-3.9 3.15c-.525.375-1.2.225-1.575-.225-.15-.15-2.475-3.225-2.475-7.8 0-4.575 2.325-7.65 2.475-7.8.375-.45 1.05-.6 1.575-.225.525.375.6 1.05.225 1.5 0 0-2.025 2.7-2.025 6.525s2.025 6.525 2.025 6.525c.375.45.225 1.125-.225 1.5z", fill: "#FC7E0F", "fill-rule": "evenodd" } })]);
}, P2 = [];
so._withStripped = !0;
var io = /* @__PURE__ */ B(
  D2,
  so,
  P2,
  !1,
  null,
  null,
  null,
  null
);
io.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/overcast.vue";
const O2 = io.exports, _2 = {};
var no = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 16 16", "xml:space": "preserve" } }, [r("path", { attrs: { d: "M14.972 5.412C14.682 2.377 11.955 0 8.763 0H.999v16h4c.551 0 1-.448 1-1v-3h3a6.01 6.01 0 0 0 4.44-1.965 5.951 5.951 0 0 0 1.533-4.623z", fill: "#2196F3" } })]);
}, z2 = [];
no._withStripped = !0;
var oo = /* @__PURE__ */ B(
  _2,
  no,
  z2,
  !1,
  null,
  null,
  null,
  null
);
oo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/pandora.vue";
const F2 = oo.exports, Y2 = {};
var ao = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" } }, [r("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [r("path", { attrs: { d: "M17.977 36c9.928 0 17.977-8.049 17.977-17.977S27.904.047 17.977.047C8.049.047 0 8.095 0 18.023 0 27.951 8.049 36 17.977 36", fill: "#F44336" } }), r("path", { attrs: { d: "M18.385 11.299a7.072 7.072 0 0 0-7.086 7.086 7.087 7.087 0 0 0 6.753 7.08.32.32 0 0 0 .333-.32v-2.078a.326.326 0 0 0-.296-.32 4.373 4.373 0 1 1 4.66-4.658.324.324 0 0 0 .317.296h2.079a.32.32 0 0 0 .32-.334 7.086 7.086 0 0 0-7.08-6.752m-.306 16.083a9.002 9.002 0 0 1-8.695-8.997c-.001-4.941 4.06-9.002 9.001-9.001a9.002 9.002 0 0 1 8.997 8.695.32.32 0 0 0 .32.306h2.618a.32.32 0 0 0 .318-.329c-.174-6.618-5.593-11.928-12.253-11.928A12.243 12.243 0 0 0 6.128 18.385c0 6.66 5.311 12.08 11.928 12.253a.32.32 0 0 0 .33-.32V27.7a.318.318 0 0 0-.307-.318", fill: "#FFF" } })])]);
}, H2 = [];
ao._withStripped = !0;
var co = /* @__PURE__ */ B(
  Y2,
  ao,
  H2,
  !1,
  null,
  null,
  null,
  null
);
co.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/pocket-casts.vue";
const j2 = co.exports, K2 = {};
var lo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 502 502" } }, [r("path", { attrs: { d: "M227.63 2.67c20.98-1.39 42.17 2.9 61.28 11.56.29 24.26-.07 48.53.12 72.79 42.32-4.54 82.7-20.35 125.31-22.87 22.11-1.56 44.96 1.87 64.83 11.97-.31 137.28-.22 274.56-.05 411.84-24.6-11.94-52.95-14.05-79.77-10.6-39.11 5.26-76.69 19.21-116.22 21.84-22.53 2.07-45.47-2.1-66.04-11.43-.28-24.26.05-48.52-.11-72.78-35.73 3.56-69.94 15.41-105.4 20.55-23 3.46-47.12 4.55-69.57-2.53-6.13-1.52-11.84-4.25-17.77-6.35-.22-8.21-.31-16.42-.27-24.62.18-129.07-.21-258.15.19-387.22 3.73 1.19 7.41 2.54 11.03 4.03 19.55 7.23 40.78 8.04 61.38 6.83 44.26-4.29 86.41-21.44 131.06-23.01m-68.68 82.32c-20.41 4.34-40.69 10.17-61.63 11.29-.35 7.89-.48 15.79-.38 23.69.25 81.72-.21 163.43.23 245.15 16.23-1 32.18-4.49 47.97-8.23-.21-38.22-.22-76.45-.05-114.68 5.96-1.4 11.89-3.54 18.11-3.16 4.45 1.82 4.9 7.25 4.71 11.38.45 28.07-.29 56.16.21 84.23-.01 5.73 1.24 11.45 3.88 16.54 15.99-4.32 32.41-7.31 48.98-8.15-2.1-5.58-3.88-11.41-3.88-17.43-.39-29.85.12-59.71-.12-89.56-.25-7.44-.23-15.37-3.9-22.1-2.97-6.64-9.71-10.14-15.98-13.09 4.66-3.9 9.83-7.49 12.9-12.87 7.71-10.64 8.27-24.36 8.08-36.98-.38-17.16 1.29-34.76-3.61-51.46-2.55-8.08-8.75-14.88-16.85-17.59-12.8-4.46-26.05.36-38.67 3.02m200.26 59.18c-23.25 5.22-46.36 11.45-70.12 13.94-.22 89.28-.03 178.56-.09 267.84-8.68-3.25-17.36-6.61-26.5-8.41-14.51-3.83-29.64-2.37-44.46-2.52-.02 24.06-.19 48.12.08 72.18 12.81-6.85 25.05-14.74 36.8-23.28 11.46-8.28 22.53-17.48 30.66-29.17 1.49-2.45 2.97-5.04 3.35-7.92 16.07-1.75 31.87-5.19 47.75-8.15.92-36.14-.16-72.31.48-108.47 11.87-2.29 23.86-4.46 35.16-8.89 9.3-3.4 17.56-9.58 23.67-17.35 6.08-9.02 10.01-19.57 10.59-30.49 1-18.17.13-36.38.47-54.57-.14-12.3.71-24.92-3.11-36.81-1.75-6.67-6.46-12.3-12.07-16.11-10.04-5.27-21.93-3.88-32.66-1.82z", fill: "#ce262f" } }), r("path", { attrs: { d: "M158.95 84.99c12.62-2.66 25.87-7.48 38.67-3.02 8.1 2.71 14.3 9.51 16.85 17.59 4.9 16.7 3.23 34.3 3.61 51.46.19 12.62-.37 26.34-8.08 36.98-3.07 5.38-8.24 8.97-12.9 12.87 6.27 2.95 13.01 6.45 15.98 13.09 3.67 6.73 3.65 14.66 3.9 22.1.24 29.85-.27 59.71.12 89.56 0 6.02 1.78 11.85 3.88 17.43-16.57.84-32.99 3.83-48.98 8.15-2.64-5.09-3.89-10.81-3.88-16.54-.5-28.07.24-56.16-.21-84.23.19-4.13-.26-9.56-4.71-11.38-6.22-.38-12.15 1.76-18.11 3.16-.17 38.23-.16 76.46.05 114.68-15.79 3.74-31.74 7.23-47.97 8.23-.44-81.72.02-163.43-.23-245.15-.1-7.9.03-15.8.38-23.69 20.94-1.12 41.22-6.95 61.63-11.29m-14.07 45.05c.41 22.36-.35 44.73.46 67.09 5.06-.78 10.11-1.79 14.92-3.6 4.45-2.18 7.44-6.94 7.63-11.88.37-13.15.14-26.3.14-39.45-.44-4.79.61-10.21-2.13-14.49-6.99-2.01-14.25.8-21.02 2.33z", fill: "#fff" } }), r("path", { attrs: { d: "M144.88 130.04c6.77-1.53 14.03-4.34 21.02-2.33 2.74 4.28 1.69 9.7 2.13 14.49 0 13.15.23 26.3-.14 39.45-.19 4.94-3.18 9.7-7.63 11.88-4.81 1.81-9.86 2.82-14.92 3.6-.81-22.36-.05-44.73-.46-67.09z", fill: "#ce262f" } }), r("path", { attrs: { d: "M359.21 144.17c10.73-2.06 22.62-3.45 32.66 1.82 5.61 3.81 10.32 9.44 12.07 16.11 3.82 11.89 2.97 24.51 3.11 36.81-.34 18.19.53 36.4-.47 54.57-.58 10.92-4.51 21.47-10.59 30.49-6.11 7.77-14.37 13.95-23.67 17.35-11.3 4.43-23.29 6.6-35.16 8.89-.64 36.16.44 72.33-.48 108.47-15.88 2.96-31.68 6.4-47.75 8.15l.07-.88c.06-89.28-.13-178.56.09-267.84 23.76-2.49 46.87-8.72 70.12-13.94m-22.17 46.92c.04 25.01-.35 50.03.23 75.04 5.78-1.34 12.93-.75 17.14-5.75 3.63-3 3.81-8.15 3.65-12.43-.09-16.51.1-33.02-.1-49.53.53-3.71-.54-9.01-4.84-9.94-5.49-.52-10.81 1.37-16.08 2.61z", fill: "#fff" } }), r("path", { attrs: { d: "M337.04 191.09c5.27-1.24 10.59-3.13 16.08-2.61 4.3.93 5.37 6.23 4.84 9.94.2 16.51.01 33.02.1 49.53.16 4.28-.02 9.43-3.65 12.43-4.21 5-11.36 4.41-17.14 5.75-.58-25.01-.19-50.03-.23-75.04z", fill: "#ce262f" } }), r("path", { attrs: { d: "M218.04 415.02c14.82.15 29.95-1.31 44.46 2.52 9.14 1.8 17.82 5.16 26.5 8.41l-.07.88c-.38 2.88-1.86 5.47-3.35 7.92-8.13 11.69-19.2 20.89-30.66 29.17-11.75 8.54-23.99 16.43-36.8 23.28-.27-24.06-.1-48.12-.08-72.18z", fill: "#992326" } })]);
}, N2 = [];
lo._withStripped = !0;
var uo = /* @__PURE__ */ B(
  K2,
  lo,
  N2,
  !1,
  null,
  null,
  null,
  null
);
uo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/radiopublic.vue";
const G2 = uo.exports, Z2 = {};
var fo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" } }, [r("path", { attrs: { d: "M28.648 15.957c-5.803-3.445-15.373-3.762-20.912-2.081a1.683 1.683 0 1 1-.978-3.222c6.359-1.93 16.929-1.557 23.608 2.408a1.684 1.684 0 0 1-1.718 2.895zm-.19 5.104c-.407.66-1.271.868-1.93.462-4.838-2.973-12.214-3.835-17.937-2.097a1.405 1.405 0 0 1-1.752-.935 1.405 1.405 0 0 1 .936-1.75c6.538-1.984 14.665-1.024 20.22 2.39.66.407.868 1.271.463 1.93zm-2.203 4.901a1.121 1.121 0 0 1-1.543.374C20.486 23.752 15.165 23.169 8.9 24.6a1.121 1.121 0 1 1-.5-2.187c6.857-1.567 12.738-.893 17.483 2.006.529.324.695 1.015.372 1.543zM18 0C8.06 0 0 8.059 0 18c0 9.942 8.06 18 18 18 9.941 0 18-8.058 18-18 0-9.941-8.059-18-18-18z", fill: "#1ED760", "fill-rule": "evenodd" } })]);
}, W2 = [];
fo._withStripped = !0;
var Ao = /* @__PURE__ */ B(
  Z2,
  fo,
  W2,
  !1,
  null,
  null,
  null,
  null
);
Ao.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/spotify.vue";
const V2 = Ao.exports, X2 = {};
var ho = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 15" } }, [r("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [r("path", { attrs: { fill: "#DE822E", d: "M21.733 3.926h6.487V.038h-6.487z" } }), r("path", { attrs: { fill: "#F3C229", d: "M14.505 3.926h6.487V1.982h-6.487z" } }), r("path", { attrs: { fill: "#532455", d: "M7.277 3.926h6.488V.91H7.277z" } }), r("path", { attrs: { fill: "#3A8EBA", d: "M.021 3.926h6.515V2.869H.02z" } }), r("path", { attrs: { fill: "#B2352B", d: "M28.961 3.926h6.514V2.372h-6.514z" } }), r("path", { attrs: { fill: "#DE822E", d: "M21.733 13.578h6.487v-2.122h-6.487z" } }), r("path", { attrs: { fill: "#F3C229", d: "M14.505 14.999h6.487v-3.543h-6.487z" } }), r("path", { attrs: { fill: "#532455", d: "M7.277 13.578h6.488v-2.122H7.277z" } }), r("path", { attrs: { fill: "#3A8EBA", d: "M.021 14.4h6.515v-2.944H.02z" } }), r("path", { attrs: { fill: "#B2352B", d: "M28.961 12.613h6.515v-1.157H28.96z" } }), r("path", { attrs: { fill: "#0A0B09", d: "M5.857 10.175V6.32H4.405V5.207h4.26V6.32H7.198v3.855H5.857zm-3.927.042c-1.143 0-1.85-.518-1.879-.54l-.03-.023.392-1.209.06.058c.006.006.61.573 1.536.573.651 0 .739-.177.739-.35 0-.317-.426-.43-.919-.563C1.094 7.965.178 7.719.178 6.67c0-.98.704-1.519 1.984-1.519.85 0 1.626.398 1.93.991l.022.043-1.039.654-.028-.045c-.193-.31-.561-.502-.962-.502-.503 0-.503.227-.503.301 0 .282.406.394.876.525.755.21 1.694.47 1.694 1.56 0 1.004-.7 1.508-2.142 1.539h-.08zm7.44-.043h1.343V5.207H9.37v4.967zm3.5 0V6.32H11.42V5.207h4.259V6.32h-1.466v3.855h-1.341zm11.36 0v-1.91h-1.909v1.91H20.98V5.208h1.342v1.986h1.91V5.207h1.341v4.968H24.23zm-5.815.05c-1.704 0-2.643-.91-2.643-2.56 0-1.542 1.013-2.499 2.643-2.499 1.686 0 2.02.953 2.034.994l.013.04-1.045.648-.028-.046c-.003-.005-.312-.502-.974-.502-.857 0-1.274.446-1.274 1.364 0 .908.453 1.415 1.275 1.427h.016c.596 0 .963-.503.967-.508l.028-.04 1.036.633-.015.04c-.015.042-.397 1.008-2.033 1.008zM26.291 10.175V5.207h3.912v1.078h-2.57v.888h1.556v1.022h-1.556v.902h2.57v1.078h-3.912M33.188 7.645h-.99v-1.36h.99c.534 0 .794.221.794.677 0 .46-.26.683-.794.683zm1.214.809c.57-.306.86-.822.86-1.534 0-1.105-.737-1.713-2.074-1.713h-2.332v4.968h1.342V8.723h.883l.813 1.452h1.581l-1.073-1.721z" } })])]);
}, q2 = [];
ho._withStripped = !0;
var po = /* @__PURE__ */ B(
  X2,
  ho,
  q2,
  !1,
  null,
  null,
  null,
  null
);
po.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/stitcher.vue";
const $2 = po.exports, eu = {};
var go = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "56 56 200 88" } }, [r("g", { attrs: { id: "Logos" } }, [r("g", { attrs: { id: "Logo__x2013__Horizontal_1A_12_" } }, [r("path", { attrs: { d: "M95 96.8v4c0 .4-.4.8-.8.8h-5c-.2 0-.4.2-.4.4v21.2c0 .4-.4.8-.8.8h-4c-.4 0-.8-.4-.8-.8V102c0-.2-.2-.4-.4-.4h-5c-.4 0-.8-.4-.8-.8v-4c0-.4.4-.8.8-.8h16.4c.4 0 .8.4.8.8zm22-.8h-4c-.4 0-.8.4-.8.8v18.8c0 1.8-1.4 3.2-3.9 3.2-2.4 0-3.8-1.4-3.8-3.2V96.8c0-.4-.4-.8-.8-.8h-4c-.4 0-.8.4-.8.8v18.8c0 4.8 4 8.8 9.4 8.8 5.5 0 9.5-4 9.5-8.8V96.8c0-.4-.4-.8-.8-.8zm22.6 0h-4c-.4 0-.8.4-.8.8v15c0 .2-.3.3-.4.1l-5.5-15.2c-.1-.4-.4-.7-1-.7h-4.8c-.4 0-.8.4-.8.8v26.4c0 .4.4.8.8.8h4c.4 0 .8-.4.8-.8v-13.8c0-.2.3-.3.4-.1l5.4 14c.1.3.4.7 1.1.7h4.7c.4 0 .8-.4.8-.8V96.8c.1-.4-.3-.8-.7-.8zm20.7 22.4h-9.5c-.2 0-.4-.2-.4-.4v-4.8c0-.2.2-.4.4-.4h9c.4 0 .8-.4.8-.8v-4c0-.4-.4-.8-.8-.8h-9c-.2 0-.4-.2-.4-.4V102c0-.2.2-.4.4-.4h9.3c.4 0 .8-.4.8-.8v-4c0-.4-.4-.8-.8-.8h-14.5c-.4 0-.8.4-.8.8v26.4c0 .4.4.8.8.8h14.7c.4 0 .8-.4.8-.8v-4c0-.4-.4-.8-.8-.8zM256 59v62c0 1.7-1.3 3-3 3h-69v17c0 1.7-1.3 3-3 3H59c-1.7 0-3-1.3-3-3V79c0-1.7 1.3-3 3-3h119V59c0-1.7 1.3-3 3-3h72c1.7 0 3 1.3 3 3zm-78 23H62.5c-.3 0-.5.2-.5.5v55c0 .3.2.5.5.5h115c.3 0 .5-.2.5-.5V82zm35.8 17.4c0-.4-.4-.8-.8-.8h-3.4c-.2 0-.4-.2-.4-.4V81.8c0-.2.2-.4.4-.4h3c.4 0 .8-.4.8-.8v-3.8c0-.4-.4-.8-.8-.8h-12.4c-.4 0-.8.4-.8.8v3.8c0 .4.4.8.8.8h3c.2 0 .4.2.4.4v16.4c0 .2-.2.4-.4.4h-3.4c-.4 0-.8.4-.8.8v3.8c0 .4.4.8.8.8H213c.4 0 .8-.4.8-.8v-3.8zm22.4-22.6c0-.4-.4-.8-.8-.8h-4c-.4 0-.8.4-.8.8v15c0 .2-.3.3-.4.1l-5.5-15.2c-.1-.4-.4-.7-1-.7H219c-.4 0-.8.4-.8.8v26.4c0 .4.4.8.8.8h4c.4 0 .8-.4.8-.8V89.4c0-.2.3-.3.4-.1l5.4 14c.1.3.4.7 1.1.7h4.7c.4 0 .8-.4.8-.8V76.8z", fill: "#14d8cc", id: "Logo_2_" } })])])]);
}, tu = [];
go._withStripped = !0;
var Eo = /* @__PURE__ */ B(
  eu,
  go,
  tu,
  !1,
  null,
  null,
  null,
  null
);
Eo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/tune-in.vue";
const ru = Eo.exports, su = {};
var Co = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 176 115", fill: "none" } }, [r("path", { attrs: { fill: "#29AB70", d: "M175.312.71h-37.905v22.003h37.905V.71z" } }), r("path", { attrs: { fill: "url(#paint0_linear)", d: "M175.312 31.352h-37.905v22.003h37.905V31.352z" } }), r("path", { attrs: { fill: "url(#paint1_linear)", d: "M175.312 61.98h-37.905v22.002h37.905V61.98z" } }), r("path", { attrs: { fill: "url(#paint2_linear)", d: "M37.905 92.623H0v22.002h37.905V92.623z" } }), r("path", { attrs: { fill: "url(#paint3_linear)", d: "M83.702 92.623H45.797v22.002h37.905V92.623z" } }), r("path", { attrs: { fill: "url(#paint4_linear)", d: "M129.515 92.623H91.61v22.002h37.905V92.623z" } }), r("path", { attrs: { fill: "url(#paint5_linear)", d: "M175.312 92.623h-37.905v22.002h37.905V92.623z" } }), r("path", { attrs: { fill: "url(#paint6_linear)", d: "M129.515 61.98H91.61v22.002h37.905V61.98z" } }), r("path", { attrs: { fill: "url(#paint7_linear)", d: "M83.702 61.98H45.797v22.002h37.905V61.98z" } }), r("path", { attrs: { fill: "url(#paint8_linear)", d: "M83.702 31.352H45.797v22.003h37.905V31.352z" } }), r("defs", [r("linearGradient", { attrs: { id: "paint0_linear", x1: "158.825", x2: "153.945", y1: "56.24", y2: "28.443", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#2C8C9D" } }), r("stop", { attrs: { offset: ".04", "stop-color": "#298E9A" } }), r("stop", { attrs: { offset: ".39", "stop-color": "#129C83" } }), r("stop", { attrs: { offset: ".72", "stop-color": "#05A475" } }), r("stop", { attrs: { offset: "1", "stop-color": "#00A770" } })], 1), r("linearGradient", { attrs: { id: "paint1_linear", x1: "136.842", x2: "175.791", y1: "82.874", y2: "62.92", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#2839BA" } }), r("stop", { attrs: { offset: "1", "stop-color": "#148CB3" } })], 1), r("linearGradient", { attrs: { id: "paint2_linear", x2: "37.905", y1: "103.616", y2: "103.616", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#F6A500" } }), r("stop", { attrs: { offset: "1", "stop-color": "#F29100" } })], 1), r("linearGradient", { attrs: { id: "paint3_linear", x1: "45.797", x2: "83.702", y1: "103.616", y2: "103.616", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#F29100" } }), r("stop", { attrs: { offset: "1", "stop-color": "#D12F5F" } })], 1), r("linearGradient", { attrs: { id: "paint4_linear", x1: "91.61", x2: "129.515", y1: "103.616", y2: "103.616", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#B4197C" } }), r("stop", { attrs: { offset: "1", "stop-color": "#472EAD" } })], 1), r("linearGradient", { attrs: { id: "paint5_linear", x1: "137.407", x2: "175.312", y1: "103.616", y2: "103.616", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#2839BA" } }), r("stop", { attrs: { offset: "1", "stop-color": "#3072B7" } })], 1), r("linearGradient", { attrs: { id: "paint6_linear", x1: "90.114", x2: "130.961", y1: "78.926", y2: "66.919", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#B4197C" } }), r("stop", { attrs: { offset: "1", "stop-color": "#373AAC" } })], 1), r("linearGradient", { attrs: { id: "paint7_linear", x1: "44.469", x2: "84.995", y1: "65.639", y2: "80.462", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#FFCB00" } }), r("stop", { attrs: { offset: "1", "stop-color": "#D12F5F" } })], 1), r("linearGradient", { attrs: { id: "paint8_linear", x1: "49.003", x2: "80.342", y1: "27.89", y2: "56.968", gradientUnits: "userSpaceOnUse" } }, [r("stop", { attrs: { "stop-color": "#FFCF00" } }), r("stop", { attrs: { offset: "1", "stop-color": "#ED743B" } })], 1)], 1)]);
}, iu = [];
Co._withStripped = !0;
var mo = /* @__PURE__ */ B(
  su,
  Co,
  iu,
  !1,
  null,
  null,
  null,
  null
);
mo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/deezer.vue";
const nu = mo.exports, ou = {};
var Bo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" } }, [r("path", { attrs: { fill: "#fe5000", d: "M0 0h64v64H0z" } }), r("path", { attrs: { fill: "#fff", d: "M23.66 42.65v5.29H22v-.82a3.85 3.85 0 0 1-2.69.93c-2.05 0-3.19-1.06-3.19-3v-2.4h1.71v2.19a1.7 1.7 0 0 0 1.94 2c1.4 0 2.23-.67 2.23-2.35v-1.8Zm9-1.38v6.67h-1.75v-.68a4 4 0 0 1-2.67.79c-2.25 0-3.67-1-3.67-2.7s1.44-2.82 3.61-2.82a3.92 3.92 0 0 1 2.73.91v-2.17Zm-1.71 4c0-1-.82-1.51-2.32-1.51s-2.31.54-2.31 1.51.82 1.51 2.31 1.51 2.28-.52 2.28-1.49Zm10.15-.72v3.37h-1.61v-.85a4 4 0 0 1-3 1c-1.94 0-2.94-.58-2.94-1.7s1-1.6 3.21-1.71l2.69-.14c-.05-.48-.7-.72-2-.72a6 6 0 0 0-3.39.91v-1.47a8.11 8.11 0 0 1 3.52-.71c2.35 0 3.48.67 3.48 2.04Zm-1.57 1v-.08l-2.91.15c-.86.05-1.27.23-1.27.58s.39.53 1.41.53c1.67.07 2.73-.39 2.73-1.11ZM46 42.53a6.77 6.77 0 0 1 3.13.72v1.56a5.14 5.14 0 0 0-3.09-1c-1.52 0-2.33.49-2.33 1.44s.81 1.43 2.33 1.43a5.18 5.18 0 0 0 3.09-.95v1.55A6.65 6.65 0 0 1 46 48c-2.53 0-4-1.08-4-2.75s1.49-2.72 4-2.72Zm11.88.15L54 48.87a2.65 2.65 0 0 1-2.58 1.39h-.38V49h.24a1.4 1.4 0 0 0 1.5-.86l.11-.18-3.46-5.26h1.9l2.38 3.71 2.3-3.71h1.79ZM14.1 47.94H16l-4-6.67h-1.86l-4 6.67H8l.8-1.34h4.5Zm-4.51-2.7L11 42.79l1.45 2.45Zm14.61-22a6.91 6.91 0 1 0 6.91 6.9 6.9 6.9 0 0 0-6.91-6.93Zm10.26-9.47H24.6L37.06 37h9.86Z" } })]);
}, au = [];
Bo._withStripped = !0;
var Io = /* @__PURE__ */ B(
  ou,
  Bo,
  au,
  !1,
  null,
  null,
  null,
  null
);
Io.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/audacy.vue";
const cu = Io.exports, lu = {};
var vo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "fill-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2", "clip-rule": "evenodd", viewBox: "0 0 366 222" } }, [r("path", { attrs: { fill: "#030404", "fill-rule": "nonzero", d: "M229.456 100.275c10.96-9.234 13.791-28.6 11.547-31.394-2.231-2.772-21.39-5.165-33.084 3.116-1.8 1.272-1.491 3.025.506 2.784 6.588-.794 21.244-2.565 23.856.806 2.619 3.372-2.903 17.269-5.368 23.475-.75 1.879.853 2.635 2.543 1.213zM362.716 6.825C359.466 1.828 354.369 0 349.162 0c-8.021 0-12.571 3.775-15.824 11.7h-.219V2.844c-.213-.9-1.05-1.572-2.063-1.625l-10.778.003c-1.172 0-2.131.831-2.231 1.894l.019 57.937c0 1.113.922 2.006 2.084 2.081h11.572c1.241 0 2.244-.931 2.265-2.084V29.862c0-3.903.216-7.434 1.847-10.971 1.297-2.8 3.897-4.629 6.719-4.629 8.025 0 7.263 9.266 7.263 15.6v31.447c.125.991.996 1.76 2.072 1.825h11.64c1.15 0 2.097-.797 2.228-1.825V24.866c0-5.607 0-13.407-3.04-18.041zM247.584 178.556l-11.525-4.409c-4.628-1.766-7.731-3.378-9.303-4.85-1.572-1.472-2.365-3.478-2.365-6.028 0-6.363 4.722-9.55 14.184-9.55a55.24 55.24 0 0115.95 2.353c1.572.49 2.709.731 3.4.731 1.278 0 1.919-.881 1.919-2.644v-3.968c0-1.272-.247-2.225-.741-2.863-.491-.634-1.328-1.153-2.509-1.544-6.11-2.253-12.356-3.381-18.763-3.381-8.075 0-14.594 1.956-19.575 5.875-4.972 3.922-7.456 9.069-7.456 15.435 0 9.693 5.469 16.556 16.4 20.575l12.553 4.699c4.041 1.469 6.816 2.938 8.347 4.41 1.522 1.469 2.291 3.381 2.291 5.728 0 3.534-1.253 6.228-3.769 8.084-2.513 1.863-6.181 2.791-11.003 2.791-6.997 0-13.738-1.025-20.241-3.081-1.775-.588-3-.882-3.691-.882-1.184 0-1.778.882-1.778 2.644v4.116c0 1.275.232 2.206.666 2.79.447.585 1.256 1.132 2.441 1.619 6.597 2.744 14.034 4.113 22.303 4.113 8.665 0 15.609-2.057 20.831-6.169 5.222-4.119 7.831-9.65 7.831-16.613 0-4.893-1.278-8.884-3.84-11.975-2.563-3.087-6.747-5.753-12.557-8.006zM209.369 62.953c12.615-6.644 27.75-5.994 39.156-.075 1.4.731 2.731-.672 2.731-1.869v-8.747c-.112-1.181-.509-2.381-1.965-3.196-6.475-3.607-14.013-4.663-21.141-4.5l19.197-27.16c1.781-2.44 2.784-3.978 2.794-5.156V5.219c0-1.21-.954-2.063-2.135-2.063l-37.065.003c-1.141-.003-2.088.825-2.097 2.072v8.194c.009 1.231.959 2.069 2.14 2.069h19.372l-22.247 31.618c-1.353 2.025-1.378 4.297-1.378 5.632v8.306c0 1.206 1.35 2.581 2.638 1.903zM282.856 51.409c-8.797 0-8.693-14.825-8.693-21.759 0-6.931.521-18.05 8.796-18.05 3.56 0 6.072 1.556 7.332 5.5 1.462 4.544 1.672 10.281 1.672 15.066 0 7.29-.413 19.243-9.107 19.243zm0-51.409c-16.234 0-25.234 13.75-25.234 31.447 0 17.575 8.9 31.687 25.234 31.687 15.707 0 25.65-13.756 25.65-31.09 0-17.935-9.003-32.044-25.65-32.044zM284.644 115.337c-2.982 0-5.31.866-7.003 2.604-1.694 1.731-2.544 4.028-2.544 6.868 0 2.838.85 5.128 2.544 6.86 1.693 1.74 4.021 2.606 7.003 2.606 2.968 0 5.303-.866 7-2.606 1.693-1.732 2.537-4.022 2.537-6.86 0-2.84-.844-5.137-2.537-6.868-1.697-1.738-4.032-2.604-7-2.604zM289.394 145.559h-9.481c-2.138 0-3.21 1-3.21 2.988v69.775c0 2 1.072 2.997 3.21 2.997h9.481c2.14 0 3.212-.997 3.212-2.997v-69.775c0-1.988-1.072-2.988-3.212-2.988zM30.913 46.834c-1.779 3.079-4.61 4.975-7.757 4.975-4.29 0-6.809-3.2-6.809-7.937 0-9.325 8.559-11.019 16.662-11.019v2.372c0 4.266.104 7.819-2.096 11.609zm2.096-22.746c-6.497.712-14.987 1.184-21.062 3.79C4.922 30.841 0 36.884 0 45.769c0 11.372 7.334 17.059 16.769 17.059 7.962 0 12.315-1.837 18.468-7.953 2.029 2.875 2.697 4.269 6.422 7.291.835.44 1.907.393 2.647-.254l.025.022a461.21 461.21 0 018.591-7.265c.916-.732.75-1.913.034-2.91-2.043-2.765-4.228-5.015-4.228-10.147V24.566c0-7.232.522-13.866-4.922-18.841C39.509 1.697 32.381.275 26.931.275 16.269.275 4.372 4.163 1.878 17.031c-.262 1.369.756 2.088 1.675 2.291l10.86 1.15c1.012-.053 1.749-1.028 1.94-2.016.934-4.431 4.738-6.575 9.006-6.575 2.307 0 4.925.832 6.291 2.847 1.569 2.253 1.359 5.331 1.359 7.938v1.422zM93.184 142.403c-9.834 0-19.671 3.438-29.506 10.303-3.278-6.865-9.534-10.303-18.775-10.303-9.041 0-18.331 3.191-27.869 9.578l-.89-4.64c-.197-1.069-.572-1.794-1.119-2.185-.55-.384-1.322-.575-2.309-.575H6.159c-1.984 0-2.978.966-2.978 2.9v67.772c0 1.941.994 2.913 2.978 2.913h8.791c1.988 0 2.981-.972 2.981-2.913V160.4c6.953-4.256 14.203-6.388 21.757-6.388 4.071 0 7.049 1.16 8.94 3.482 1.888 2.328 2.831 5.906 2.831 10.74v47.019c0 1.941.991 2.913 2.982 2.913h8.79c1.988 0 2.985-.972 2.985-2.913v-52.531c0-.775-.05-1.497-.15-2.175 7.35-4.356 14.653-6.535 21.903-6.535 4.072 0 7.05 1.16 8.94 3.482 1.888 2.328 2.832 5.906 2.832 10.74v47.019c0 1.941.993 2.913 2.984 2.913h8.791c1.981 0 2.981-.972 2.981-2.913v-51.081c0-6.966-1.844-12.335-5.513-16.113-3.681-3.768-8.94-5.656-15.8-5.656zM194.238 145.559h-8.71c-1.972 0-2.953.972-2.953 2.903v54.282c-7.181 4.64-14.312 6.968-21.397 6.968-4.528 0-7.822-1.234-9.89-3.706-2.063-2.465-3.097-6.312-3.097-11.534v-46.01c0-1.931-.985-2.903-2.954-2.903h-8.706c-1.969 0-2.953.972-2.953 2.903v50.654c0 7.062 1.866 12.534 5.606 16.4 3.741 3.868 9.103 5.803 16.088 5.803 9.644 0 19.044-3.338 28.191-10.016l1.034 5.084c.194 1.063.566 1.791 1.109 2.182.535.381 1.3.581 2.288.581h6.344c1.968 0 2.95-.972 2.95-2.916v-67.772c0-1.931-.982-2.903-2.95-2.903zM363.784 206.703c-.406 0-1.165.147-2.275.444-4.862 1.397-9.415 2.09-13.671 2.09-8.2 0-14.201-2.115-17.991-6.346-3.8-4.225-5.697-10.863-5.697-19.913v-1.934c0-9.253 1.869-15.988 5.616-20.216 3.75-4.231 9.872-6.347 18.375-6.347 4.25 0 8.453.6 12.609 1.794 1.106.3 1.922.447 2.428.447 1.313 0 1.972-.994 1.972-2.985v-4.031c0-1.39-.231-2.381-.687-2.978-.457-.597-1.235-1.094-2.351-1.491-5.265-1.887-10.628-2.834-16.093-2.834-11.95 0-21.185 3.456-27.719 10.369-6.522 6.915-9.794 16.684-9.794 29.312 0 12.732 3.163 22.45 9.494 29.166 6.325 6.712 15.462 10.069 27.409 10.069 6.579 0 12.344-1.047 17.313-3.135 1.212-.493 2.028-1.047 2.428-1.64.406-.594.606-1.538.606-2.838v-4.022c0-1.99-.656-2.981-1.972-2.981zM62.456 63.134h11.335c1.206 0 2.184-.931 2.184-2.084l.003-30.7c0-6.706-.316-15.966 7.828-15.966 8.038 0 6.982 9.503 6.982 15.966l.012 30.703c0 1.113.894 2.006 2.034 2.081h11.319c1.206 0 2.181-.931 2.181-2.084v-30.7c0-3.294-.103-8.169 1.06-11.091 1.168-2.925 4.025-4.756 6.775-4.756 3.275 0 5.815 1.097 6.659 5 .531 2.316.319 8.409.319 10.847l.003 30.703c0 1.113.897 2.006 2.034 2.081H134.5c1.209 0 2.191-.931 2.191-2.084l.006-36.55c0-6.219.74-13.284-2.856-18.159C130.669 1.95 125.484 0 120.722 0c-6.663 0-12.9 3.416-15.653 10.725C101.897 3.416 97.45 0 90.363 0 83.384 0 78.2 3.416 75.453 10.725h-.215V3.166c-.069-1.06-.954-1.891-2.057-1.947l-10.556.003c-1.206 0-2.187.928-2.187 2.087l-.01 57.916c.091 1.034.95 1.841 2.028 1.909zM179.875 35.225c0 4.266.097 7.819-2.1 11.609-1.784 3.079-4.612 4.975-7.756 4.975-4.297 0-6.813-3.2-6.813-7.937 0-9.325 8.556-11.019 16.669-11.019v2.372zm0-11.137c-6.503.712-14.994 1.184-21.072 3.79-7.019 2.963-11.947 9.006-11.947 17.891 0 11.372 7.338 17.059 16.769 17.059 7.969 0 12.322-1.837 18.475-7.953 2.031 2.875 2.694 4.269 6.416 7.291.837.44 1.909.393 2.65-.254l.025.022a461.15 461.15 0 018.59-7.265c.916-.732.753-1.913.038-2.91-2.047-2.765-4.232-5.015-4.232-10.147V24.566c0-7.232.525-13.866-4.921-18.841-4.3-4.028-11.422-5.45-16.878-5.45-10.66 0-22.551 3.888-25.05 16.756-.26 1.369.756 2.088 1.674 2.291l10.86 1.15c1.009-.053 1.75-1.028 1.944-2.016.934-4.431 4.731-6.575 9-6.575 2.309 0 4.925.832 6.293 2.847 1.572 2.253 1.366 5.331 1.366 7.938v1.422z" } }), r("path", { attrs: { fill: "#030404", "fill-rule": "nonzero", d: "M51.738 72.547c25.034 21.728 58.121 34.778 94.865 34.778 26.219 0 56.663-7.916 77.666-22.809 3.472-2.469.5-6.163-3.056-4.716-23.541 9.597-49.125 14.237-72.404 14.237-34.503 0-67.906-9.096-94.921-24.203-2.366-1.318-4.119 1.01-2.15 2.713z" } })]);
}, uu = [];
vo._withStripped = !0;
var wo = /* @__PURE__ */ B(
  lu,
  vo,
  uu,
  !1,
  null,
  null,
  null,
  null
);
wo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/amazon-podcasts.vue";
const fu = wo.exports, Au = {};
var Qo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "fill-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2", "clip-rule": "evenodd", viewBox: "0 0 366 222" } }, [r("path", { attrs: { fill: "#ffffff", "fill-rule": "nonzero", d: "M229.456 100.275c10.96-9.234 13.791-28.6 11.547-31.394-2.231-2.772-21.39-5.165-33.084 3.116-1.8 1.272-1.491 3.025.506 2.784 6.588-.794 21.244-2.565 23.856.806 2.619 3.372-2.903 17.269-5.368 23.475-.75 1.879.853 2.635 2.543 1.213zM362.716 6.825C359.466 1.828 354.369 0 349.162 0c-8.021 0-12.571 3.775-15.824 11.7h-.219V2.844c-.213-.9-1.05-1.572-2.063-1.625l-10.778.003c-1.172 0-2.131.831-2.231 1.894l.019 57.937c0 1.113.922 2.006 2.084 2.081h11.572c1.241 0 2.244-.931 2.265-2.084V29.862c0-3.903.216-7.434 1.847-10.971 1.297-2.8 3.897-4.629 6.719-4.629 8.025 0 7.263 9.266 7.263 15.6v31.447c.125.991.996 1.76 2.072 1.825h11.64c1.15 0 2.097-.797 2.228-1.825V24.866c0-5.607 0-13.407-3.04-18.041zM247.584 178.556l-11.525-4.409c-4.628-1.766-7.731-3.378-9.303-4.85-1.572-1.472-2.365-3.478-2.365-6.028 0-6.363 4.722-9.55 14.184-9.55a55.24 55.24 0 0115.95 2.353c1.572.49 2.709.731 3.4.731 1.278 0 1.919-.881 1.919-2.644v-3.968c0-1.272-.247-2.225-.741-2.863-.491-.634-1.328-1.153-2.509-1.544-6.11-2.253-12.356-3.381-18.763-3.381-8.075 0-14.594 1.956-19.575 5.875-4.972 3.922-7.456 9.069-7.456 15.435 0 9.693 5.469 16.556 16.4 20.575l12.553 4.699c4.041 1.469 6.816 2.938 8.347 4.41 1.522 1.469 2.291 3.381 2.291 5.728 0 3.534-1.253 6.228-3.769 8.084-2.513 1.863-6.181 2.791-11.003 2.791-6.997 0-13.738-1.025-20.241-3.081-1.775-.588-3-.882-3.691-.882-1.184 0-1.778.882-1.778 2.644v4.116c0 1.275.232 2.206.666 2.79.447.585 1.256 1.132 2.441 1.619 6.597 2.744 14.034 4.113 22.303 4.113 8.665 0 15.609-2.057 20.831-6.169 5.222-4.119 7.831-9.65 7.831-16.613 0-4.893-1.278-8.884-3.84-11.975-2.563-3.087-6.747-5.753-12.557-8.006zM209.369 62.953c12.615-6.644 27.75-5.994 39.156-.075 1.4.731 2.731-.672 2.731-1.869v-8.747c-.112-1.181-.509-2.381-1.965-3.196-6.475-3.607-14.013-4.663-21.141-4.5l19.197-27.16c1.781-2.44 2.784-3.978 2.794-5.156V5.219c0-1.21-.954-2.063-2.135-2.063l-37.065.003c-1.141-.003-2.088.825-2.097 2.072v8.194c.009 1.231.959 2.069 2.14 2.069h19.372l-22.247 31.618c-1.353 2.025-1.378 4.297-1.378 5.632v8.306c0 1.206 1.35 2.581 2.638 1.903zM282.856 51.409c-8.797 0-8.693-14.825-8.693-21.759 0-6.931.521-18.05 8.796-18.05 3.56 0 6.072 1.556 7.332 5.5 1.462 4.544 1.672 10.281 1.672 15.066 0 7.29-.413 19.243-9.107 19.243zm0-51.409c-16.234 0-25.234 13.75-25.234 31.447 0 17.575 8.9 31.687 25.234 31.687 15.707 0 25.65-13.756 25.65-31.09 0-17.935-9.003-32.044-25.65-32.044zM284.644 115.337c-2.982 0-5.31.866-7.003 2.604-1.694 1.731-2.544 4.028-2.544 6.868 0 2.838.85 5.128 2.544 6.86 1.693 1.74 4.021 2.606 7.003 2.606 2.968 0 5.303-.866 7-2.606 1.693-1.732 2.537-4.022 2.537-6.86 0-2.84-.844-5.137-2.537-6.868-1.697-1.738-4.032-2.604-7-2.604zM289.394 145.559h-9.481c-2.138 0-3.21 1-3.21 2.988v69.775c0 2 1.072 2.997 3.21 2.997h9.481c2.14 0 3.212-.997 3.212-2.997v-69.775c0-1.988-1.072-2.988-3.212-2.988zM30.913 46.834c-1.779 3.079-4.61 4.975-7.757 4.975-4.29 0-6.809-3.2-6.809-7.937 0-9.325 8.559-11.019 16.662-11.019v2.372c0 4.266.104 7.819-2.096 11.609zm2.096-22.746c-6.497.712-14.987 1.184-21.062 3.79C4.922 30.841 0 36.884 0 45.769c0 11.372 7.334 17.059 16.769 17.059 7.962 0 12.315-1.837 18.468-7.953 2.029 2.875 2.697 4.269 6.422 7.291.835.44 1.907.393 2.647-.254l.025.022a461.21 461.21 0 018.591-7.265c.916-.732.75-1.913.034-2.91-2.043-2.765-4.228-5.015-4.228-10.147V24.566c0-7.232.522-13.866-4.922-18.841C39.509 1.697 32.381.275 26.931.275 16.269.275 4.372 4.163 1.878 17.031c-.262 1.369.756 2.088 1.675 2.291l10.86 1.15c1.012-.053 1.749-1.028 1.94-2.016.934-4.431 4.738-6.575 9.006-6.575 2.307 0 4.925.832 6.291 2.847 1.569 2.253 1.359 5.331 1.359 7.938v1.422zM93.184 142.403c-9.834 0-19.671 3.438-29.506 10.303-3.278-6.865-9.534-10.303-18.775-10.303-9.041 0-18.331 3.191-27.869 9.578l-.89-4.64c-.197-1.069-.572-1.794-1.119-2.185-.55-.384-1.322-.575-2.309-.575H6.159c-1.984 0-2.978.966-2.978 2.9v67.772c0 1.941.994 2.913 2.978 2.913h8.791c1.988 0 2.981-.972 2.981-2.913V160.4c6.953-4.256 14.203-6.388 21.757-6.388 4.071 0 7.049 1.16 8.94 3.482 1.888 2.328 2.831 5.906 2.831 10.74v47.019c0 1.941.991 2.913 2.982 2.913h8.79c1.988 0 2.985-.972 2.985-2.913v-52.531c0-.775-.05-1.497-.15-2.175 7.35-4.356 14.653-6.535 21.903-6.535 4.072 0 7.05 1.16 8.94 3.482 1.888 2.328 2.832 5.906 2.832 10.74v47.019c0 1.941.993 2.913 2.984 2.913h8.791c1.981 0 2.981-.972 2.981-2.913v-51.081c0-6.966-1.844-12.335-5.513-16.113-3.681-3.768-8.94-5.656-15.8-5.656zM194.238 145.559h-8.71c-1.972 0-2.953.972-2.953 2.903v54.282c-7.181 4.64-14.312 6.968-21.397 6.968-4.528 0-7.822-1.234-9.89-3.706-2.063-2.465-3.097-6.312-3.097-11.534v-46.01c0-1.931-.985-2.903-2.954-2.903h-8.706c-1.969 0-2.953.972-2.953 2.903v50.654c0 7.062 1.866 12.534 5.606 16.4 3.741 3.868 9.103 5.803 16.088 5.803 9.644 0 19.044-3.338 28.191-10.016l1.034 5.084c.194 1.063.566 1.791 1.109 2.182.535.381 1.3.581 2.288.581h6.344c1.968 0 2.95-.972 2.95-2.916v-67.772c0-1.931-.982-2.903-2.95-2.903zM363.784 206.703c-.406 0-1.165.147-2.275.444-4.862 1.397-9.415 2.09-13.671 2.09-8.2 0-14.201-2.115-17.991-6.346-3.8-4.225-5.697-10.863-5.697-19.913v-1.934c0-9.253 1.869-15.988 5.616-20.216 3.75-4.231 9.872-6.347 18.375-6.347 4.25 0 8.453.6 12.609 1.794 1.106.3 1.922.447 2.428.447 1.313 0 1.972-.994 1.972-2.985v-4.031c0-1.39-.231-2.381-.687-2.978-.457-.597-1.235-1.094-2.351-1.491-5.265-1.887-10.628-2.834-16.093-2.834-11.95 0-21.185 3.456-27.719 10.369-6.522 6.915-9.794 16.684-9.794 29.312 0 12.732 3.163 22.45 9.494 29.166 6.325 6.712 15.462 10.069 27.409 10.069 6.579 0 12.344-1.047 17.313-3.135 1.212-.493 2.028-1.047 2.428-1.64.406-.594.606-1.538.606-2.838v-4.022c0-1.99-.656-2.981-1.972-2.981zM62.456 63.134h11.335c1.206 0 2.184-.931 2.184-2.084l.003-30.7c0-6.706-.316-15.966 7.828-15.966 8.038 0 6.982 9.503 6.982 15.966l.012 30.703c0 1.113.894 2.006 2.034 2.081h11.319c1.206 0 2.181-.931 2.181-2.084v-30.7c0-3.294-.103-8.169 1.06-11.091 1.168-2.925 4.025-4.756 6.775-4.756 3.275 0 5.815 1.097 6.659 5 .531 2.316.319 8.409.319 10.847l.003 30.703c0 1.113.897 2.006 2.034 2.081H134.5c1.209 0 2.191-.931 2.191-2.084l.006-36.55c0-6.219.74-13.284-2.856-18.159C130.669 1.95 125.484 0 120.722 0c-6.663 0-12.9 3.416-15.653 10.725C101.897 3.416 97.45 0 90.363 0 83.384 0 78.2 3.416 75.453 10.725h-.215V3.166c-.069-1.06-.954-1.891-2.057-1.947l-10.556.003c-1.206 0-2.187.928-2.187 2.087l-.01 57.916c.091 1.034.95 1.841 2.028 1.909zM179.875 35.225c0 4.266.097 7.819-2.1 11.609-1.784 3.079-4.612 4.975-7.756 4.975-4.297 0-6.813-3.2-6.813-7.937 0-9.325 8.556-11.019 16.669-11.019v2.372zm0-11.137c-6.503.712-14.994 1.184-21.072 3.79-7.019 2.963-11.947 9.006-11.947 17.891 0 11.372 7.338 17.059 16.769 17.059 7.969 0 12.322-1.837 18.475-7.953 2.031 2.875 2.694 4.269 6.416 7.291.837.44 1.909.393 2.65-.254l.025.022a461.15 461.15 0 018.59-7.265c.916-.732.753-1.913.038-2.91-2.047-2.765-4.232-5.015-4.232-10.147V24.566c0-7.232.525-13.866-4.921-18.841-4.3-4.028-11.422-5.45-16.878-5.45-10.66 0-22.551 3.888-25.05 16.756-.26 1.369.756 2.088 1.674 2.291l10.86 1.15c1.009-.053 1.75-1.028 1.944-2.016.934-4.431 4.731-6.575 9-6.575 2.309 0 4.925.832 6.293 2.847 1.572 2.253 1.366 5.331 1.366 7.938v1.422z" } }), r("path", { attrs: { fill: "#ffffff", "fill-rule": "nonzero", d: "M51.738 72.547c25.034 21.728 58.121 34.778 94.865 34.778 26.219 0 56.663-7.916 77.666-22.809 3.472-2.469.5-6.163-3.056-4.716-23.541 9.597-49.125 14.237-72.404 14.237-34.503 0-67.906-9.096-94.921-24.203-2.366-1.318-4.119 1.01-2.15 2.713z" } })]);
}, hu = [];
Qo._withStripped = !0;
var So = /* @__PURE__ */ B(
  Au,
  Qo,
  hu,
  !1,
  null,
  null,
  null,
  null
);
So.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/amazon-dark-podcasts.vue";
const du = So.exports, pu = {};
var ko = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "fill-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2", "clip-rule": "evenodd", viewBox: "0 0 415 128" } }, [r("path", { attrs: { fill: "none", d: "M0 0h414.266v127.904H0z" } }), r("path", { attrs: { fill: "#e22b27", d: "M194.89 19.466h-6.35s-18.85 0-22.23 18.86l-4.43 25.19c-3.25 18.95 15.6 18.95 15.6 18.95h12.62l-1.21 6.36s-1.07 6.23-7.33 6.23h-21.48l-7.05 12.59h26.24s18.84 0 22.19-18.82l12.22-69.37h-18.79v.01zm2.86 18.86l-5.51 31.54h-12.61s-6.22 0-5.14-6.35l4.43-25.19s1.19-6.27 7.43-6.27h6.37c-.01 0 6.24 0 5.03 6.27zm130.98-18.86h-6.36l-8.83 50.33c-9.67-.53-7.74-6.28-7.74-6.28l7.81-44.05h-25.2c-18.96 0-22.31 18.86-22.31 18.86l-4.45 25.19c-.41 2.35-.45 4.41-.26 6.23-9.02-.83-8.14-6.23-8.14-6.23l7.78-44.05h-25.2c-18.95 0-22.3 18.86-22.3 18.86l-4.44 25.19c-3.27 18.95 15.73 18.95 15.73 18.95h6.23c4.65 0 8.61-3.59 11.15-6.97 4.66 8.7 17.95 6.97 17.95 6.97l2.03-9.36c3.37 9.33 15.19 9.36 15.19 9.36h6.22c4.7 0 8.66-3.59 11.18-6.97 3.47 5.64 8.12 6.74 16.53 6.91v.05h12.6l7.67-44.02s1.22-6.39 7.58-6.39h6.23s6.37 0 5.17 6.39l-7.69 44.02h12.6l7.79-44.4c3.26-18.84-15.69-18.6-15.69-18.6h-18.83v.01zm-88.08 44.05s-1.09 6.35-7.47 6.35h-6.24s-6.34 0-5.26-6.35l4.43-25.19s1.2-6.27 7.55-6.27h12.61l-5.62 31.46zm52.55 0s-1.05 6.35-7.42 6.35h-6.24s-6.37 0-5.29-6.35l4.46-25.19s1.19-6.27 7.55-6.27h12.59l-5.65 31.46zm112.22 0l7.79-44.05h-25.18c-18.97 0-22.34 18.86-22.34 18.86l-4.4 25.19c-3.28 18.95 15.7 18.95 15.7 18.95h6.26c4.68 0 8.63-3.59 11.16-6.97 4.3 6.97 14.04 6.97 14.04 6.97l2.15-12.61c-6.26.01-5.18-6.34-5.18-6.34zm-12.6 0s-1.07 6.35-7.44 6.35h-6.24s-6.36 0-5.28-6.35l4.48-25.19s1.17-6.27 7.53-6.27h12.57l-5.62 31.46zM127.35 121.756c0 3.1-2.52 5.62-5.63 5.62H5.77c-3.11 0-5.62-2.52-5.62-5.62V5.776c0-3.1 2.52-5.61 5.62-5.61h115.95c3.11 0 5.63 2.51 5.63 5.61v115.98z" } }), r("path", { attrs: { fill: "#fff", d: "M94.51 15.216H66.76s-20.74 0-24.44 20.74l-4.88 27.73c-3.57 20.88 17.18 20.88 17.18 20.88H68.5l-1.32 7s-1.19 6.88-8.08 6.88H35.45l-2.48 13.86h23.61s20.75 0 24.45-20.74l13.48-76.35zm-17.57 20.75l-6.09 34.73H57s-6.89 0-5.68-7l4.9-27.73s1.31-6.87 8.18-6.87h7s6.87 0 5.54 6.87z" } })]);
}, gu = [];
ko._withStripped = !0;
var yo = /* @__PURE__ */ B(
  pu,
  ko,
  gu,
  !1,
  null,
  null,
  null,
  null
);
yo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/gaana-podcasts.vue";
const Eu = yo.exports, Cu = {};
var Jo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "fill-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2", "clip-rule": "evenodd", viewBox: "0 0 1525 782" } }, [r("path", { attrs: { fill: "#2a2d36", "fill-rule": "nonzero", d: "M1511.66 112.553a166 166 0 00-99.156-99.175C1370.285.031 1331.066.031 1252.629.031h-236.5c-78.437 0-117.625 0-159.844 13.347a165.97 165.97 0 00-99.187 99.175 249.116 249.116 0 00-6.281 24.209 440.108 440.108 0 0143.781 77.672c1.156-29.887 3.969-53.818 10.812-75.44 14.625-40.191 37.125-62.685 77.313-77.313 36.812-11.637 80.156-11.637 148.562-11.637h206.219c68.375 0 111.75 0 148.563 11.637 40.187 14.628 62.656 37.122 77.281 77.313 11.656 36.809 11.656 80.165 11.656 148.556v206.216c0 68.39 0 111.746-11.656 148.556-14.625 40.187-37.094 62.681-77.281 77.306-36.813 11.644-80.188 11.644-148.563 11.644h-206.219c-68.406 0-111.75 0-148.562-11.644-40.188-14.625-62.688-37.119-77.313-77.306-6.843-21.638-9.656-45.585-10.812-75.494a440.196 440.196 0 01-43.781 77.678 233.573 233.573 0 006.281 24.26 165.948 165.948 0 0099.187 99.165c42.219 13.35 81.407 13.35 159.844 13.35h236.5c78.437 0 117.656 0 159.875-13.35a165.979 165.979 0 0099.156-99.165c13.344-42.219 13.344-81.432 13.344-159.86V272.409c0-78.431 0-117.643-13.344-159.856z" } }), r("path", { attrs: { fill: "#2a2d36", "fill-rule": "nonzero", d: "M951.062 678.175c-62.468 0-104.187-38.65-104.187-106.034v-6.982c0-2.818 2.219-13.403 12.781-11.353 63.25 19.478 131 39.113 180.531 104.653 5.657 8.016.719 19.678-9.093 19.716h-80.032zm123.094-13.453c-12.531-92.931-56.468-252.5-221.875-370.494-2.593-1.984-5.343-4.141-5.406-10.99v-75.851c0-83.415 56.281-104.115 82.375-104.115 5.188.15 9.656 1.337 12.75 6.575 78.875 171.984 128.031 280.809 158.438 540.115.156 5.057.937 7.479 4-.165 21.437-47.097 122.968-287.366 82.593-533.394-1.093-8.578 5.719-13.262 10.969-13.262h120.719c61.094 0 103.187 41.965 103.187 104.246v106.679c0 2.625-.718 7.437-6.469 10.521-187.031 97.472-257.281 256.716-282.187 341.416-2.469 6.9-3.906 12.172-11.625 12.172h-36.844c-7.406-.1-8.968-3.006-10.625-13.453zm244.563 13.453h-130.188c-5.531 0-18.218-8.716-8.219-20.822 66.751-71.737 150.094-96.678 229.375-123.197 10.376-3.075 12.219 7.835 12.219 10.86v27.125c0 61.053-42 106.034-103.187 106.034zM564.906 358.094c-26.937 0-48.781 23.106-48.781 51.562 0 28.485 21.844 51.563 48.781 51.563 26.969 0 48.782-23.078 48.782-51.563 0-28.456-21.813-51.562-48.782-51.562z" } }), r("path", { attrs: { fill: "#2a2d36", "fill-rule": "nonzero", d: "M564.906 530.959c-68.718 0-124.437-54.297-124.437-121.303 0-66.997 55.719-121.293 124.437-121.293 68.719 0 124.406 54.296 124.406 121.293 0 67.006-55.687 121.303-124.406 121.303zM416.594 233c0 20.237-16.625 36.844-36.844 36.844h-17.562c-20.313 0-36.907-16.585-36.907-36.844v-9.084c0-20.26 16.594-36.857 36.907-36.857h17.562c20.25 0 36.844 16.613 36.844 36.857V233zm0 255.525c0 20.622-16.906 37.525-37.5 37.525h-16.282c-20.625 0-37.531-16.903-37.531-37.525V331.403c0-20.594 16.906-37.475 37.531-37.475h16.282c20.594 0 37.5 16.881 37.5 37.475v157.122zm-118.563-75.738c0 199.46-317.937 111.525-189.031 9.163 30.156 41.844 88.063 39.062 94.219-2.238l1.156-162.675c2.969-41.612 83.906-49.843 93.656 0v155.75zM390.625 0C174.906 0 0 174.894 0 390.631c0 215.738 174.906 390.631 390.625 390.631 215.75 0 390.656-174.893 390.656-390.631C781.281 174.894 606.375 0 390.625 0z" } })]);
}, mu = [];
Jo._withStripped = !0;
var xo = /* @__PURE__ */ B(
  Cu,
  Jo,
  mu,
  !1,
  null,
  null,
  null,
  null
);
xo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/jiosaavn-podcasts.vue";
const Bu = xo.exports, Iu = {};
var bo = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "fill-rule": "evenodd", "stroke-linejoin": "round", "stroke-miterlimit": "2", "clip-rule": "evenodd", viewBox: "0 0 1525 782" } }, [r("path", { attrs: { fill: "#fff", "fill-rule": "nonzero", d: "M1511.66 112.553a166 166 0 00-99.156-99.175C1370.285.031 1331.066.031 1252.629.031h-236.5c-78.437 0-117.625 0-159.844 13.347a165.97 165.97 0 00-99.187 99.175 249.116 249.116 0 00-6.281 24.209 440.108 440.108 0 0143.781 77.672c1.156-29.887 3.969-53.818 10.812-75.44 14.625-40.191 37.125-62.685 77.313-77.313 36.812-11.637 80.156-11.637 148.562-11.637h206.219c68.375 0 111.75 0 148.563 11.637 40.187 14.628 62.656 37.122 77.281 77.313 11.656 36.809 11.656 80.165 11.656 148.556v206.216c0 68.39 0 111.746-11.656 148.556-14.625 40.187-37.094 62.681-77.281 77.306-36.813 11.644-80.188 11.644-148.563 11.644h-206.219c-68.406 0-111.75 0-148.562-11.644-40.188-14.625-62.688-37.119-77.313-77.306-6.843-21.638-9.656-45.585-10.812-75.494a440.196 440.196 0 01-43.781 77.678 233.573 233.573 0 006.281 24.26 165.948 165.948 0 0099.187 99.165c42.219 13.35 81.407 13.35 159.844 13.35h236.5c78.437 0 117.656 0 159.875-13.35a165.979 165.979 0 0099.156-99.165c13.344-42.219 13.344-81.432 13.344-159.86V272.409c0-78.431 0-117.643-13.344-159.856z" } }), r("path", { attrs: { fill: "#fff", "fill-rule": "nonzero", d: "M951.062 678.175c-62.468 0-104.187-38.65-104.187-106.034v-6.982c0-2.818 2.219-13.403 12.781-11.353 63.25 19.478 131 39.113 180.531 104.653 5.657 8.016.719 19.678-9.093 19.716h-80.032zm123.094-13.453c-12.531-92.931-56.468-252.5-221.875-370.494-2.593-1.984-5.343-4.141-5.406-10.99v-75.851c0-83.415 56.281-104.115 82.375-104.115 5.188.15 9.656 1.337 12.75 6.575 78.875 171.984 128.031 280.809 158.438 540.115.156 5.057.937 7.479 4-.165 21.437-47.097 122.968-287.366 82.593-533.394-1.093-8.578 5.719-13.262 10.969-13.262h120.719c61.094 0 103.187 41.965 103.187 104.246v106.679c0 2.625-.718 7.437-6.469 10.521-187.031 97.472-257.281 256.716-282.187 341.416-2.469 6.9-3.906 12.172-11.625 12.172h-36.844c-7.406-.1-8.968-3.006-10.625-13.453zm244.563 13.453h-130.188c-5.531 0-18.218-8.716-8.219-20.822 66.751-71.737 150.094-96.678 229.375-123.197 10.376-3.075 12.219 7.835 12.219 10.86v27.125c0 61.053-42 106.034-103.187 106.034zM564.906 358.094c-26.937 0-48.781 23.106-48.781 51.562 0 28.485 21.844 51.563 48.781 51.563 26.969 0 48.782-23.078 48.782-51.563 0-28.456-21.813-51.562-48.782-51.562z" } }), r("path", { attrs: { fill: "#fff", "fill-rule": "nonzero", d: "M564.906 530.959c-68.718 0-124.437-54.297-124.437-121.303 0-66.997 55.719-121.293 124.437-121.293 68.719 0 124.406 54.296 124.406 121.293 0 67.006-55.687 121.303-124.406 121.303zM416.594 233c0 20.237-16.625 36.844-36.844 36.844h-17.562c-20.313 0-36.907-16.585-36.907-36.844v-9.084c0-20.26 16.594-36.857 36.907-36.857h17.562c20.25 0 36.844 16.613 36.844 36.857V233zm0 255.525c0 20.622-16.906 37.525-37.5 37.525h-16.282c-20.625 0-37.531-16.903-37.531-37.525V331.403c0-20.594 16.906-37.475 37.531-37.475h16.282c20.594 0 37.5 16.881 37.5 37.475v157.122zm-118.563-75.738c0 199.46-317.937 111.525-189.031 9.163 30.156 41.844 88.063 39.062 94.219-2.238l1.156-162.675c2.969-41.612 83.906-49.843 93.656 0v155.75zM390.625 0C174.906 0 0 174.894 0 390.631c0 215.738 174.906 390.631 390.625 390.631 215.75 0 390.656-174.893 390.656-390.631C781.281 174.894 606.375 0 390.625 0z" } })]);
}, vu = [];
bo._withStripped = !0;
var Mo = /* @__PURE__ */ B(
  Iu,
  bo,
  vu,
  !1,
  null,
  null,
  null,
  null
);
Mo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/jiosaavn-dark-podcasts.vue";
const wu = Mo.exports, Qu = {};
var To = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", viewBox: "0 0 512 512" } }, [r("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [r("path", { attrs: { fill: "#D81422", d: "M0 0h512v512H0z" } }), r("image", { attrs: { width: "366", height: "366", x: "73", y: "73", "xlink:href": "data:image/png;base64,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" } })])]);
}, Su = [];
To._withStripped = !0;
var Ro = /* @__PURE__ */ B(
  Qu,
  To,
  Su,
  !1,
  null,
  null,
  null,
  null
);
Ro.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/playerfm-podcasts.vue";
const ku = Ro.exports;
const yu = {
  components: {
    Panel: Kn,
    IconOpen: Mn,
    IconRss: k2
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      channels: [
        {
          title: "Apple Podcasts",
          icon: T2
        },
        {
          title: "Spotify",
          icon: V2
        },
        {
          title: "Google Podcasts",
          icon: x2
        },
        {
          title: "Amazon Music and Audible",
          icon: fu,
          darkIcon: du
        },
        {
          title: "Pandora",
          icon: F2
        },
        {
          title: "Stitcher",
          icon: $2
        },
        {
          title: "iHeartRadio",
          icon: U2
        },
        {
          title: "Radio.com",
          altTitle: "Audacy",
          icon: cu
        },
        {
          title: "Deezer",
          icon: nu
        },
        {
          title: "Overcast",
          icon: O2
        },
        {
          title: "Pocketcast",
          icon: j2
        },
        {
          title: "PlayerFM",
          icon: ku
        },
        {
          title: "RadioPublic",
          icon: G2
        },
        {
          title: "Tune In",
          icon: ru
        },
        {
          title: "Gaana",
          icon: Eu
        },
        {
          title: "JioSaavn",
          icon: Bu,
          darkIcon: wu
        }
      ]
    };
  },
  computed: {
    channelsFiltered() {
      return this.channels.filter(
        (t) => this.getChannelUrl(t.title)
      );
    },
    hideItems() {
      const t = new URLSearchParams(window.location.search);
      return this.store.state.distributionChannels.length > 8 && !t.get("show");
    },
    isDark() {
      return this.store.state.isDark;
    },
    episodeUrl() {
      return this.store.state.episode.custom_url && this.store.state.episode.custom_url !== "" ? this.store.state.episode.custom_url : this.store.state.episode.episode_url;
    },
    itunesUrl() {
      return this.store.state.podcast.itunes_url && this.store.state.podcast.itunes_url !== "" ? this.store.state.podcast.itunes_url : !1;
    },
    rssUrl() {
      return this.store.state.podcast.external_feed_url && this.store.state.podcast.external_feed_url !== "" ? this.store.state.podcast.external_feed_url : this.store.state.podcast.feed_url && this.store.state.podcast.feed_url !== "" ? this.store.state.podcast.feed_url : !1;
    },
    size() {
      return this.store.state.size;
    }
  },
  methods: {
    onHide() {
      this.store.setShowSubscribe(!1);
    },
    getChannelUrl(t) {
      let e = this.store.state.distributionChannels && this.store.state.distributionChannels.find((r) => r.distribution_channel ? r.distribution_channel.name === t : r.name === t);
      return e && e.url;
    }
  }
};
var Lo = function() {
  var e = this, r = e._self._c;
  return r("panel", { attrs: { "on-hide": e.onHide, store: e.store, title: "Subscribe" } }, [r("template", { slot: "footer" }, [e.hideItems ? r("a", { staticClass: "subscribe-tools", attrs: { href: `${e.store.state.episode.episode_url}?subscribe=true`, target: "simplecast-share", title: "More Subscribe Options" }, on: { click: function(s) {
    return e.store.sendShareSubscribeEvent("share", " CLICK", "share");
  } } }, [e._v("More Options "), r("icon-open")], 1) : e._e()]), r("ul", { staticClass: "subscribe-links" }, [e._l(e.channelsFiltered, function(s) {
    return r("li", { key: s.title }, [r("a", { attrs: { href: e.getChannelUrl(s.title), title: s.altTitle ? s.altTitle : s.title, target: "simplecast" }, on: { click: function(i) {
      return e.store.sendShareSubscribeEvent(
        "subscribe",
        "SUBSCRIBE",
        s.title
      );
    } } }, [e.isDark && s.darkIcon ? r(s.darkIcon, { tag: "component" }) : r(s.icon, { tag: "component" })], 1)]);
  }), e.rssUrl ? r("li", [r("a", { attrs: { href: e.rssUrl, target: "simplecast", title: "RSS Link" }, on: { click: function(s) {
    return e.store.sendShareSubscribeEvent("subscribe", "SUBSCRIBE", "RSS Link");
  } } }, [r("IconRss")], 1)]) : e._e()], 2)], 2);
}, Ju = [];
Lo._withStripped = !0;
var Uo = /* @__PURE__ */ B(
  yu,
  Lo,
  Ju,
  !1,
  null,
  null,
  null,
  null
);
Uo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/SubscribePanel.vue";
const Do = Uo.exports, xu = {};
var Po = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { width: "12", height: "19", viewBox: "0 0 12 19", xmlns: "http://www.w3.org/2000/svg" } }, [r("path", { attrs: { d: "M11 17.408V7.592H9.026V6.5H12v11.998H0V6.501h3.023v1.09H1.001v9.817h9.998zm-8.272-12.7l-.705-.705L6.025 0l4.003 4.003-.71.71-2.793-2.797v10.515h-1V1.916L2.728 4.708z", "fill-rule": "nonzero" } })]);
}, bu = [];
Po._withStripped = !0;
var Oo = /* @__PURE__ */ B(
  xu,
  Po,
  bu,
  !1,
  null,
  null,
  null,
  null
);
Oo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/share-mini.vue";
const Mu = Oo.exports;
const Tu = {
  components: {
    Artwork: lt,
    IconClose: zn,
    IconLogo: $t,
    IconShare: Mu,
    MetaInfo: ut,
    Speed: er
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  computed: {
    episodeUrl() {
      return this.store.state.episode.episode_url + "?share=true";
    },
    showBranding() {
      return this.store.state.podcast.branding === "simplecast";
    },
    isDark() {
      return this.store.state.isDark;
    }
  },
  methods: {
    toggleSubscribe() {
      this.store.setShowSubscribe(!this.store.state.showSubscribe);
    }
  }
};
var _o = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "panel", class: [{ dark: e.isDark }, "subscribe-panel-mini"] }, [r("div", { staticClass: "artwork-meta" }, [r("Artwork", { attrs: { store: e.store } }), r("MetaInfo", { attrs: { store: e.store } }), r("Speed", { staticClass: "speed-mini", attrs: { store: e.store } }), r("a", { staticClass: "share", attrs: { href: e.episodeUrl, title: "Share Episode", target: "simplecast-share" } }, [r("icon-share")], 1), r("div", { staticClass: "subscribe-tiny-items" }, [r("a", { staticClass: "subscribe-close-btn", attrs: { href: "#", title: "Close player settings" }, on: { click: function(s) {
    return s.preventDefault(), e.toggleSubscribe.apply(null, arguments);
  } } }, [r("IconClose")], 1), e.showBranding ? r("IconLogo", { staticClass: "mini-logo" }) : e._e()], 1)], 1)]);
}, Ru = [];
_o._withStripped = !0;
var zo = /* @__PURE__ */ B(
  Tu,
  _o,
  Ru,
  !1,
  null,
  "ca11a0cb",
  null,
  null
);
zo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/ShareSubscribePanelMini.vue";
const Lu = zo.exports;
const Uu = {
  components: {
    Main: v0,
    ShareSubscribePanelMini: Lu,
    SharePanel: Zn,
    SubscribePanel: Do
  },
  props: {
    adFreeAudio: {
      type: String,
      default: ""
    },
    cacheBust: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: ""
    },
    dark: {
      type: Boolean,
      default: !1
    },
    episode: {
      type: Object,
      default: () => {
      }
    },
    width: {
      type: Number,
      default: 444
    },
    height: {
      type: Number,
      default: 200
    },
    hideShare: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: ""
    },
    podcast: {
      type: Object,
      default: () => {
      }
    },
    timejump: {
      type: Number,
      default: 0
    },
    websocket: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      store: new Qn()
    };
  },
  computed: {
    showShare() {
      return this.store.state.showShare;
    },
    showSubscribe() {
      return this.store.state.showSubscribe;
    },
    sizeMini() {
      return this.store.state.size === "size-mini";
    },
    scaledSize() {
      return !this.sizeMini && this.height < 200 ? this.height / 200 : 1;
    },
    scaledWidth() {
      if (!this.sizeMini && this.height < 200) {
        const t = this.width * this.scaledSize;
        return this.width / t * 100;
      }
      return 100;
    }
  },
  watch: {
    color(t) {
      this.store.setColor(t);
    },
    dark(t) {
      this.store.setIsDark(t), this.store.setColor("");
    },
    height(t) {
      this.store.setSize(t);
    },
    episode(t) {
      this.store.setEpisode(t), this.store.getEpisodeWaveform(t);
    },
    podcast(t) {
      this.store.setPodcast(t);
    }
  },
  created() {
    this.store.setAdFreeAudio(this.adFreeAudio), this.store.setCacheBust(this.cacheBust), this.store.setIsDark(this.dark), this.store.setHideShareSubscribeButtons(this.hideShare), this.store.setColor(this.color), this.store.setCurrentTime(this.timejump), this.store.setSize(this.height), this.store.setWebsocketPath(this.websocket), this.id !== "" ? this.store.getEpisode(this.id) : this.episode && this.podcast ? (this.store.setEpisode(this.episode), this.store.setPodcast(this.podcast), this.store.getEpisodeWaveform(this.episode), this.podcast.is_private !== !0 && this.store.getDistributionChannels(
      this.podcast.distribution_channels.href
    )) : (this.store.setIsLoaded(!0), console.error(
      "Either an episode ID needs to be set, or both an episode and podcast Object. You have not set either (\u256F\xB0\u25A1\xB0)\u256F\uFE35 \u253B\u2501\u253B"
    ));
  },
  mounted() {
    window.addEventListener("resize", this.resize), this.resize();
  },
  methods: {
    resize() {
      window.parent.postMessage(
        JSON.stringify({
          src: window.location.toString(),
          context: "iframe.resize",
          height: 200
        }),
        "*"
      );
    }
  }
};
var Fo = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "player", class: { "simplecast-player": !0, "standard-size": !e.sizeMini }, style: {
    transform: `scale(${e.scaledSize})`,
    width: `${e.scaledWidth}%`
  } }, [r("Main", { attrs: { store: e.store } }), r("transition", { attrs: { name: "fade" } }, [e.showShare && !e.sizeMini ? r("SharePanel", { attrs: { store: e.store } }) : e._e(), e.showSubscribe && !e.sizeMini ? r("SubscribePanel", { attrs: { store: e.store } }) : e._e(), e.showSubscribe && e.sizeMini ? r("ShareSubscribePanelMini", { attrs: { store: e.store } }) : e._e()], 1)], 1);
}, Du = [];
Fo._withStripped = !0;
var Yo = /* @__PURE__ */ B(
  Uu,
  Fo,
  Du,
  !1,
  null,
  "aefab004",
  null,
  null
);
Yo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Player.vue";
const Pu = Yo.exports, Ou = {};
var Ho = function() {
  var e = this, r = e._self._c;
  return r("svg", { attrs: { viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [r("path", { attrs: { d: "M0,6 L0,12 L4,12 L9,17 L9,1 L4,6 L0,6 L0,6 Z M13.5,9 C13.5,7.23 12.48,5.71 11,4.97 L11,13.02 C12.48,12.29 13.5,10.77 13.5,9 L13.5,9 Z M11,0.23 L11,2.29 C13.89,3.15 16,5.83 16,9 C16,12.17 13.89,14.85 11,15.71 L11,17.77 C15.01,16.86 18,13.28 18,9 C18,4.72 15.01,1.14 11,0.23 L11,0.23 Z" } })]);
}, _u = [];
Ho._withStripped = !0;
var jo = /* @__PURE__ */ B(
  Ou,
  Ho,
  _u,
  !1,
  null,
  null,
  null,
  null
);
jo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/assets/svg/speaker.vue";
const zu = jo.exports;
const Fu = {
  components: {
    IconSpeaker: zu
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      innerHeight: 0,
      innerWidth: 0,
      offsetHeight: 0,
      offsetWidth: 0
    };
  },
  computed: {
    smallText() {
      return this.offsetWidth < 350;
    },
    audio() {
      return this.store.state.audio;
    },
    currentTime() {
      return this.store.state.currentTime;
    },
    episode() {
      return this.store.state.episode;
    },
    episodes() {
      try {
        return this.store.state.podcast.episodes.collection;
      } catch {
        return [];
      }
    },
    isDark() {
      return this.store.state.isDark;
    },
    isPlaying() {
      return this.store.state.isPlaying;
    },
    tableStyles() {
      return {
        background: this.store.state.color
      };
    }
  },
  watch: {
    currentTime(t) {
      t >= this.audio.duration && this.playNextEpisode();
    }
  },
  created() {
    window.addEventListener("resize", this.setOffsets);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setOffsets);
  },
  mounted() {
    this.setOffsets(), setTimeout(this.setOffsets, 100);
  },
  methods: {
    setOffsets() {
      const t = window.getComputedStyle(this.$refs.episodes, null), e = parseInt(
        t.getPropertyValue("height").replace("px", "")
      ), r = parseInt(t.getPropertyValue("padding").replace("px", "")) || 0, s = parseInt(t.getPropertyValue("border-width").replace("px", "")) || 0;
      this.innerHeight = e - r * 2 - s * 2, this.offsetWidth = this.$refs.episodes.offsetWidth + r, this.offsetHeight = this.$refs.episodes.offsetHeight;
    },
    showEpNumber(t) {
      return t.type === "full" && t.number !== null || t.type !== "full";
    },
    getEpisodeNumber(t) {
      if (!t)
        return "";
      const e = this.store.state.podcast.type === "episodic" ? "" : `S${t.season_number}:`, r = t.type.charAt(0).toUpperCase(), s = t.type === "full" ? `E${t.number}` : r;
      return this.showEpNumber(t) ? e + s : e.replace(":", "");
    },
    playEpisodeTitle(t) {
      return t.id === this.episode.id && this.store.state.isPlaying ? `Pause Episode: ${t.title}` : `Play Episode: ${t.title}`;
    },
    playEpisode(t) {
      t.id === this.episode.id ? this.store.state.isPlaying ? this.audio.pause() : this.audio.play() : (this.store.state.isPlaying && (this.store.sendPlayEvent(), this.store.state.playStart = 0), this.store.setEpisode(t), this.store.getEpisodeWaveform(t), this.audio.play());
    },
    playNextEpisode() {
      for (let t = 0; t < this.episodes.length; t += 1)
        if (this.episodes[t].id === this.episode.id && this.episodes[t + 1]) {
          this.playEpisode(this.episodes[t + 1]), this.audio.play(), this.store.setPlaybackRate(this.store.state.currentRate);
          break;
        }
    },
    time(t) {
      return Qe.iso(t || 0);
    }
  }
};
var Ko = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "episodes", staticClass: "episodes", class: { dark: e.isDark, "small-text": e.smallText }, attrs: { "aria-label": "Episode Playlist" } }, [r("div", { staticClass: "episodes-list", style: e.tableStyles }, e._l(e.episodes, function(s, i) {
    return r("button", { key: i, staticClass: "episodes-list_item", class: { selected: s.enclosure_url === e.episode.enclosure_url }, attrs: { "aria-label": e.playEpisodeTitle(s) }, on: { click: function(a) {
      return e.playEpisode(s);
    } } }, [r("span", { staticClass: "number" }, [e._v(e._s(e.getEpisodeNumber(s)))]), r("span", { staticClass: "title" }, [r("div", { staticClass: "marquee" }, [e._v(e._s(s.title))])]), r("span", { staticClass: "duration" }, [s.enclosure_url === e.episode.enclosure_url && e.isPlaying ? r("IconSpeaker") : [e._v(" " + e._s(e.time(s.duration)) + " ")]], 2)]);
  }), 0)]);
}, Yu = [];
Ko._withStripped = !0;
var No = /* @__PURE__ */ B(
  Fu,
  Ko,
  Yu,
  !1,
  null,
  "5a7b0efb",
  null,
  null
);
No.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Episodes.vue";
const Hu = No.exports;
const ju = {
  components: {
    Artwork: lt,
    Audio: hs,
    Episodes: Hu,
    Forward: xs,
    Logo: Cs,
    MetaInfo: ut,
    PlayPause: Hs,
    Privacy: Ns,
    Rewind: Ls,
    Scrubber: hi,
    Share: gi,
    Subscribe: Ii,
    Speed: er,
    SubscribePanel: Do,
    SharePanel: Zn
  },
  props: {
    store: {
      type: Object,
      default: function() {
      }
    }
  },
  data() {
    return {
      main: !1,
      innerHeight: 0,
      innerWidth: 0,
      offsetHeight: 0,
      offsetWidth: 0
    };
  },
  computed: {
    artworkStyles() {
      return this.landscape ? {
        "flex-basis": `${this.innerHeight}px`,
        "max-width": `${this.innerHeight}px`
      } : !1;
    },
    showBranding() {
      return this.store.state.podcast.branding === "simplecast";
    },
    metaControlsStyles() {
      return this.landscape ? {
        "flex-basis": `calc(100% - ${this.innerHeight + 15}px)`,
        "max-width": `calc(100% - ${this.innerHeight + 15}px)`
      } : !1;
    },
    artSide() {
      return this.offsetHeight < 640 && this.offsetWidth >= 810 || this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth >= 1150 || this.offsetHeight >= 800 && this.offsetWidth >= 1280;
    },
    artEmbed() {
      return this.offsetHeight < 640 && this.offsetWidth < 810 && this.offsetWidth >= 600 || this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth >= 600 && this.offsetWidth < 1150 || this.offsetHeight >= 800 && this.offsetWidth >= 600 && this.offsetWidth < 1280;
    },
    metaArt() {
      return this.offsetHeight < 640 && this.offsetWidth < 600 || this.offsetHeight >= 640 && this.offsetHeight < 600 && this.offsetWidth >= 480;
    },
    artAbove() {
      return this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth < 480 || this.offsetHeight >= 800 && this.offsetWidth < 600;
    },
    card() {
      return this.offsetHeight < 640 && this.offsetWidth < 810 || this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth >= 480 && this.offsetWidth < 1150 || this.offsetHeight >= 800 && this.offsetWidth >= 600 && this.offsetWidth < 1280;
    },
    cardAlt() {
      return !!(this.card && this.offsetWidth < 600);
    },
    controlsAlt() {
      return this.offsetWidth < 480 || this.offsetWidth >= 1150 && this.offsetWidth < 1024 && this.offsetHeight >= 640 && this.offsetHeight < 800;
    },
    episodesAlt() {
      return this.offsetWidth < 480;
    },
    isDark() {
      return this.store.state.isDark;
    },
    landscape() {
      return this.offsetHeight < 640 && this.offsetWidth >= 810 || this.offsetHeight < 800 && this.offsetWidth >= 1150 || this.offsetWidth >= 1280;
    },
    playerStyles() {
      return {
        background: this.store.state.color
      };
    },
    playSmall() {
      return this.offsetWidth < 480 && this.offsetHeight < 800 || this.offsetWidth < 600 && this.offsetHeight >= 800;
    },
    portrait() {
      return this.offsetHeight >= 640 && this.offsetWidth < 480 || this.offsetHeight >= 800 && this.offsetWidth < 600;
    },
    showSubscribe() {
      return this.store.state.showSubscribe;
    },
    showShare() {
      return this.store.state.showShare;
    },
    hideShareSubscribeButtons() {
      return this.store.state.hideShareSubscribeButtons;
    },
    textExtraSmall() {
      return this.offsetWidth < 480 && this.offsetHeight < 640;
    },
    textLarge() {
      return this.offsetWidth >= 1920 && this.offsetHeight >= 640 || this.offsetWidth >= 1440 && this.offsetHeight >= 800;
    },
    textMedium() {
      return this.offsetWidth >= 810 && this.offsetWidth < 1920 && this.offsetHeight >= 640 && this.offsetHeight < 800 || this.offsetWidth >= 810 && this.offsetWidth < 1440 && this.offsetHeight >= 640;
    },
    textSmall() {
      return this.offsetWidth >= 480 && this.offsetHeight < 640 || this.offsetWidth < 810 && this.offsetHeight >= 640;
    }
  },
  created() {
    window.addEventListener("resize", this.setOffsets);
  },
  beforeDestroy() {
    window.removeEventListener("re10size", this.setOffsets);
  },
  mounted() {
    this.setOffsets();
  },
  methods: {
    setOffsets() {
      const t = window.getComputedStyle(this.$refs.main, null), e = parseInt(
        t.getPropertyValue("height").replace("px", "")
      ), r = 15, s = 2;
      this.innerHeight = e - r * 2 - s * 2, this.offsetWidth = this.$refs.main.offsetWidth + r, this.offsetHeight = this.$refs.main.offsetHeight;
    }
  }
};
var Go = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "main", staticClass: "main", class: {
    card: e.card,
    "card-alt": e.cardAlt,
    dark: e.isDark,
    "episodes-alt": e.episodesAlt,
    landscape: e.landscape,
    portrait: e.portrait,
    "text-large": e.textLarge,
    "text-medium": e.textMedium,
    "text-small": e.textSmall,
    "text-extra-small": e.textExtraSmall
  }, style: e.playerStyles }, [r("Audio", { attrs: { store: e.store } }), e.artSide ? r("Artwork", { staticClass: "artSide", style: e.artworkStyles, attrs: { store: e.store } }) : e._e(), r("div", { staticClass: "artwork-meta-controls", style: e.metaControlsStyles }, [r("div", { staticClass: "artwork-meta-controls-inner" }, [e.artEmbed ? r("Artwork", { staticClass: "artEmbed", style: e.artworkStyles, attrs: { store: e.store } }) : e._e(), r("div", { staticClass: "meta-controls" }, [e.artAbove ? r("Artwork", { staticClass: "artAbove", style: e.artworkStyles, attrs: { store: e.store } }) : e._e(), r("div", { class: [
    { "meta-controls-wrap": !0, hide: e.showSubscribe || e.showShare }
  ] }, [e.showBranding ? r("Logo", { attrs: { store: e.store } }) : e._e(), r("div", { staticClass: "meta-wrapper" }, [e.metaArt ? r("Artwork", { staticClass: "metaArt", style: e.artworkStyles, attrs: { store: e.store } }) : e._e(), r("MetaInfo", { attrs: { store: e.store } })], 1), r("div", { staticClass: "play-pause-controls" }, [r("PlayPause", { attrs: { store: e.store } }), r("div", { staticClass: "scrubber-controls" }, [r("Scrubber", { attrs: { store: e.store } }), r("div", { staticClass: "controls" }, [r("Speed", { attrs: { store: e.store } }), r("div", { staticClass: "middle" }, [r("Rewind", { attrs: { store: e.store } }), r("Forward", { attrs: { store: e.store } })], 1), r("div", { staticClass: "right" }, [e.hideShareSubscribeButtons ? e._e() : r("Privacy", { attrs: { store: e.store } }), e.hideShareSubscribeButtons ? e._e() : r("Share", { attrs: { store: e.store } }), e.hideShareSubscribeButtons ? e._e() : r("Subscribe", { attrs: { store: e.store } })], 1)], 1)], 1)], 1), r("transition", { attrs: { name: "fade" } }, [e.showShare ? r("SharePanel", { attrs: { store: e.store } }) : e._e(), e.showSubscribe ? r("SubscribePanel", { attrs: { store: e.store } }) : e._e()], 1)], 1)], 1)], 1), r("Episodes", { attrs: { store: e.store } })], 1)], 1);
}, Ku = [];
Go._withStripped = !0;
var Zo = /* @__PURE__ */ B(
  ju,
  Go,
  Ku,
  !1,
  null,
  "c1188c09",
  null,
  null
);
Zo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/PlaylistMain.vue";
const Nu = Zo.exports;
const Gu = {
  components: {
    Main: Nu
  },
  props: {
    color: {
      type: String,
      default: ""
    },
    dark: {
      type: Boolean,
      default: !1
    },
    hideShare: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: ""
    },
    websocket: {
      type: String,
      default: ""
    }
  },
  data() {
    return { store: new Qn() };
  },
  computed: {
    podcast() {
      return this.store.state.podcast;
    }
  },
  watch: {
    color(t) {
      this.store.setColor(t);
    },
    dark(t) {
      this.store.setIsDark(t), this.store.setColor("");
    }
  },
  created() {
    this.store.setIsDark(this.dark), this.store.setColor(this.color), this.store.setHideShareSubscribeButtons(this.hideShare), this.id !== "" ? this.store.getPlaylist(this.id) : (this.store.setIsLoaded(!0), console.error(
      "A show ID needs to be set. You have not set one (\u256F\xB0\u25A1\xB0)\u256F\uFE35 \u253B\u2501\u253B"
    ));
  }
};
var Wo = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "simplecast-playlist" }, [r("Main", { attrs: { store: e.store } })], 1);
}, Zu = [];
Wo._withStripped = !0;
var Vo = /* @__PURE__ */ B(
  Gu,
  Wo,
  Zu,
  !1,
  null,
  "8cef9671",
  null,
  null
);
Vo.options.__file = "/Users/sarahfrisk/Simplecast/simple-docker-compose/apps/audioplayer/src/components/Playlist.vue";
const Wu = Vo.exports, Xu = Pu, qu = Wu;
export {
  Xu as SimplecastPlayer,
  qu as SimplecastPlaylist
};
